{
  "common": {
    "retry": "Thử lại",
    "cancel": "Hủy",
    "back": "Quay lại",
    "more": "Thêm",
    "loading": "Đang tải",
    "language": "Ngôn ngữ",
    "poweredBy": "Vận hành bởi {{name}}",
    "appUpdate": {
      "title": "Đã có phiên bản mới",
      "subtitle": "Hãy lưu công việc đang làm, rồi tải lại để dùng phiên bản mới.",
      "reload": "Tải lại"
    },
    "brandLogoAlt": "OOD Core Business Platform",
    "copyright": "© {{year}} {{holder}}. Bảo lưu mọi quyền.",
    "delete": "Xóa",
    "close": "Đóng",
    "remove": "Bỏ",
    "appVersion": "Phiên bản {{version}}",
    "appVersionShort": "v{{version}}"
  },
  "status": {
    "synced": "Đã đồng bộ",
    "pending_other": "{{count}} mục chờ đồng bộ",
    "offlineHo": "Mất kết nối. Đơn hàng vẫn được lưu tại cửa hàng.",
    "storeUnreachable": "Không kết nối được máy chủ cửa hàng. Kiểm tra dây mạng hoặc Wi‑Fi.",
    "managerMode": "Quản lý"
  },
  "requiresHo": {
    "reason": "Chức năng này cần kết nối với văn phòng chính. Bạn vẫn có thể hoàn tất đơn hàng.",
    "membership": "Thành viên cần kết nối với văn phòng chính. Bạn vẫn có thể hoàn tất đơn hàng."
  },
  "keypad": {
    "backspace": "Xóa số cuối",
    "ok": "OK",
    "entry": {
      "amount": "Số tiền",
      "quantity": "Số lượng",
      "phone": "Số điện thoại"
    }
  },
  "login": {
    "title": "Đăng nhập",
    "staffCode": "Mã nhân viên",
    "password": "Mật khẩu",
    "submit": "Đăng nhập",
    "lockedTitle": "Máy đã khóa",
    "lockedHint": "Đăng nhập lại để tiếp tục, hoặc nhập mã nhân viên khác để đổi người dùng.",
    "logOff": "Đăng xuất",
    "sso": "Đăng nhập bằng {{name}}",
    "breakGlass": "Đăng nhập khẩn cấp bằng mã nhân viên và mật khẩu",
    "mfa": {
      "title": "Đăng nhập hai bước",
      "code": "Mã xác thực",
      "hint": "Mã 6 chữ số trong ứng dụng xác thực, hoặc một mã khôi phục của bạn."
    }
  },
  "businessDay": {
    "title": "Ngày kinh doanh",
    "close": "Đóng ngày kinh doanh",
    "openedAt": "Mở lúc {{time}}",
    "noneOpen": "Chưa có ngày kinh doanh nào mở. Ngày sẽ mở khi có đơn đầu tiên.",
    "closeBlocked": "Cần xử lý trước:",
    "closeBody": "Báo cáo ngày sẽ được chốt. Các đơn đã thanh toán nhưng đang giao vẫn có thể hoàn tất sau khi đóng ngày.",
    "printReport": "In báo cáo ngày",
    "printRunning": "In báo cáo ngày (tạm)",
    "printed": "Đã gửi báo cáo ngày tới {{printer}}.",
    "notPrinted": "Chưa cài máy in hóa đơn cho máy POS hoặc cửa hàng này.",
    "closedPrint": "Đã chốt ngày kinh doanh. Báo cáo ngày đang được in.",
    "endsAt": "Ngày kinh doanh này kết thúc lúc {{time}}; đơn sau giờ đó thuộc ngày tiếp theo.",
    "rolledOver": "Ngày kinh doanh này đã kết thúc lúc {{time}}. Đơn tiếp theo sẽ thuộc ngày mới.",
    "daysWaiting_one": "Còn {{count}} ngày kinh doanh trước chưa đóng.",
    "daysWaiting_other": "Còn {{count}} ngày kinh doanh trước chưa đóng.",
    "toClose": "Ngày cần đóng",
    "status": {
      "open": "Đang bán",
      "closing": "Chờ đóng"
    },
    "closeWarnings": "Vẫn có thể đóng ngày:",
    "closeDay": "Đóng ngày kinh doanh {{date}}"
  },
  "errors": {
    "shifts.business_day_already_open": "Ngày kinh doanh đã được mở.",
    "shifts.business_date_already_used": "Ngày kinh doanh này đã được sử dụng.",
    "shifts.business_day_close_blocked": "Chưa thể đóng ngày kinh doanh.",
    "shifts.open_shifts_other": "Còn {{count}} ca đang mở",
    "sync.ho_unavailable": "Không kết nối được văn phòng chính. Bạn vẫn có thể hoàn tất đơn hàng.",
    "unknown": "Yêu cầu chưa được gửi. Kiểm tra kết nối rồi bấm Thử lại.",
    "import.file_invalid": "Tệp không phải sổ tính Excel (.xlsx) hoặc lớn hơn 10 MB.",
    "import.brand_not_found": "Không tìm thấy thương hiệu.",
    "identity.invalid_credentials": "Mã nhân viên hoặc mật khẩu không đúng.",
    "identity.user_inactive": "Tài khoản đã bị khóa hoặc vô hiệu hóa. Liên hệ quản lý hoặc văn phòng chính.",
    "identity.no_access_at_store": "Bạn không có quyền tại cửa hàng này. Liên hệ quản lý.",
    "identity.too_many_attempts": "Nhập sai quá nhiều lần. Vui lòng chờ vài phút rồi thử lại.",
    "identity.session_ended": "Phiên làm việc đã kết thúc. Vui lòng đăng nhập lại.",
    "identity.approver_invalid_credentials": "Mã nhân viên hoặc mật khẩu của quản lý không đúng.",
    "identity.approver_not_permitted": "Quản lý này không có quyền duyệt thao tác này.",
    "identity.approver_is_requester": "Cần một người khác duyệt thao tác này.",
    "too_many_requests": "Thử quá nhiều lần. Vui lòng chờ một phút rồi thử lại.",
    "common.version_conflict": "Bản ghi đã được người khác thay đổi. Đóng biểu mẫu, tải lại rồi thử lại.",
    "common.version_required": "Thiếu phiên bản của bản ghi. Tải lại rồi thử lại.",
    "common.duplicate": "Đã có bản ghi với mã này.",
    "common.not_found": "Bản ghi không còn tồn tại.",
    "validation.failed": "Kiểm tra các trường được đánh dấu.",
    "identity.no_ho_access": "Bạn không có vai trò tại văn phòng chính. Liên hệ quản trị viên.",
    "common.parent_not_found": "Không tìm thấy bản ghi cha.",
    "common.invalid_combination": "Một số giá trị không phù hợp với nhau. Kiểm tra các trường rồi thử lại.",
    "common.reference_invalid": "Bản ghi liên kết không tồn tại.",
    "sync.store_not_paired": "Cửa hàng này chưa được kết nối với văn phòng chính. Hãy kết nối trong trang quản trị cửa hàng.",
    "sync.store_not_found": "Không tìm thấy cửa hàng.",
    "sync.invalid_ip": "Chỉ nhập địa chỉ IP hoặc dải mạng, ví dụ 203.0.113.10 hoặc 203.0.113.0/28.",
    "sync.pairing_code_invalid": "Mã ghép nối không đúng hoặc đã hết hạn. Hãy xin văn phòng chính mã mới.",
    "sync.ip_not_allowed": "Văn phòng chính không nhận kết nối từ địa chỉ internet của cửa hàng này. Hãy nhờ văn phòng chính thêm địa chỉ.",
    "sync.store_key_invalid": "Khóa kết nối văn phòng chính của cửa hàng không còn hợp lệ. Hãy ghép nối lại bằng mã mới.",
    "sync.ho_unreachable": "Không kết nối được văn phòng chính tại địa chỉ này. Hãy kiểm tra địa chỉ và kết nối internet của cửa hàng.",
    "sync.ho_url_invalid": "Nhập địa chỉ đồng bộ của văn phòng chính, ví dụ https://sync.example.com.",
    "sync.paired_to_other_store": "Máy chủ cửa hàng này đang giữ dữ liệu của một cửa hàng khác. Không thể ghép nối với cửa hàng khác.",
    "sync.change_failed": "Không áp dụng được một thay đổi từ văn phòng chính. Bộ phận hỗ trợ có thể xem chi tiết.",
    "kitchen.store_required": "Hãy chọn cửa hàng trước.",
    "kitchen.ticket_not_found": "Phiếu bếp này không tồn tại.",
    "kitchen.no_printer": "Trạm này chưa có máy in.",
    "kitchen.item_not_found": "Món này không tồn tại.",
    "printing.job_superseded": "Lệnh này đã được in ở máy in dự phòng nên không thể thử lại.",
    "printing.job_not_failed": "Chỉ có thể thử lại lệnh in bị lỗi.",
    "printing.job_not_found": "Lệnh in này không tồn tại.",
    "printing.device_inactive": "Máy in này đang tắt.",
    "printing.device_not_found": "Máy in này không tồn tại.",
    "printing.not_a_printer": "Thiết bị này không phải máy in.",
    "payments.no_open_shift": "Hãy mở ca trước khi nhận thanh toán.",
    "ordering.open_orders_one": "Còn {{count}} đơn đang mở",
    "ordering.open_orders_other": "Còn {{count}} đơn đang mở",
    "ordering.open_orders_carried_one": "Còn {{count}} đơn chưa thanh toán, vẫn mở và chuyển sang ngày hôm sau",
    "ordering.open_orders_carried_other": "Còn {{count}} đơn chưa thanh toán, vẫn mở và chuyển sang ngày hôm sau",
    "ordering.unfulfilled_orders_one": "Còn {{count}} đơn đã thanh toán chưa giao",
    "ordering.unfulfilled_orders_other": "Còn {{count}} đơn đã thanh toán chưa giao",
    "ordering.scheduled_orders_one": "Còn {{count}} đơn chưa thanh toán đặt cho ngày sau, sẽ chờ đến ngày đó",
    "ordering.scheduled_orders_other": "Còn {{count}} đơn chưa thanh toán đặt cho ngày sau, sẽ chờ đến ngày đó",
    "shifts.off": "Cửa hàng này không dùng ca.",
    "shifts.already_open": "Đang có ca mở. Hãy đóng ca đó trước khi mở ca tiếp theo.",
    "shifts.not_found": "Không tìm thấy ca.",
    "shifts.not_open": "Ca đã đóng.",
    "shifts.changed": "Ca vừa được thay đổi ở máy khác. Hãy tải lại và thử lại.",
    "shifts.amount_invalid": "Nhập số tiền từ 0 trở lên.",
    "shifts.movement_type_invalid": "Chọn thu tiền, chi tiền hoặc nộp két.",
    "shifts.reason_required": "Chọn lý do hoặc ghi rõ lý do.",
    "shifts.terminal_required": "Cửa hàng kiểm đếm tiền theo từng máy: hãy thực hiện trên máy bán hàng.",
    "shifts.counts_required": "Hãy đếm tiền trong mọi ngăn kéo trước khi đóng ca.",
    "shifts.no_open_business_day": "Hãy mở ngày kinh doanh trước.",
    "shifts.window_invalid": "Giờ kết thúc ca phải khác giờ bắt đầu.",
    "shifts.days_required": "Chọn ít nhất một ngày cho ca.",
    "promotions.code_unknown": "Mã này không tồn tại. Hãy kiểm tra lại.",
    "promotions.code_not_active": "Mã này hiện không dùng được: chưa đến hạn, đã hết hạn hoặc đã bị hủy.",
    "promotions.code_used_up": "Mã này đã được dùng hết số lần cho phép.",
    "promotions.not_eligible": "Không dùng được mã này cho đơn hàng.",
    "promotions.not_stackable": "Không thể dùng mã này cùng với mã đã có trên đơn.",
    "promotions.too_many_attempts": "Cửa hàng đã nhập sai mã quá nhiều lần. Hãy chờ vài phút rồi thử lại.",
    "promotions.line_required": "Mã này áp dụng cho một món: hãy chọn món trước.",
    "ordering.coupon_code_invalid": "Mã gồm 4 đến 32 chữ cái và chữ số.",
    "ordering.coupon_already_applied": "Mã này đã có trên đơn.",
    "ordering.coupon_excluded_by_deal": "Combo trên đơn này không dùng chung được với mã giảm giá.",
    "payments.redemption_excluded_by_deal": "Combo trên đơn này không thanh toán được bằng điểm hoặc phiếu quà tặng.",
    "vouchers.code_unknown": "Phiếu này không tồn tại. Hãy kiểm tra lại mã.",
    "vouchers.not_active": "Phiếu này không dùng được: chưa đến hạn, đã hết hạn, đã dùng hết hoặc đã bị hủy.",
    "vouchers.no_balance": "Phiếu này không còn giá trị để dùng lúc này.",
    "vouchers.wrong_currency": "Phiếu này dùng loại tiền khác.",
    "vouchers.too_many_attempts": "Cửa hàng đã nhập sai mã quá nhiều lần. Hãy chờ vài phút rồi thử lại.",
    "payments.voucher_code_required": "Hãy nhập hoặc quét mã phiếu.",
    "vouchers.not_eligible": "Không dùng được phiếu này cho đơn hàng.",
    "config.template_invalid": "Mẫu in có lỗi. Xem vị trí lỗi ở phần xem trước.",
    "config.template_type_not_supported": "Cửa hàng chỉ in theo mẫu cho hóa đơn, phiếu tạm tính, phiếu bếp và báo cáo ca.",
    "config.template_footer_only_bills": "Chân trang chỉ dùng cho phiếu tạm tính hoặc hóa đơn. Hãy dùng mẫu in cho chứng từ khác.",
    "config.template_in_use": "Mẫu in này đang được dùng. Hãy bỏ các nơi áp dụng trước.",
    "config.template_assignment_type": "Nơi áp dụng phải cùng loại chứng từ với mẫu in.",
    "config.template_assignment_brand": "Mẫu in của một thương hiệu chỉ dùng được cho thương hiệu đó và các cửa hàng của nó.",
    "catalog.default_exists": "Đã có một mục khác là mặc định. Hãy bỏ mặc định ở đó trước.",
    "catalog.text_option_name": "Nhập nội dung tùy chọn, tối đa 200 ký tự.",
    "catalog.text_option_no_defaults": "Hãy đặt một nhóm thuế và một đơn vị tính làm mặc định trước (Danh mục › Nhóm thuế và Đơn vị tính): tùy chọn dạng chữ dùng chúng.",
    "catalog.text_option_group": "Không tìm thấy nhóm tùy chọn.",
    "catalog.text_option_group_brand": "Tùy chọn phải cùng thương hiệu với nhóm tùy chọn.",
    "shifts.clocked_in_one": "Còn {{count}} nhân viên chưa chấm công ra: đóng ngày sẽ chấm ra cho họ",
    "shifts.clocked_in_other": "Còn {{count}} nhân viên chưa chấm công ra: đóng ngày sẽ chấm ra cho họ",
    "shifts.not_clocked_in": "Bạn chưa chấm công vào.",
    "shifts.count_too_late": "Một ca sau đã được đóng nên không thể đếm tiền ca này nữa. Hãy đóng ca mà không đếm.",
    "identity.sso_failed": "Không đăng nhập được bằng tài khoản công ty. Hãy thử lại hoặc liên hệ bộ phận IT.",
    "identity.sso_no_staff": "Tài khoản công ty của bạn chưa gắn với nhân viên nào ở trụ sở. Hãy nhờ bộ phận IT thêm bạn.",
    "identity.sso_code_invalid": "Lượt đăng nhập này đã hết hạn. Hãy đăng nhập lại.",
    "identity.sso_not_set_up": "Công ty này không đăng nhập bằng tài khoản riêng.",
    "identity.use_sso": "Công ty của bạn đăng nhập bằng tài khoản riêng. Hãy dùng nút đăng nhập đó.",
    "common.mfa_required": "Thao tác này cần đăng nhập hai bước. Hãy thiết lập ứng dụng xác thực rồi đăng nhập lại."
  },
  "apps": {
    "kds": {
      "empty": "Chưa có phiếu. Đơn mới sẽ hiện ở đây khi được gửi xuống bếp."
    }
  },
  "approval": {
    "title": "Quản lý duyệt",
    "hint": "Quản lý nhập mã nhân viên và mật khẩu để duyệt.",
    "approve": "Duyệt",
    "reason": "Lý do"
  },
  "admin": {
    "typeToSearch": "Gõ để tìm",
    "chooseFirst": "Hãy chọn {{field}} trước",
    "fixedOnEdit": "Không đổi được sau khi tạo. Muốn chuyển, hãy xóa rồi thêm lại.",
    "search": "Tìm kiếm",
    "create": "Tạo mới",
    "edit": "Sửa",
    "save": "Lưu",
    "delete": "Xóa",
    "actions": "Thao tác",
    "deleteConfirm": "Xóa bản ghi này?",
    "empty": "Chưa có dữ liệu. Bấm Tạo mới để thêm.",
    "emptyTitle": "Chưa có bản ghi",
    "noResultsTitle": "Không có kết quả",
    "noResultsHint": "Thử tìm kiếm khác hoặc đổi bộ lọc.",
    "retry": "Thử lại",
    "rowAction": "{{action}} \"{{record}}\"",
    "required": "(bắt buộc)",
    "optional": "(không bắt buộc)",
    "saving": "Đang lưu…",
    "datePlaceholder": "yyyy-mm-dd",
    "quickFilter": {
      "all": "Tất cả"
    },
    "validation": {
      "required": "Vui lòng nhập mục này."
    },
    "overview": {
      "hoHint": "Tình trạng kết nối và bán hàng của các cửa hàng.",
      "storeHint": "Kết nối của cửa hàng với trụ sở và doanh số hôm nay.",
      "asOf": "Tính đến {{time}}",
      "refresh": "Làm mới",
      "empty": "Chưa có gì để hiển thị.",
      "noAccessTitle": "Chưa có gì để hiển thị",
      "noAccess": "Vai trò của bạn không có mục tổng quan nào. Hãy dùng menu bên trái.",
      "chart": {
        "view": "Hiển thị dạng",
        "chart": "Biểu đồ",
        "table": "Bảng"
      },
      "lag": {
        "label": "Chỉ tính đơn đã hoàn tất, có thể chậm",
        "about": "Về các số liệu này",
        "help": "Trụ sở chỉ tính một đơn sau khi cửa hàng hoàn tất và đồng bộ đơn đó. Số liệu có thể chậm vài phút so với cửa hàng, và lâu hơn khi cửa hàng mất kết nối."
      },
      "fleet": {
        "title": "Hệ thống cửa hàng",
        "online": "Trực tuyến",
        "offline": "Ngoại tuyến",
        "neverConnected": "Chưa từng kết nối",
        "total": "Cửa hàng"
      },
      "problems": {
        "title": "Sự cố đồng bộ",
        "empty": "Không cửa hàng nào gặp sự cố đồng bộ.",
        "detail": "Hàng đợi {{outbox}}, lỗi {{failed}}, đã dừng {{dead}}, xung đột {{conflicts}}",
        "open": "Mở kết nối của {{store}}"
      },
      "sales": {
        "title": "Doanh số hôm nay",
        "orders": "Số đơn",
        "netSales": "Doanh thu thuần",
        "averageTicket": "Giá trị đơn trung bình",
        "openOrders": "Đơn đang mở",
        "empty": "Hôm nay chưa có đơn hoàn tất.",
        "byHour": "Doanh số theo giờ",
        "hour": "Giờ",
        "day": "Ngày",
        "seriesName": "Doanh thu thuần",
        "summary": "Doanh thu thuần theo {{unit}}, tổng {{total}}, cao nhất {{peak}}"
      },
      "month": {
        "revenue": "Doanh thu từng ngày trong tháng này",
        "orders": "Số đơn hoàn tất từng ngày trong tháng này",
        "ordersSeries": "Đơn hoàn tất",
        "ordersSummary": "Đơn hoàn tất theo {{unit}}, tổng {{total}}, nhiều nhất {{peak}}"
      },
      "status": {
        "title": "Đơn theo trạng thái",
        "status": "Trạng thái",
        "count": "Số đơn",
        "empty": "Hôm nay chưa có đơn nào."
      },
      "payments": {
        "title": "Thanh toán theo nhà cung cấp",
        "provider": "Nhà cung cấp",
        "method": "Hình thức",
        "count": "Số giao dịch",
        "paid": "Đã thu",
        "refunded": "Đã hoàn",
        "empty": "Chưa có thanh toán nào."
      },
      "deliveries": {
        "title": "Giao hàng thất bại",
        "provider": "Nhà cung cấp",
        "total": "Số đơn giao",
        "failed": "Thất bại",
        "empty": "Không có đơn giao thất bại.",
        "own": "Tài xế riêng"
      },
      "link": {
        "title": "Kết nối với trụ sở",
        "connected": "Đã kết nối với trụ sở.",
        "offline": "Đang làm việc ngoại tuyến. Đơn hàng và thanh toán không bị ảnh hưởng.",
        "reason": "Lý do: {{reason}}",
        "lastContact": "Liên lạc gần nhất {{time}}",
        "waiting": "{{count}} tin nhắn đang chờ đồng bộ",
        "manage": "Kết nối với trụ sở"
      },
      "day": {
        "title": "Ngày kinh doanh",
        "open": "Đang mở từ {{time}}",
        "date": "Ngày kinh doanh {{date}}",
        "closed": "Chưa mở ngày kinh doanh.",
        "closedHint": "Ngày sẽ mở khi có đơn đầu tiên ở POS."
      },
      "biz": {
        "period": "Kỳ",
        "periods": {
          "today": "Hôm nay",
          "7d": "7 ngày qua",
          "month": "Tháng này",
          "30d": "30 ngày qua"
        },
        "kpis": "Số liệu chính",
        "netSales": "Doanh số",
        "vsPrevious": "so với kỳ trước",
        "ofSales": "{{share}} tiền hàng",
        "openReport": "Mở báo cáo",
        "thisPeriod": "Kỳ này",
        "previousPeriod": "Kỳ trước",
        "trend": "Xu hướng doanh số",
        "trendToday": "Doanh số theo giờ hôm nay",
        "trendSummary": "Doanh số trong kỳ, tổng {{total}}, so với kỳ trước",
        "channels": "Doanh số theo kênh",
        "channel": "Kênh",
        "share": "Tỷ trọng",
        "channelsSummary": "Doanh số chia theo {{count}} kênh",
        "payments": "Thanh toán",
        "method": "Phương thức thanh toán",
        "net": "Thực thu",
        "paymentsSummary": "Thanh toán chia theo {{count}} phương thức",
        "topItems": "10 món bán chạy",
        "item": "Món",
        "topItemsSummary": "Mười món có doanh số cao nhất, dẫn đầu là {{name}}",
        "stores": "Cửa hàng theo doanh số",
        "change": "Thay đổi",
        "storesSummary": "Cửa hàng xếp theo doanh số, dẫn đầu là {{name}}",
        "busyHours": "Giờ cao điểm",
        "busyHoursSummary": "Doanh số theo thứ và giờ; ô càng đậm càng đông khách",
        "noSales": "Không có doanh số trong kỳ này",
        "noPayments": "Không có thanh toán trong kỳ này"
      },
      "members": {
        "title": "Hội viên",
        "members": "Hội viên",
        "asOf": "Đếm lúc {{time}}",
        "newMembers": "Hội viên mới",
        "newToday": "Hội viên mới hôm nay",
        "pointsHeld": "Điểm hội viên đang có",
        "trend": "Hội viên mới mỗi ngày",
        "noneJoined": "Không có ai tham gia trong kỳ này và kỳ trước",
        "trendSummary_one": "{{total}} hội viên mới trong kỳ này",
        "trendSummary_other": "{{total}} hội viên mới trong kỳ này",
        "byTier": "Hội viên theo hạng",
        "noMembers": "Chưa có hội viên",
        "tier": "Hạng",
        "noTier": "Chưa có hạng",
        "byTierSummary": "Hạng đông nhất là {{name}}"
      }
    },
    "errors": {
      "forbidden": "Bạn không có quyền thực hiện thao tác này. Liên hệ quản trị viên.",
      "forbiddenTitle": "Không có quyền truy cập",
      "notFound": "Trang này không tồn tại."
    },
    "fields": {
      "code": "Mã",
      "name": "Tên",
      "codeHelper": "Chữ, số, - hoặc _. Lưu dạng chữ in hoa.",
      "updatedAt": "Cập nhật lần cuối"
    },
    "kitchen": {
      "addition": "Gọi thêm",
      "fallback": "Đã in ở máy in dự phòng",
      "store": "Cửa hàng",
      "storePlaceholder": "Chọn cửa hàng",
      "columns": {
        "ticket": "Phiếu",
        "store": "Cửa hàng",
        "station": "Trạm bếp",
        "order": "Đơn hàng",
        "label": "Bàn hoặc nhãn",
        "saleType": "Loại bán hàng",
        "items": "Số món",
        "addition": "Gọi thêm",
        "status": "Trạng thái",
        "printStatus": "In",
        "firedAt": "Gửi lúc"
      },
      "filters": {
        "station": "Trạm bếp",
        "status": "Trạng thái",
        "printStatus": "Trạng thái in",
        "store": "Cửa hàng",
        "firedAt": "Gửi lúc"
      },
      "ticket": {
        "new": "Mới",
        "in_progress": "Đang làm",
        "ready": "Sẵn sàng",
        "bumped": "Xong",
        "recalled": "Gọi lại",
        "voided": "Đã hủy"
      },
      "print": {
        "none": "Chưa in",
        "queued": "Chờ in",
        "printed": "Đã in",
        "failed": "In lỗi"
      },
      "job": {
        "open": "Đang mở",
        "queued": "Chờ in",
        "printing": "Đang in",
        "printed": "Đã in",
        "failed": "Lỗi",
        "cancelled": "Đã hủy"
      },
      "printer": {
        "online": "Trực tuyến",
        "offline": "Ngoại tuyến",
        "error": "Lỗi",
        "unknown": "Chưa rõ"
      },
      "stationType": {
        "kitchen": "Bếp",
        "bar": "Quầy bar",
        "pastry": "Bánh ngọt",
        "expo": "Chuyền món",
        "other": "Khác"
      },
      "tickets": {
        "title": "Phiếu bếp",
        "hint": "Mỗi lần gửi bếp tạo một phiếu cho từng trạm. Tự cập nhật sau 15 giây.",
        "hoHint": "Phiếu bếp của các đơn đã hoàn tất ở mọi cửa hàng.",
        "search": "Tìm theo số đơn hoặc bàn",
        "empty": "Chưa có phiếu bếp",
        "hoEmpty": "Văn phòng chính nhận phiếu khi đơn đã hoàn tất và được đồng bộ.",
        "back": "Về danh sách phiếu bếp"
      },
      "detail": {
        "title": "Phiếu {{station}} số {{number}}",
        "reprint": "In lại",
        "reprinted": "Đã gửi lại phiếu tới máy in.",
        "printedAt": "In lúc",
        "reprints": "Số lần in lại",
        "orderNote": "Ghi chú đơn hàng",
        "items": "Món",
        "quantity": "SL",
        "item": "Món",
        "options": "Tùy chọn",
        "note": "Ghi chú",
        "allergy": "Ghi chú dị ứng",
        "partOf": "(trong {{name}})",
        "attempts": "Các lần in",
        "noAttempts": "Chưa có lần in nào",
        "time": "Thời gian"
      },
      "jobs": {
        "title": "Hàng đợi in",
        "hint": "Các lệnh in của cửa hàng này. Tự cập nhật sau 15 giây.",
        "storeOnly": "Hàng đợi in nằm tại từng cửa hàng. Hãy mở cổng quản trị cửa hàng để xem.",
        "createdAt": "Tạo lúc",
        "device": "Máy in",
        "status": "Trạng thái",
        "attempts": "Số lần thử",
        "error": "Lỗi gần nhất",
        "nextAttempt": "Lần thử tiếp theo",
        "empty": "Không có lệnh in",
        "retry": "Thử lại",
        "retried": "Lệnh in đã được xếp hàng lại.",
        "superseded": "Lệnh này đã được in ở máy in dự phòng nên không thể thử lại.",
        "fallback": "Dự phòng",
        "reprint": "In lại"
      },
      "board": {
        "title": "Trạm bếp",
        "hint": "Mỗi trạm với máy in và số phiếu hôm nay. Tự cập nhật sau 15 giây.",
        "hoHint": "Các trạm bếp của một cửa hàng và số phiếu hôm nay.",
        "pickStore": "Chọn cửa hàng",
        "pickStoreHint": "Văn phòng chính xem trạm bếp của từng cửa hàng.",
        "empty": "Chưa có trạm bếp",
        "emptyHint": "Văn phòng chính thiết lập trạm bếp cho cửa hàng.",
        "primary": "Máy in",
        "fallback": "Máy in dự phòng",
        "noPrinter": "không có",
        "lastSeen": "Thấy lần cuối {{time}}",
        "neverSeen": "Chưa thấy",
        "testPrint": "Thử in",
        "testPrinted": "Đã in trang thử trên {{name}}.",
        "testFailed": "Không in được trang thử trên {{name}}.",
        "queued": "Lệnh chờ in",
        "failed": "Lệnh lỗi",
        "ticketsToday": "Phiếu hôm nay",
        "lastTicket": "Phiếu gần nhất",
        "none": "Chưa có",
        "notPrinted_one": "{{count}} phiếu chưa in",
        "notPrinted_other": "{{count}} phiếu chưa in"
      },
      "routing": {
        "title": "Định tuyến bếp",
        "hint": "Món nào làm ở trạm nào, theo thiết lập của văn phòng chính. Chỉ xem.",
        "hoHint": "Kiểm tra món đi đâu ở một cửa hàng. Quy tắc được sửa trong phần thiết lập trạm bếp.",
        "test": "Thử định tuyến",
        "saleType": "Loại bán hàng",
        "item": "Món",
        "itemPlaceholder": "Chọn món",
        "run": "Thử",
        "station": "Trạm bếp",
        "reason": "Lý do",
        "nowhere": "Không có trạm: món sẽ không được in",
        "source": {
          "item": "Quy tắc theo món",
          "category": "Quy tắc theo nhóm",
          "default": "Trạm mặc định",
          "none": "Không có trạm"
        },
        "reasons": {
          "item_rule": "Có quy tắc cho món này",
          "category_rule": "Có quy tắc cho nhóm của món",
          "default_station": "Không có quy tắc: dùng trạm mặc định",
          "no_station": "Không có quy tắc và không có trạm mặc định"
        },
        "rules": "Quy tắc định tuyến",
        "noRules": "Chưa có quy tắc định tuyến",
        "noRulesHint": "Khi không có quy tắc, mọi món đều đi đến trạm mặc định.",
        "appliesTo": "Áp dụng cho",
        "priority": "Ưu tiên",
        "ruleItem": "Món: {{name}}",
        "ruleCategory": "Nhóm {{name}}",
        "allSaleTypes": "Mọi loại bán hàng"
      },
      "order": {
        "tab": "Bếp",
        "empty": "Chưa gửi bếp",
        "emptyHint": "Phiếu bếp sẽ hiện ở đây sau khi đơn được gửi bếp.",
        "unrouted_one": "{{count}} dòng chưa có quy tắc định tuyến",
        "unrouted_other": "{{count}} dòng chưa có quy tắc định tuyến",
        "unroutedHint": "Các dòng này đã đi đến trạm mặc định. Hãy kiểm tra định tuyến trạm bếp ở văn phòng chính.",
        "send": "Lần gửi {{number}} lúc {{time}}",
        "station": "Trạm bếp",
        "tickets": "Phiếu"
      },
      "widget": {
        "title": "Bếp",
        "notPrinted": "Phiếu chưa in"
      }
    },
    "nav": {
      "overview": "Tổng quan",
      "brands": "Thương hiệu",
      "organisation": "Tổ chức",
      "orders": "Đơn hàng",
      "sales": "Bán hàng",
      "payments": "Thanh toán",
      "shipping": "Giao hàng",
      "storeConnections": "Kết nối cửa hàng",
      "system": "Hệ thống",
      "hoConnection": "Kết nối văn phòng chính",
      "tableQuickSetup": "Thiết lập bàn nhanh",
      "auditLog": "Nhật ký kiểm tra",
      "syncLogs": "Nhật ký đồng bộ",
      "deliveryServices": "Dịch vụ giao hàng",
      "deliveryProviders": "Nhà cung cấp giao hàng",
      "locationImport": "Nhập địa điểm",
      "kitchen": "Bếp",
      "kitchenStations": "Trạm bếp",
      "kitchenTickets": "Phiếu bếp",
      "printQueue": "Hàng đợi in",
      "kitchenRouting": "Định tuyến",
      "shiftHistory": "Lịch sử ca",
      "memberPoints": "Lịch sử điểm",
      "einvoices": "Hóa đơn",
      "einvoiceProviders": "Nhà cung cấp",
      "images": "Hình ảnh",
      "tableQr": "Mã QR tại bàn",
      "messagingAccounts": "Tài khoản tin nhắn",
      "messageTemplates": "Mẫu tin nhắn",
      "customerMessages": "Tin nhắn cho khách",
      "translations": "Bản dịch",
      "menuImport": "Nhập dữ liệu thực đơn",
      "paymentAccounts": "Tài khoản thanh toán",
      "paymentProfiles": "Cấu hình thanh toán",
      "paymentReconciliation": "Đối soát thanh toán",
      "masterDataPublish": "Xuất bản dữ liệu",
      "issueRewards": "Cấp ưu đãi",
      "customerAccounts": "Khách hàng",
      "cmsForms": "Biểu mẫu",
      "formSubmissions": "Nội dung gửi từ biểu mẫu",
      "onlineOrders": "Đơn hàng",
      "dayReports": "Báo cáo ngày",
      "reports": "Báo cáo",
      "reportSales": "Doanh thu",
      "reportProducts": "Cơ cấu món bán",
      "reportHours": "Doanh thu theo giờ",
      "reportPayments": "Thanh toán và thuế",
      "reportQr": "Đối soát QR",
      "reportControls": "Hủy món và giảm giá",
      "reportJournal": "Sổ doanh thu",
      "reportEinvoices": "Đối soát hóa đơn điện tử",
      "reportMenu": "Phân tích thực đơn",
      "reportStaff": "Hiệu suất nhân viên",
      "reportOperations": "Vận hành",
      "reportCustomers": "Khách hàng và khuyến mãi",
      "stockBalances": "Tồn kho",
      "stockMovements": "Biến động kho",
      "stockEntries": "Nhập hàng và hao hụt",
      "stockCounts": "Kiểm kê",
      "stockTransfers": "Chuyển kho",
      "stockSettings": "Cài đặt kho",
      "reportStockBalances": "Tồn kho",
      "reportStockMovements": "Biến động kho",
      "reportStockTransfers": "Chuyển kho",
      "reportStockCounts": "Kiểm kê",
      "posApp": "Ứng dụng POS",
      "attendance": "Chấm công",
      "branding": "Nhận diện thương hiệu",
      "integrationLogs": "Nhật ký tích hợp",
      "auditSettings": "Thời gian lưu nhật ký",
      "signIn": "Đăng nhập",
      "customerSecurity": "Bảo mật tài khoản khách hàng"
    },
    "ho": {
      "title": "Quản trị văn phòng chính"
    },
    "store": {
      "title": "Quản trị cửa hàng",
      "noAccessTitle": "Không có quyền truy cập",
      "noAccess": "Bạn không có quyền vào trang quản trị cửa hàng. Liên hệ quản lý."
    },
    "account": {
      "title": "Tài khoản",
      "staffCode": "Mã nhân viên: {{code}}",
      "tenant": "Công ty {{code}}",
      "store": "Cửa hàng {{code}}"
    },
    "details": "Thông tin",
    "yes": "Có",
    "no": "Không",
    "none": "Không chọn",
    "choose": "Chọn",
    "saved": "Đã lưu",
    "jsonInvalid": "Nhập đối tượng JSON hợp lệ, ví dụ {}.",
    "weekdays": {
      "mon": "T2",
      "tue": "T3",
      "wed": "T4",
      "thu": "T5",
      "fri": "T6",
      "sat": "T7",
      "sun": "CN"
    },
    "everyDay": "Hằng ngày",
    "setPassword": "Đặt mật khẩu",
    "newPassword": "Mật khẩu mới",
    "passwordHint": "Ít nhất 8 ký tự. Nhân viên dùng được ở mọi cửa hàng sau lần đồng bộ tiếp theo.",
    "passwordSet": "Đã lưu mật khẩu.",
    "passwordTooShort": "Nhập ít nhất 8 ký tự.",
    "sync": {
      "tab": "Kết nối",
      "title": "Kết nối cửa hàng",
      "hint": "Cách máy chủ của từng cửa hàng kết nối với văn phòng chính. Cửa hàng gọi lên văn phòng chính; văn phòng chính không bao giờ gọi vào cửa hàng.",
      "status": {
        "not_paired": "Chưa ghép nối",
        "pairing": "Đang chờ ghép nối",
        "paired": "Đã ghép nối",
        "revoked": "Đã thu hồi khóa"
      },
      "online": "Trực tuyến",
      "offline": "Mất kết nối",
      "never": "Chưa có",
      "network": "Mạng",
      "publicIps": "Địa chỉ internet được phép",
      "publicIpsHelp": "Mỗi dòng một địa chỉ: IP công khai của cửa hàng (203.0.113.10) hoặc dải mạng (203.0.113.0/28). Văn phòng chính chỉ nhận kết nối của cửa hàng từ các địa chỉ này.",
      "anyAddress": "Chưa có địa chỉ: văn phòng chính nhận khóa của cửa hàng từ mọi địa chỉ.",
      "lanHost": "Máy chủ cửa hàng trong mạng nội bộ",
      "lanHostHelp": "Ví dụ 192.168.1.10. Máy POS và thiết bị trong cửa hàng kết nối vào đây.",
      "lanPort": "Cổng",
      "saveNetwork": "Lưu cài đặt mạng",
      "saved": "Đã lưu cài đặt mạng.",
      "pairing": "Ghép nối",
      "pairingHint": "Tạo mã, rồi nhập mã trên máy chủ cửa hàng: trang quản trị cửa hàng › Kết nối văn phòng chính. Mã dùng được một lần, trong 30 phút.",
      "createCode": "Tạo mã ghép nối",
      "code": "Mã ghép nối",
      "codeValid": "Có hiệu lực đến {{time}}. Mã chỉ hiển thị lúc này.",
      "copyCode": "Sao chép mã ghép nối",
      "copied": "Đã sao chép",
      "empty": "Không có cửa hàng nào để hiển thị.",
      "repairWarning": "Dùng mã mới sẽ thay khóa hiện tại của cửa hàng.",
      "key": "Khóa cửa hàng",
      "keyIssued": "Khóa {{prefix}}…, cấp lúc {{time}}",
      "revoke": "Thu hồi khóa",
      "revokeTitle": "Thu hồi khóa của cửa hàng này?",
      "revokeBody": "Cửa hàng ngừng đồng bộ ngay. Cửa hàng vẫn bán hàng bình thường và sẽ đồng bộ sau khi được ghép nối lại.",
      "revokedAt": "Thu hồi lúc {{time}}",
      "health": "Tình trạng",
      "appVersion": "Phiên bản",
      "outboxDepth": "Đang chờ gửi",
      "oldestPending": "Chờ lâu nhất từ",
      "lastHeartbeat": "Tín hiệu gần nhất",
      "lastPush": "Nhận dữ liệu gần nhất",
      "lastPull": "Vị trí dữ liệu gốc",
      "lastSeenIp": "Gọi gần nhất từ",
      "lanAddresses": "Địa chỉ máy chủ cửa hàng",
      "lastError": "Lỗi báo gần nhất",
      "columns": {
        "store": "Cửa hàng",
        "status": "Trạng thái",
        "online": "Kết nối",
        "lastHeartbeat": "Tín hiệu gần nhất",
        "appVersion": "Phiên bản",
        "pending": "Đang chờ",
        "ip": "Gọi gần nhất từ"
      },
      "lastRelay": "Lần nhận tin gần nhất (đơn online)"
    },
    "connect": {
      "title": "Kết nối văn phòng chính",
      "hint": "Máy chủ cửa hàng này chưa kết nối với văn phòng chính. Hãy xin văn phòng chính mã ghép nối cho cửa hàng, rồi nhập vào đây.",
      "hoUrl": "Địa chỉ đồng bộ của văn phòng chính",
      "hoUrlHelp": "Ví dụ https://sync.example.com",
      "code": "Mã ghép nối",
      "codeHelp": "Tám ký tự, ví dụ K7QP-2M9X.",
      "submit": "Kết nối",
      "connected": "Đã kết nối văn phòng chính với tên {{store}}. Nhân viên đăng nhập được khi tài khoản về tới, thường trong vòng một phút.",
      "continue": "Tiếp tục đăng nhập"
    },
    "hoConnection": {
      "title": "Kết nối văn phòng chính",
      "pairedAs": "Đã kết nối với tên {{store}}",
      "hoUrl": "Địa chỉ đồng bộ của văn phòng chính",
      "key": "Khóa cửa hàng",
      "pairedAt": "Ghép nối lúc",
      "reachable": "Văn phòng chính phản hồi bình thường.",
      "unreachable": "Không kết nối được văn phòng chính. Cửa hàng vẫn bán hàng; dữ liệu sẽ đồng bộ khi kết nối lại.",
      "lastContact": "Liên lạc gần nhất",
      "lastPull": "Cập nhật dữ liệu gốc",
      "lastPush": "Gửi dữ liệu",
      "pending": "Đang chờ gửi",
      "oldestPending": "Chờ lâu nhất từ",
      "lanUrls": "Máy POS và thiết bị kết nối tới",
      "test": "Kiểm tra kết nối",
      "testOk": "Văn phòng chính đã phản hồi. Văn phòng chính thấy cửa hàng ở địa chỉ {{ip}}.",
      "repair": "Ghép nối lại",
      "repairHint": "Chỉ khi văn phòng chính yêu cầu: ghép nối lại máy chủ cửa hàng bằng mã mới.",
      "never": "Chưa có",
      "held": "Chờ đơn hoàn tất",
      "syncNow": "Đồng bộ ngay",
      "syncNowDone_one": "Đã cập nhật: nhận {{count}} thay đổi từ văn phòng trung tâm.",
      "syncNowDone_other": "Đã cập nhật: nhận {{count}} thay đổi từ văn phòng trung tâm.",
      "syncNowMore": "Đã nhận thay đổi. Phần còn lại tiếp tục được nhận trong nền.",
      "onDemandHint": "Thực đơn, giá và thiết lập từ văn phòng trung tâm được chuyển về khi văn phòng trung tâm xuất bản, hoặc khi bạn bấm Đồng bộ ngay."
    },
    "filters": {
      "title": "Bộ lọc",
      "button": "Bộ lọc",
      "buttonCount_one": "Bộ lọc ({{count}})",
      "buttonCount_other": "Bộ lọc ({{count}})",
      "close": "Đóng bộ lọc",
      "any": "Tất cả",
      "from": "Từ ngày",
      "to": "Đến ngày",
      "online": "Kết nối",
      "status": "Trạng thái",
      "reset": "Đặt lại bộ lọc",
      "apply": "Áp dụng bộ lọc"
    },
    "shifts": {
      "history": "Lịch sử ca",
      "historyHint": "Các ca của cửa hàng, mới nhất trước: tiền mặt phải có và đếm được, ai mở và đóng ca.",
      "shift": "Ca",
      "opened": "Mở lúc",
      "closed": "Đóng lúc",
      "status": "Trạng thái",
      "expected": "Tiền mặt phải có",
      "counted": "Đếm được",
      "variance": "Thừa hoặc thiếu",
      "open": "Đang mở",
      "closedStatus": "Đã đóng",
      "forced": "Đóng không kiểm đếm",
      "unscheduled": "Ca ngoài lịch",
      "empty": "Chưa có ca nào",
      "drawer": "Ngăn kéo",
      "store": "Cửa hàng",
      "float": "Tiền đầu ca",
      "cashSales": "Thu tiền mặt",
      "cashRefunds": "Hoàn tiền mặt",
      "paidIn": "Thu khác",
      "paidOut": "Chi khác",
      "drops": "Nộp két",
      "tenders": "Doanh thu theo phương thức",
      "method": "Phương thức",
      "paid": "Đã thu",
      "refunded": "Đã hoàn",
      "count": "Số giao dịch",
      "movements": "Thu chi tiền mặt",
      "type": "Loại",
      "amount": "Số tiền",
      "note": "Ghi chú",
      "at": "Lúc",
      "print": "In báo cáo ca",
      "printed": "Đã gửi đến {{printer}}.",
      "notPrinted": "Chưa có máy in hóa đơn.",
      "movement": {
        "opening_float": "Tiền đầu ca",
        "paid_in": "Thu tiền",
        "paid_out": "Chi tiền",
        "cash_drop": "Nộp két",
        "no_sale": "Mở két không bán",
        "float_adjust": "Điều chỉnh tiền đầu ca"
      },
      "noteLabel": "Ghi chú: {{note}}",
      "orders": "Đơn hàng theo trạng thái",
      "orderCount": "Số đơn",
      "total": "Tổng",
      "net": "Thực thu",
      "noOrders": "Ca này chưa có đơn hàng",
      "noTakings": "Ca này chưa nhận thanh toán",
      "takingsTotal": "Tổng thu: {{amount}}",
      "openOrders_one": "Còn {{count}} đơn đang mở. Đơn sẽ chuyển sang ca sau nếu không được thanh toán hoặc hủy.",
      "openOrders_other": "Còn {{count}} đơn đang mở. Các đơn sẽ chuyển sang ca sau nếu không được thanh toán hoặc hủy.",
      "figures": "Số khách {{guests}} · trung bình/đơn {{average}} · hủy món, hủy đơn {{voids}} ({{voidAmount}})",
      "methodCounted": "Đối chiếu",
      "noSales": "Mở két không bán: {{count}}",
      "ended": "Đã kết thúc"
    },
    "masterData": {
      "title": "Xuất bản dữ liệu",
      "hint": "Thay đổi tại văn phòng trung tâm (thực đơn, giá, món, thiết lập) chỉ đến cửa hàng và website khi bạn xuất bản tại đây. Cửa hàng đang mất kết nối sẽ nhận khi kết nối lại.",
      "website": "Website và gọi món QR",
      "websitePublishedAt": "Xuất bản gần nhất {{time}}",
      "websiteNever": "Chưa xuất bản",
      "publishWebsite": "Xuất bản lên website",
      "publishAll": "Xuất bản tới tất cả cửa hàng",
      "publish": "Xuất bản",
      "alsoWebsite": "Xuất bản cả lên website",
      "confirmStore": "Xuất bản tới {{store}}?",
      "confirmAll_one": "Xuất bản tới {{count}} cửa hàng?",
      "confirmAll_other": "Xuất bản tới tất cả {{count}} cửa hàng?",
      "confirmWebsite": "Xuất bản lên website và các cửa hàng bán trực tuyến?",
      "confirmBody": "Mọi thay đổi tại văn phòng trung tâm đến nay sẽ được gửi đi. Cửa hàng đang trực tuyến nhận trong vài giây.",
      "publishedStores_one": "Đã xuất bản tới {{count}} cửa hàng.",
      "publishedStores_other": "Đã xuất bản tới {{count}} cửa hàng.",
      "publishedWebsite": "Đã xuất bản lên website.",
      "publishedBoth_one": "Đã xuất bản tới {{count}} cửa hàng và website.",
      "publishedBoth_other": "Đã xuất bản tới {{count}} cửa hàng và website.",
      "changesWaiting": "Có thay đổi chờ",
      "upToDate": "Đã cập nhật",
      "never": "Chưa có",
      "empty": "Chưa có cửa hàng nào.",
      "columns": {
        "store": "Cửa hàng",
        "changes": "Thay đổi từ văn phòng trung tâm",
        "published": "Xuất bản gần nhất",
        "status": "Xuất bản",
        "contact": "Liên lạc gần nhất"
      },
      "status": {
        "never": "Chưa xuất bản",
        "pending": "Chờ cửa hàng nhận",
        "current": "Đã nhận"
      },
      "publishGroup": "Xuất bản theo nhóm cửa hàng",
      "confirmGroup_one": "Xuất bản tới {{group}}: {{count}} cửa hàng?",
      "confirmGroup_other": "Xuất bản tới {{group}}: {{count}} cửa hàng?",
      "groupEmpty": "{{group}} chưa có cửa hàng nào. Hãy thêm cửa hàng vào nhóm trước."
    },
    "addressLookup": {
      "label": "Tìm vĩ độ và kinh độ",
      "placeholder": "Ví dụ: 12 Lê Lợi, Bến Nghé, Hồ Chí Minh",
      "help": "Nhập địa chỉ cửa hàng rồi chọn một gợi ý, hoặc bấm Tìm. Hệ thống điền vĩ độ, kinh độ, đường và, khi tên khớp, tỉnh/thành và phường/xã.",
      "find": "Tìm",
      "finding": "Đang tìm địa chỉ…",
      "pick": "Chọn địa chỉ",
      "none": "Không tìm thấy địa chỉ. Hãy thêm phường/xã và tỉnh/thành, hoặc kiểm tra chính tả.",
      "unavailable": "Chưa tìm được tọa độ của địa chỉ. Hãy tự nhập vĩ độ và kinh độ."
    },
    "dayReport": {
      "title": "Báo cáo ngày",
      "hint": "Doanh thu, thuế, giảm giá, hủy món, tiền thu và tiền mặt của từng ngày kinh doanh, từ dữ liệu của cửa hàng. Ngày chưa chốt là số liệu tạm.",
      "empty": "Chưa có ngày kinh doanh nào",
      "date": "Ngày kinh doanh",
      "status": "Trạng thái",
      "opened": "Mở",
      "closedAt": "Chốt",
      "closed": "Đã chốt",
      "openNotFinal": "Đang mở, số liệu tạm",
      "print": "In báo cáo ngày",
      "downloadCsv": "Tải CSV",
      "printed": "Đã gửi báo cáo ngày tới {{printer}}.",
      "notPrinted": "Chưa cài máy in hóa đơn cho cửa hàng này.",
      "total": "Tổng doanh thu",
      "totalCaption": "Đơn đã hoàn tất",
      "orders": "Số đơn",
      "guestsCaption_one": "{{count}} khách",
      "guestsCaption_other": "{{count}} khách",
      "averageCheck": "Trung bình/đơn",
      "voids": "Hủy món, hủy đơn",
      "voidsCaption_one": "{{count}} lần",
      "voidsCaption_other": "{{count}} lần",
      "salesSummary": "Doanh thu",
      "subtotal": "Tiền hàng",
      "discounts": "Giảm giá",
      "charges": "Phụ thu",
      "tax": "Thuế",
      "rounding": "Làm tròn",
      "guests": "Số khách",
      "invoiceRequests_one": "{{count}} đơn yêu cầu xuất hóa đơn GTGT.",
      "invoiceRequests_other": "{{count}} đơn yêu cầu xuất hóa đơn GTGT.",
      "byHour": "Doanh thu theo giờ",
      "hour": "Giờ",
      "amount": "Số tiền",
      "quantity": "Số lượng",
      "name": "Tên",
      "byCategory": "Doanh thu theo nhóm hàng",
      "topItems": "Bán chạy",
      "bySaleType": "Doanh thu theo loại bán",
      "byChannel": "Doanh thu theo kênh",
      "deals": "Combo",
      "other": "Khác",
      "noSales": "Không có doanh thu trong ngày",
      "taxes": "Thuế theo thuế suất",
      "taxable": "Doanh thu chịu thuế",
      "discountsTitle": "Giảm giá",
      "source": "Nguồn",
      "reason": "Lý do",
      "count": "Số lần",
      "noDiscounts": "Không có giảm giá trong ngày",
      "discountSource": {
        "manual": "Thủ công",
        "promotion": "Khuyến mãi",
        "coupon": "Mã giảm giá",
        "member": "Thành viên",
        "marketplace": "Sàn TMĐT",
        "points": "Điểm"
      },
      "voidsCapped": "Đang hiện {{shown}} lần hủy mới nhất trong {{count}} lần.",
      "at": "Lúc",
      "order": "Đơn",
      "item": "Món",
      "wholeOrder": "Cả đơn",
      "kitchen": "Bếp",
      "afterSend": "Đã gửi bếp",
      "by": "Người hủy",
      "approved": "có duyệt",
      "noVoids": "Không có hủy món trong ngày",
      "tenders": "Tiền thu theo phương thức",
      "method": "Phương thức",
      "paid": "Đã thu",
      "refunded": "Đã hoàn",
      "net": "Thực thu",
      "noTakings": "Không có thanh toán trong ngày",
      "cash": "Theo ca",
      "shift": "Ca",
      "noShifts": "Không có ca trong ngày",
      "movements": "Thu khác {{paidIn}} · chi khác {{paidOut}} · nộp két {{drops}}",
      "takings": "Doanh thu",
      "outsideShifts_one": "Ngoài ca ({{count}} thanh toán)",
      "outsideShifts_other": "Ngoài ca ({{count}} thanh toán)"
    },
    "pickerFirst": "Đang hiển thị {{count}} mục đầu. Nhập để tìm mục khác.",
    "pickerMatches": "Đang hiển thị {{count}} kết quả đầu. Nhập thêm để thu hẹp.",
    "stock": {
      "balances": "Tồn kho",
      "balancesHint": "Số lượng từng mặt hàng theo dõi tồn kho tại cửa hàng, theo đơn vị cơ bản, định giá theo giá vốn chuẩn. Chọn một mặt hàng để xem các biến động.",
      "movements": "Biến động kho",
      "movementsHint": "Mọi thay đổi tồn kho, mới nhất trước: bán hàng, nhập hàng, hao hụt, điều chỉnh, kiểm kê và chuyển kho.",
      "entries": "Nhập hàng và hao hụt",
      "entriesHint": "Nhập hàng, hao hụt và điều chỉnh ghi nhận tại cửa hàng này. Mỗi phiếu được ghi sổ khi lưu.",
      "counts": "Kiểm kê",
      "countsHint": "Đếm hàng thực tế; khi ghi sổ phiếu kiểm kê, chênh lệch được ghi nhận.",
      "transfers": "Chuyển kho",
      "transfersHint": "Hàng chuyển đến hoặc nhận từ các cửa hàng khác cùng thương hiệu.",
      "settings": "Cài đặt kho",
      "settingsHint": "Cách xử lý tồn kho tại cửa hàng này.",
      "settingsSaved": "Đã lưu cài đặt kho",
      "autoSoldOut": "Tự báo hết món khi hết hàng",
      "autoSoldOutHint": "Khi một mặt hàng bán có theo dõi tồn kho về 0 hoặc âm, mặt hàng được báo hết trên POS; khi nhập thêm hàng sẽ bán lại được. Mặt hàng báo hết thủ công không bị thay đổi.",
      "on": "Bật",
      "off": "Tắt",
      "code": "Mã",
      "item": "Mặt hàng",
      "items": "Mặt hàng",
      "onHand": "Tồn",
      "unitCost": "Đơn giá vốn",
      "value": "Giá trị",
      "lastMovement": "Biến động gần nhất",
      "searchItems": "Tìm mặt hàng",
      "noBalances": "Chưa có mặt hàng theo dõi tồn kho",
      "noBalancesHint": "Mặt hàng hiện ở đây khi trụ sở đánh dấu theo dõi tồn kho.",
      "when": "Thời gian",
      "type": "Loại",
      "quantity": "Số lượng",
      "by": "Người thực hiện",
      "note": "Ghi chú",
      "noMovements": "Chưa có biến động",
      "number": "Số phiếu",
      "reason": "Lý do",
      "reference": "Tham chiếu",
      "referenceHint": "Ví dụ số phiếu giao hàng của nhà cung cấp.",
      "lineCount": "Số dòng",
      "postedAt": "Ghi sổ",
      "createdAt": "Tạo lúc",
      "sentAt": "Gửi lúc",
      "receivedAt": "Nhận lúc",
      "newEntry": "Phiếu mới",
      "newEntryHint": "Ghi nhận nhập hàng, hao hụt hoặc điều chỉnh. Có thể nhập số lượng theo bất kỳ đơn vị nào của mặt hàng.",
      "noEntries": "Chưa có phiếu nào",
      "chooseReason": "Chọn lý do",
      "reasonRequired": "Chọn lý do cho hao hụt hoặc điều chỉnh.",
      "linesRequired": "Thêm ít nhất một mặt hàng, mỗi mặt hàng có số lượng.",
      "post": "Ghi sổ",
      "lines": "Chi tiết",
      "baseQuantity": "Theo đơn vị cơ bản",
      "addItem": "Thêm mặt hàng",
      "unit": "Đơn vị",
      "removeLine": "Xóa {{name}}",
      "entryTypeHint": {
        "receipt": "Tăng tồn kho. Nhập đơn giá vốn nếu biết.",
        "waste": "Giảm tồn kho: hư hỏng, đổ vỡ hoặc hết hạn.",
        "adjustment": "Điều chỉnh tăng hoặc giảm; nhập số âm để giảm tồn kho."
      },
      "status": "Trạng thái",
      "counted": "Đã đếm",
      "expected": "Sổ sách",
      "difference": "Chênh lệch",
      "countedOf": "Số lượng đếm được của {{name}}",
      "newCount": "Kiểm kê mới",
      "startCount": "Bắt đầu kiểm kê",
      "noCounts": "Chưa có phiếu kiểm kê",
      "itemsRequired": "Chọn ít nhất một mặt hàng.",
      "spotOneItem": "Kiểm tra nhanh chỉ cho một mặt hàng.",
      "countType": {
        "full": "Kiểm kê toàn bộ",
        "partial": "Kiểm kê một phần",
        "spot": "Kiểm tra nhanh"
      },
      "countTypeHint": {
        "full": "Mọi mặt hàng theo dõi tồn kho của cửa hàng.",
        "partial": "Các mặt hàng bạn chọn; có thể thêm trong khi đếm.",
        "spot": "Một mặt hàng, kiểm tra ngay."
      },
      "countSaved": "Đã lưu phiếu kiểm kê",
      "cancelCount": "Hủy kiểm kê",
      "postCount": "Ghi sổ kiểm kê",
      "postCountTitle": "Ghi sổ phiếu kiểm kê {{number}}?",
      "postCountBody": "Đã đếm {{counted}} trên {{total}} dòng. Chênh lệch của các dòng đã đếm được ghi vào tồn kho; dòng chưa đếm giữ nguyên. Sau đó không sửa được phiếu.",
      "cancelCountTitle": "Hủy phiếu kiểm kê {{number}}?",
      "cancelCountBody": "Không ghi gì vào tồn kho, và không dùng lại được phiếu này.",
      "state": {
        "draft": "Nháp",
        "in_progress": "Đang thực hiện",
        "posted": "Đã ghi sổ",
        "cancelled": "Đã hủy",
        "sent": "Đã gửi",
        "received": "Đã nhận"
      },
      "direction": "Chiều",
      "directions": {
        "out": "Chuyển đi",
        "in": "Nhận về"
      },
      "otherStore": "Cửa hàng kia",
      "fromStore": "Từ",
      "toStore": "Đến",
      "newTransfer": "Phiếu chuyển mới",
      "newTransferHint": "Chuyển hàng đến cửa hàng khác cùng thương hiệu. Phiếu được lưu nháp; khi gửi, hàng được trừ khỏi cửa hàng này.",
      "noTransfers": "Chưa có phiếu chuyển",
      "chooseStore": "Chọn cửa hàng",
      "storeRequired": "Chọn cửa hàng nhận.",
      "storesUnavailable": "Danh sách cửa hàng lấy từ trụ sở. Thử lại khi cửa hàng có mạng.",
      "saveDraft": "Lưu nháp",
      "send": "Gửi",
      "cancelTransfer": "Hủy phiếu chuyển",
      "receive": "Nhận hàng",
      "quantitySent": "Đã gửi",
      "quantityReceived": "Đã nhận",
      "receivedOf": "Số lượng nhận được của {{name}}",
      "receiveHint": "Nhập số lượng thực nhận của từng dòng, rồi chọn Nhận hàng. Mỗi phiếu chỉ nhận một lần.",
      "confirm": {
        "send": "Gửi phiếu chuyển {{number}}?",
        "cancel": "Hủy phiếu chuyển {{number}}?",
        "receive": "Nhận phiếu chuyển {{number}}?"
      },
      "confirmBody": {
        "send": "Hàng được trừ khỏi cửa hàng này ngay, và phiếu đến {{store}} khi cửa hàng có mạng. Sau đó không sửa được phiếu.",
        "cancel": "Phiếu nháp bị hủy; không trừ gì khỏi tồn kho.",
        "receive": "Số hàng thực nhận được cộng vào tồn kho cửa hàng này. Chênh lệch so với số {{store}} đã gửi được lưu cho cả hai cửa hàng và trụ sở."
      },
      "txn": {
        "sale": "Bán hàng",
        "receipt": "Nhập hàng",
        "waste": "Hao hụt",
        "adjustment": "Điều chỉnh",
        "count": "Kiểm kê",
        "transfer_out": "Chuyển đi",
        "transfer_in": "Nhận chuyển"
      }
    },
    "posApp": {
      "title": "Ứng dụng POS cho Windows và máy tính bảng",
      "intro": "Thiết bị có ứng dụng POS kết nối với máy chủ cửa hàng này. Mở trang này trên máy khác khi cài đặt thiết bị, hoặc đọc địa chỉ ở đây.",
      "qrLabel": "Mã QR chứa địa chỉ của cửa hàng này",
      "address": "Địa chỉ cửa hàng",
      "stepInstall": "Cài ứng dụng POS lên thiết bị: bộ cài Windows trên máy POS để bàn, hoặc POS cho máy tính bảng trên máy tính bảng (do bộ phận IT cung cấp).",
      "stepConnect": "Mở ứng dụng và quét mã này (máy tính bảng), hoặc nhập địa chỉ (Windows).",
      "stepTerminal": "Quản lý đăng nhập trên thiết bị và chọn thiết bị là máy POS nào.",
      "downloads": {
        "title": "Tải ứng dụng",
        "version": "Phiên bản {{version}}, có trong gói cài đặt của cửa hàng.",
        "windows": "Bộ cài cho Windows",
        "tablet": "POS cho máy tính bảng (APK)",
        "rootCertificate": "Chứng chỉ gốc của cửa hàng",
        "none": "Gói cài đặt của cửa hàng này chưa có ứng dụng POS. Hãy hỏi bộ phận IT để lấy bộ cài Windows hoặc POS cho máy tính bảng."
      }
    },
    "attendance": {
      "title": "Chấm công",
      "hint": "Ai đã chấm công vào, ra và lúc nào. Mở một dòng để sửa giờ hoặc chấm công ra cho nhân viên.",
      "staff": "Nhân viên",
      "in": "Giờ vào",
      "out": "Giờ ra",
      "clockedIn": "Đang làm",
      "reason": "Chấm ra bởi",
      "reasons": {
        "self": "Nhân viên tự chấm",
        "manager": "Quản lý",
        "day_close": "Khi đóng ngày"
      },
      "edited": "Điều chỉnh",
      "corrected": "Đã sửa",
      "search": "Tìm nhân viên trong trang này",
      "empty": "Chưa có ai chấm công.",
      "correct": "Sửa chấm công",
      "outHint": "Để trống khi nhân viên vẫn đang làm.",
      "note": "Lý do sửa"
    },
    "branding": {
      "title": "Nhận diện thương hiệu",
      "hint": "Nội dung màn hình đăng nhập và chân trang của mọi ứng dụng: tên sản phẩm, chủ sở hữu bản quyền và dòng “Powered by”. Để trống thì mỗi ứng dụng dùng nội dung riêng. Cửa hàng nhận thay đổi ở lần đồng bộ tiếp theo; logo của từng thương hiệu đặt trong thương hiệu.",
      "productName": "Tên sản phẩm",
      "productNameHelp": "Tên hệ thống mà nhân viên biết đến. Để trống: tên riêng của ứng dụng.",
      "copyright": "Chủ sở hữu bản quyền",
      "copyrightHelp": "Hiện ở chân trang dạng “© năm chủ sở hữu”. Để trống: tên “Powered by”, rồi tên sản phẩm.",
      "poweredByName": "Powered by",
      "poweredByNameHelp": "Đơn vị cung cấp nền tảng, hiện dạng “Powered by …” ở chân trang và màn hình đăng nhập.",
      "poweredByUrl": "Liên kết Powered by",
      "poweredByUrlHelp": "Địa chỉ web (không bắt buộc) mà dòng “Powered by” trỏ tới, bắt đầu bằng https://.",
      "preview": "Xem trước",
      "previewNone": "Chưa đặt gì: mỗi ứng dụng hiện nhận diện riêng.",
      "saved": "Đã lưu nhận diện thương hiệu. Cửa hàng hiện sau lần đồng bộ tiếp theo."
    },
    "history": {
      "title": "Lịch sử",
      "when": "Thời gian",
      "who": "Người thực hiện",
      "what": "Thao tác",
      "record": "Bản ghi",
      "changes": "Thay đổi",
      "system": "Hệ thống",
      "emptyTitle": "Chưa có thay đổi nào",
      "empty": "Các thay đổi của nhân viên được ghi lại ở đây, kèm người thực hiện và thời gian.",
      "actions": {
        "create": "Tạo mới",
        "update": "Sửa",
        "delete": "Xóa",
        "restore": "Khôi phục"
      },
      "storeHint": "Mọi thay đổi nhân viên thực hiện trong cổng quản trị cửa hàng, cùng đăng nhập và phê duyệt: ai, khi nào và thay đổi gì."
    },
    "auditSettings": {
      "title": "Thời gian lưu nhật ký kiểm tra",
      "hint": "Nhật ký kiểm tra lưu ai đã thay đổi gì trong bao lâu. Đặt theo chính sách lưu trữ của bạn; các bản ghi cũ hơn được xóa hằng ngày tại trụ sở, và mọi thay đổi của thiết lập này cũng được ghi lại.",
      "keepAll": "Lưu tất cả",
      "months": "Lưu trong (tháng)",
      "monthsHelp": "Từ 1 đến 600 tháng.",
      "monthsInvalid": "Nhập số tháng nguyên từ 1 đến 600.",
      "default": "Chưa đặt: 120 tháng (10 năm), mức tối thiểu cho chứng từ kế toán tại Việt Nam.",
      "saved": "Đã lưu. Các bản ghi cũ hơn sẽ được xóa ở lần dọn dẹp hằng ngày tiếp theo."
    },
    "removed": {
      "show": "Hiển thị",
      "current": "Bản ghi hiện có",
      "view": "Đã xóa",
      "restore": "Khôi phục",
      "confirm": "Khôi phục bản ghi này?",
      "confirmBody": "Bản ghi trở lại như lúc bị xóa, và đến các cửa hàng ở lần đồng bộ tiếp theo. Việc khôi phục được ghi vào nhật ký kiểm tra.",
      "emptyTitle": "Chưa có gì bị xóa",
      "empty": "Các bản ghi bị xóa khỏi danh sách này được giữ ở đây và có thể khôi phục."
    }
  },
  "carbon": {
    "itemsPerPage": "Số dòng mỗi trang:",
    "itemRange": "{{min}}–{{max}} trên {{total}} mục",
    "pageRange": "trên {{total}} trang",
    "itemRangeMany": "{{min}}–{{max}} trên hơn {{total}} mục",
    "pageOnly": "Trang {{page}}",
    "previousPage": "Trang trước",
    "nextPage": "Trang sau",
    "pageNumber": "Số trang",
    "close": "Đóng",
    "showPassword": "Hiện mật khẩu",
    "hidePassword": "Ẩn mật khẩu",
    "skipToContent": "Chuyển đến nội dung chính",
    "clearSearch": "Xóa tìm kiếm",
    "openMenu": "Mở menu",
    "closeMenu": "Đóng menu",
    "error": "Lỗi",
    "warning": "Cảnh báo",
    "info": "Thông tin"
  },
  "md": {
    "fields": {
      "account_id": "Tài khoản hội viên",
      "account_no": "Số tài khoản",
      "account_prefix": "Tiền tố số tài khoản",
      "action_code": "Chức năng",
      "address": "Địa chỉ (IP hoặc cổng)",
      "allow_ai_crawlers": "Cho phép công cụ tìm kiếm AI",
      "allow_cod": "Thanh toán khi nhận hàng",
      "allow_item_modifiers": "Cho chọn tùy chọn của món",
      "allow_pay_at_pickup": "Thanh toán tại quầy khi tự đến lấy",
      "allow_quantity": "Cho chọn số lượng",
      "allow_repeat": "Được chọn trùng",
      "allows_change": "Trả tiền thừa",
      "amount_entry": "Nhập giá trị tại POS",
      "applies_after_tax": "Áp dụng sau thuế VAT",
      "apply_rules": "Khi nào áp dụng",
      "attendance_mode": "Chấm công",
      "audience": "Ai được dùng",
      "audience_segment_id": "Nhóm khách hàng",
      "auto_accept": "Tự động nhận đơn",
      "auto_apply": "Tự động áp dụng",
      "available_again_at": "Có lại lúc",
      "background_url": "Ảnh nền (URL)",
      "balance": "Số dư",
      "balance_reserved": "Đang giữ trên đơn mở",
      "barcode": "Mã vạch",
      "base_behavior": "Hoạt động như",
      "base_distance_m": "Khoảng cách tính phí cơ bản (m)",
      "base_fee": "Phí cơ bản",
      "base_uom_id": "Đơn vị cơ bản",
      "batch_id": "Lô",
      "birth_date": "Ngày sinh",
      "blind_count": "Đếm mù (ẩn số tiền phải có)",
      "body": "Nội dung mẫu",
      "brand_id": "Thương hiệu",
      "busy_extra_minutes": "Đang đông: thêm phút",
      "busy_until": "Đông đến lúc",
      "canvas_height": "Chiều cao",
      "canvas_width": "Chiều rộng",
      "capacity": "Số ghế",
      "card_digits": "Số chữ số của số thẻ",
      "card_no": "Số thẻ",
      "card_prefix": "Tiền tố số thẻ",
      "cash_count_enabled": "Kiểm đếm tiền khi đóng ca",
      "category_id": "Nhóm hàng",
      "channel_type": "Loại kênh",
      "charge_type_id": "Phí",
      "closes_at": "Đóng cửa lúc",
      "club_id": "Chương trình",
      "code": "Mã",
      "code3": "Mã 3 chữ cái",
      "col_span": "Số cột chiếm",
      "combine_match": "Khách thuộc",
      "component_type": "Loại",
      "conditions": "Đối tượng",
      "config": "Cấu hình (JSON)",
      "connection_type": "Kết nối",
      "consent_at": "Ngày đồng ý",
      "contact_id": "Người dùng thẻ",
      "contact_no": "Số người dùng thẻ",
      "contact_prefix": "Tiền tố số người dùng thẻ",
      "content": "Nội dung",
      "count_scope": "Kiểm đếm tiền",
      "country_code": "Quốc gia",
      "country_id": "Quốc gia",
      "cover_url": "Ảnh bìa",
      "currency_code": "Tiền tệ",
      "day_close_open_orders": "Đơn đang mở khi đóng ngày",
      "day_cutoff_at": "Giờ kết thúc ngày kinh doanh",
      "day_of_week": "Thứ",
      "days_of_week": "Ngày trong tuần",
      "deal_component_item_id": "Lựa chọn combo",
      "deal_id": "Combo",
      "decimals": "Số chữ số thập phân",
      "default_language": "Ngôn ngữ mặc định",
      "default_opening_float": "Tiền đầu ca mặc định",
      "default_sale_type_id": "Loại bán mặc định",
      "delivery_sale_type_id": "Loại bán hàng của đơn giao hàng",
      "delivery_service_id": "Dịch vụ giao hàng",
      "density": "Mật độ hiển thị",
      "deposit_percent": "Đặt cọc cho đơn ngày sau (%)",
      "description": "Mô tả",
      "description_i18n": "Bản dịch mô tả",
      "device_type": "Loại thiết bị",
      "dine_in_sale_type_id": "Loại bán hàng của đơn ăn tại nhà hàng",
      "discount_value": "Giá trị giảm",
      "display_category_id": "Hiển thị trong nhóm",
      "display_name": "Họ tên",
      "district_code": "Quận/Huyện",
      "division_id": "Đơn vị hành chính",
      "document_type": "Loại chứng từ",
      "effective_from": "Hiệu lực từ",
      "effective_to": "Hiệu lực đến",
      "email": "Email",
      "email_buyer": "Gửi hóa đơn qua email cho người mua",
      "end_time": "Đến giờ",
      "ends_at": "Giờ kết thúc",
      "engine": "Bộ xử lý mẫu",
      "excludes_promotions": "Không áp dụng khuyến mãi khác cho đơn",
      "excludes_redemptions": "Không đổi điểm, voucher cho đơn",
      "expiry_reminder_days": "Nhắc hội viên trước khi điểm hết hạn bấy nhiêu ngày (ví dụ 30, 7; để trống: không nhắc)",
      "external_store_id": "Mã cửa hàng trên kênh",
      "face_value": "Mệnh giá",
      "factor": "Hệ số",
      "factor_to_base": "Số đơn vị cơ bản trong 1",
      "fallback_device_id": "Máy in dự phòng",
      "fee_mode": "Cách tính phí",
      "fixed_fee": "Phí cố định",
      "free_from_amount": "Miễn phí giao từ",
      "from_uom_id": "Từ đơn vị",
      "full_name": "Tên đầy đủ",
      "full_name_i18n": "Bản dịch tên đầy đủ",
      "funded_by": "Bên chi trả",
      "gender": "Giới tính",
      "grid_col": "Cột",
      "grid_cols": "Số cột",
      "grid_row": "Hàng",
      "grid_rows": "Số hàng",
      "has_changes": "Có thay đổi chưa xuất bản",
      "height": "Chiều cao",
      "hold_minutes": "Gửi sau khi thanh toán (phút)",
      "host": "Tên miền",
      "icon": "Biểu tượng",
      "icon_url": "Biểu tượng (địa chỉ ảnh)",
      "image_url": "Ảnh (URL)",
      "ingredient_item_id": "Nguyên liệu",
      "invoice_kind": "Loại hóa đơn",
      "invoice_series": "Ký hiệu hóa đơn",
      "is_active": "Đang dùng",
      "is_available": "Còn hàng",
      "is_base": "Là đơn vị cơ bản",
      "is_default": "Mặc định",
      "is_default_sale": "Đơn vị bán mặc định",
      "is_enabled": "Bật",
      "is_free": "Chưa gán",
      "is_main": "Người dùng chính",
      "is_open_price": "Nhập giá tại POS",
      "is_primary": "Chính",
      "is_required": "Bắt buộc",
      "is_skippable": "Có thể bỏ qua",
      "is_stackable": "Dùng chung với mã khác",
      "is_stock_tracked": "Theo dõi tồn kho",
      "is_system": "Vai trò hệ thống",
      "is_tax_inclusive": "Giá đã gồm thuế",
      "is_taxable": "Chịu thuế",
      "is_visible": "Hiển thị",
      "item_category_id": "Nhóm hàng",
      "item_group_id": "Nhóm biến thể",
      "item_id": "Món",
      "item_type": "Loại hàng",
      "joined_at": "Ngày tham gia",
      "joined_store_id": "Cửa hàng đăng ký",
      "kds_enabled": "Màn hình bếp",
      "kds_late_minutes": "Trễ sau (phút)",
      "kds_warn_minutes": "Cảnh báo sau (phút)",
      "kind": "Loại",
      "kitchen_name": "Tên in bếp",
      "label": "Nhãn",
      "label_i18n": "Bản dịch nhãn",
      "label_override": "Nhãn trên nút",
      "language": "Ngôn ngữ",
      "languages": "Ngôn ngữ (mã, ví dụ vi,en)",
      "large_text": "Chữ lớn",
      "last_run_at": "Cập nhật lúc",
      "latitude": "Vĩ độ",
      "legal_entity_id": "Pháp nhân",
      "legal_name": "Tên pháp lý",
      "level": "Cấp",
      "limits": "Giới hạn (JSON)",
      "line_detail": "Dòng trên hóa đơn",
      "list_filter": "Bộ lọc danh sách (JSON)",
      "locale": "Định dạng vùng",
      "logo_url": "Logo (địa chỉ ảnh)",
      "longitude": "Kinh độ",
      "manual_confirm_approval_above": "Cần quản lý duyệt khi trên",
      "maps_url": "Liên kết Google Maps",
      "marketing_consent": "Đồng ý nhận tiếp thị",
      "match": "Cách so khớp",
      "max_cod_amount": "Giá trị tối đa thu tiền khi giao",
      "max_discount": "Giảm tối đa",
      "max_distance_m": "Giao xa nhất (m)",
      "max_open_orders": "Số đơn đang làm tối đa",
      "max_quantity": "Số lượng tối đa",
      "max_redeem_percent": "Tỷ lệ tối đa giá trị món (chưa VAT) trả bằng điểm (%)",
      "max_select": "Chọn tối đa",
      "max_select_override": "Chọn tối đa (ghi đè)",
      "max_uses": "Số lần dùng mỗi mã",
      "max_value": "Tối đa",
      "member_account_id": "Đã cấp cho hội viên",
      "member_count": "Số khách",
      "menu_id": "Thực đơn",
      "menu_layout_id": "Bố cục thực đơn",
      "method": "Cách tính",
      "method_type": "Loại thanh toán",
      "min_points": "Số điểm để đạt hạng",
      "min_redeem_points": "Số điểm tối thiểu để thanh toán",
      "min_select": "Chọn tối thiểu",
      "min_select_override": "Chọn tối thiểu (ghi đè)",
      "minimum_order_amount": "Đơn tối thiểu",
      "model": "Mẫu máy",
      "modifier_group_id": "Nhóm tùy chọn",
      "name": "Tên",
      "name_i18n": "Bản dịch tên",
      "next_account_no": "Số tài khoản tiếp theo",
      "next_card_no": "Số thẻ kế tiếp",
      "next_contact_no": "Số người dùng thẻ tiếp theo",
      "note": "Ghi chú",
      "notify": "Thông báo hội viên",
      "og_image_url": "Ảnh khi chia sẻ",
      "open_mode": "Cách mở ca",
      "opened_on": "Ngày khai trương",
      "opens_at": "Mở cửa lúc",
      "opens_drawer": "Mở ngăn kéo tiền",
      "order_flow_id": "Quy trình bán",
      "palette_key": "Màu",
      "paper_width_mm": "Khổ giấy (mm)",
      "parent_id": "Nhóm cha",
      "parent_page_id": "Trang cha",
      "part_role": "Cách dùng",
      "part_segment_id": "Nhóm khách hàng",
      "paused_reason": "Lý do tạm dừng",
      "payment_method_name": "Hình thức thanh toán trên hóa đơn",
      "per_member_limit": "Số lần mỗi hội viên",
      "permission_code": "Quyền",
      "phone": "Điện thoại",
      "phone_code": "Đầu số điện thoại",
      "phone_normalized": "Số điện thoại",
      "phrase": "Từ hoặc cụm từ",
      "pickup_sale_type_id": "Loại bán hàng của đơn tự đến lấy",
      "place_name": "Địa danh",
      "placement": "Vị trí",
      "point_value": "Giá trị một điểm",
      "points": "Điểm",
      "points_balance": "Điểm",
      "points_expiry_months": "Số tháng điểm hết hạn (0: không hết hạn)",
      "points_reserved": "Điểm đang giữ trên đơn mở",
      "points_with_other_discounts": "Dùng điểm cùng giảm giá khác trên một hóa đơn",
      "port": "Cổng",
      "pos_layout_id": "Bố cục POS",
      "pos_layout_section_id": "Khu vực POS",
      "pos_profile_id": "Hồ sơ POS",
      "pos_x": "X",
      "pos_y": "Y",
      "postal_code": "Mã bưu chính",
      "postal_code_pattern": "Mẫu mã bưu chính",
      "preferred_language": "Ngôn ngữ",
      "prefix": "Tiền tố mã",
      "prep_minutes": "Thời gian chuẩn bị (phút)",
      "price": "Giá",
      "pricing_method": "Cách tính giá",
      "primary_device_id": "Máy in",
      "priority": "Độ ưu tiên",
      "privacy_notice_version": "Phiên bản thông báo quyền riêng tư",
      "prompt_text": "Lời nhắc",
      "provider_account_id": "Tài khoản nhà cung cấp",
      "provider_code": "Mã nhà cung cấp",
      "provider_name": "Nhà cung cấp",
      "province_code": "Tỉnh/Thành phố",
      "published_at": "Đã xuất bản lúc",
      "published_version": "Phiên bản trên website",
      "quantity": "Số lượng",
      "question": "Câu hỏi",
      "question_i18n": "Bản dịch câu hỏi",
      "rate": "Thuế suất (%)",
      "reason": "Lý do",
      "reason_required": "Bắt buộc nhập lý do",
      "reason_type": "Dùng cho",
      "refresh_requested_at": "Yêu cầu cập nhật",
      "region_id": "Vùng",
      "require_mode": "Ca khi thanh toán",
      "requires_address": "Cần địa chỉ",
      "requires_approval": "Cần quản lý duyệt",
      "requires_customer": "Cần khách hàng",
      "requires_ho": "Cần kết nối văn phòng chính",
      "requires_reference": "Cần mã tham chiếu",
      "requires_table": "Cần chọn bàn",
      "reward_method": "Loại giảm giá",
      "reward_scope": "Áp dụng cho",
      "reward_settings": "Thiết lập phần thưởng",
      "reward_type": "Phần thưởng",
      "reward_value": "Mức giảm",
      "role": "Vai trò nút",
      "role_id": "Vai trò",
      "rotation": "Góc xoay",
      "row_span": "Số hàng chiếm",
      "rule": "Quy tắc (JSON)",
      "rule_type": "Loại quy tắc",
      "rules": "Khi nào được dùng",
      "sale_type_id": "Loại bán hàng",
      "sales_channel_id": "Kênh bán",
      "schedule_days": "Số ngày khách được đặt trước (0: chỉ giao ngay)",
      "scheme_id": "Hạng",
      "scheme_since": "Đạt hạng từ",
      "scope": "Áp dụng cho",
      "screen_class": "Màn hình",
      "section_type": "Loại khu vực",
      "segment_id": "Chỉ hội viên thuộc nhóm",
      "seller_tax_code": "MST người bán",
      "send_by": "Gửi hóa đơn trong ngày trước (giờ cửa hàng)",
      "seo_description_i18n": "Mô tả cho công cụ tìm kiếm",
      "seo_title_i18n": "Tiêu đề cho công cụ tìm kiếm",
      "service_type": "Dịch vụ của nhà cung cấp",
      "settings": "Cấu hình (JSON)",
      "settings_override": "Cấu hình riêng (JSON)",
      "shape": "Hình dạng",
      "short_name": "Tên ngắn",
      "short_name_i18n": "Bản dịch tên ngắn",
      "shortcut_key": "Phím tắt",
      "site_name": "Tên hiển thị cho khách",
      "slot_limit": "Số đơn tối đa mỗi khung giờ",
      "slot_minutes": "Độ dài khung giờ (phút)",
      "slug": "Khóa",
      "sort_order": "Thứ tự",
      "source": "Nguồn nhập",
      "spend_amount": "Cho mỗi số tiền chi tiêu",
      "staff_code": "Mã nhân viên",
      "standard_cost": "Giá vốn chuẩn",
      "start_time": "Từ giờ",
      "starts_at": "Giờ bắt đầu",
      "station_type": "Loại khu bếp",
      "status": "Trạng thái",
      "step_fee": "Phí mỗi bước",
      "step_m": "Sau đó mỗi (m)",
      "step_type": "Bước",
      "store_group_id": "Nhóm cửa hàng",
      "store_id": "Cửa hàng",
      "street_address": "Địa chỉ",
      "summary_i18n": "Tóm tắt",
      "support_email": "Email hỗ trợ",
      "support_phone": "Điện thoại hỗ trợ",
      "table_area_id": "Khu vực",
      "target_page_id": "Mở trang",
      "target_type": "Nút mở",
      "tax_category_id": "Nhóm thuế",
      "tax_code": "Mã số thuế",
      "template_code": "Mẫu số hóa đơn",
      "terminal_id": "Máy bán hàng",
      "terminal_type": "Loại máy",
      "theme": "Giao diện",
      "tier_counts_adjustments": "Điểm do nhân viên điều chỉnh được tính hạng",
      "tier_counts_orders": "Điểm từ đơn hàng được tính hạng",
      "tier_counts_rewards": "Điểm từ chương trình ưu đãi được tính hạng",
      "tier_period_months": "Số tháng tính hạng",
      "tier_points": "Điểm xếp hạng",
      "time_zone": "Múi giờ",
      "title_i18n": "Tiêu đề",
      "to_uom_id": "Sang đơn vị",
      "trigger_event": "Hỏi khi",
      "trigger_settings": "Thiết lập kích hoạt",
      "trigger_type": "Điều kiện kích hoạt",
      "unit_type_id": "Loại đơn vị",
      "uom_id": "Đơn vị",
      "upcharge": "Phụ thu",
      "use_item_groups": "Gộp biến thể thành một món",
      "uses_confirmed": "Đã dùng",
      "uses_reserved": "Đang giữ trên đơn mở",
      "valid_from": "Từ ngày",
      "valid_to": "Đến ngày",
      "value": "Giá trị",
      "variance_tolerance": "Chênh lệch cho phép không cần quản lý",
      "ward_code": "Phường/Xã",
      "waste_percent": "Hao hụt (%)",
      "width": "Chiều rộng"
    },
    "enums": {
      "day_of_week": {
        "1": "Thứ Hai",
        "2": "Thứ Ba",
        "3": "Thứ Tư",
        "4": "Thứ Năm",
        "5": "Thứ Sáu",
        "6": "Thứ Bảy",
        "7": "Chủ nhật"
      },
      "gender": {
        "female": "Nữ",
        "male": "Nam",
        "other": "Khác"
      },
      "invoice_kind": {
        "vat": "Hóa đơn GTGT",
        "sales": "Hóa đơn bán hàng"
      },
      "line_detail": {
        "combined": "Một dòng cho mỗi món hoặc combo, tùy chọn và thành phần ghi trong tên",
        "detailed": "Tùy chọn và thành phần combo trên dòng riêng"
      },
      "entry_type": {
        "earn": "Tích điểm",
        "reverse": "Hoàn điểm tích",
        "redeem": "Thanh toán bằng điểm",
        "refund": "Hoàn điểm",
        "adjust": "Điều chỉnh"
      },
      "reward_method": {
        "percent": "Phần trăm",
        "amount": "Số tiền"
      },
      "reward_scope": {
        "order": "Cả đơn",
        "line": "Một món"
      },
      "funded_by": {
        "brand": "Thương hiệu",
        "store": "Cửa hàng",
        "partner": "Đối tác"
      },
      "audience": {
        "anyone": "Bất kỳ ai có mã",
        "members": "Hội viên có mã",
        "holder": "Chỉ hội viên được cấp",
        "segment": "Khách thuộc một nhóm khách hàng"
      },
      "require_mode": {
        "required": "Bắt buộc: không thanh toán khi chưa mở ca",
        "optional": "Không bắt buộc: gắn vào ca nếu đang mở",
        "off": "Tắt: không dùng ca"
      },
      "open_mode": {
        "manual": "Mở thủ công",
        "auto": "Tự động: bắt đầu và giao ca theo giờ ca"
      },
      "day_close_open_orders": {
        "block": "Chặn đóng ngày: thanh toán, hủy hoặc chuyển đơn trước",
        "carry_over": "Chuyển sang ngày hôm sau"
      },
      "count_scope": {
        "store": "Đếm chung cả cửa hàng",
        "terminal": "Đếm theo từng máy"
      },
      "slot_minutes": {
        "15": "15 phút",
        "30": "30 phút",
        "60": "1 giờ"
      },
      "attendance_mode": {
        "off": "Không dùng",
        "on_login": "Đăng nhập là chấm công vào",
        "separate": "Chấm công riêng"
      },
      "kind": {
        "internal": "Tài xế của cửa hàng",
        "external": "Nhà cung cấp, đặt qua văn phòng chính",
        "rules": "Theo điều kiện",
        "list": "Danh sách tải lên",
        "combined": "Kết hợp nhóm khác",
        "site": "Thiết lập website",
        "home": "Trang chủ",
        "page": "Trang",
        "promotion": "Khuyến mãi",
        "news": "Tin tức",
        "form": "Biểu mẫu"
      },
      "combine_match": {
        "all": "Tất cả các nhóm được chọn",
        "any": "Bất kỳ nhóm được chọn"
      },
      "part_role": {
        "include": "Bao gồm",
        "exclude": "Loại trừ"
      },
      "fee_mode": {
        "manual": "Thu ngân nhập",
        "fixed": "Số tiền cố định",
        "quote": "Theo báo giá của nhà cung cấp"
      },
      "base_behavior": {
        "dine_in": "Ăn tại chỗ",
        "takeaway": "Mang đi",
        "delivery": "Giao hàng",
        "pickup": "Đặt trước lấy tại quán"
      },
      "channel_type": {
        "pos": "POS",
        "website": "Website",
        "app": "Ứng dụng di động",
        "zalo_mini_app": "Zalo mini app",
        "marketplace": "Sàn giao đồ ăn",
        "api": "Open API",
        "qr": "Gọi món bằng QR tại bàn"
      },
      "display": {
        "buttons": "Nút",
        "swatches": "Ô màu",
        "list": "Danh sách"
      },
      "component_type": {
        "auto": "Luôn có",
        "choice": "Khách chọn"
      },
      "connection_type": {
        "tcp": "Mạng (TCP)",
        "usb": "USB",
        "serial": "Cổng nối tiếp",
        "bluetooth": "Bluetooth",
        "provider_sdk": "SDK nhà cung cấp",
        "browser": "Trên máy POS (PDF hoặc màn hình)"
      },
      "density": {
        "terminal": "Máy bán hàng",
        "tablet": "Máy tính bảng",
        "handheld": "Máy cầm tay"
      },
      "screen_class": {
        "terminal": "Máy bán hàng",
        "tablet": "Máy tính bảng",
        "handheld": "Máy cầm tay"
      },
      "device_type": {
        "receipt_printer": "Máy in hóa đơn",
        "kitchen_printer": "Máy in bếp",
        "label_printer": "Máy in tem",
        "cash_drawer": "Ngăn kéo tiền",
        "customer_display": "Màn hình khách",
        "scanner": "Máy quét",
        "payment_terminal": "Máy quẹt thẻ",
        "kds_screen": "Màn hình bếp"
      },
      "document_type": {
        "receipt": "Hóa đơn",
        "bill": "Phiếu tạm tính",
        "kitchen_ticket": "Phiếu bếp",
        "delivery_slip": "Phiếu giao hàng",
        "shift_report": "Báo cáo ca",
        "day_report": "Báo cáo ngày",
        "label": "Tem"
      },
      "engine": {
        "scriban": "Mẫu in",
        "text": "Chỉ chân trang"
      },
      "item_type": {
        "sellable": "Bán",
        "modifier_only": "Chỉ làm tùy chọn",
        "ingredient": "Nguyên liệu"
      },
      "method": {
        "percent": "Phần trăm",
        "fixed": "Số tiền cố định",
        "amount": "Số tiền"
      },
      "method_type": {
        "cash": "Tiền mặt",
        "card": "Thẻ",
        "qr": "Mã QR",
        "bank_transfer": "Chuyển khoản",
        "e_wallet": "Ví điện tử",
        "voucher": "Phiếu quà tặng",
        "points": "Điểm thưởng",
        "pay_later": "Công nợ",
        "other": "Khác"
      },
      "palette_key": {
        "neutral": "Trung tính",
        "blue": "Xanh dương",
        "cyan": "Xanh lơ",
        "teal": "Xanh mòng két",
        "green": "Xanh lá",
        "purple": "Tím",
        "magenta": "Hồng tím",
        "red": "Đỏ",
        "warm-gray": "Xám ấm"
      },
      "paper_width_mm": {
        "58": "58 mm",
        "80": "80 mm"
      },
      "placement": {
        "order_rail": "Thao tác đơn",
        "line_rail": "Thao tác món",
        "command_bar": "Thanh lệnh",
        "more_sheet": "Thêm",
        "order_header": "Đầu đơn",
        "table_sheet": "Thao tác bàn"
      },
      "pricing_method": {
        "fixed": "Giá cố định",
        "sum_of_components": "Tổng giá các món",
        "sum_minus_percent": "Tổng trừ phần trăm",
        "sum_minus_amount": "Tổng trừ số tiền",
        "sum_minus_cheapest": "Miễn phí món rẻ nhất"
      },
      "reason_type": {
        "void": "Hủy món",
        "discount": "Giảm giá",
        "refund": "Hoàn tiền",
        "cash_movement": "Thu chi tiền mặt",
        "order_reject": "Từ chối đơn online",
        "table_reset": "Dọn bàn",
        "stock_adjustment": "Điều chỉnh kho"
      },
      "role": {
        "send": "Gửi",
        "pay": "Thanh toán",
        "bill": "In tạm tính",
        "danger": "Nguy hiểm",
        "tool": "Công cụ"
      },
      "scope": {
        "order": "Cả đơn",
        "line": "Một món",
        "both": "Đơn hoặc món"
      },
      "section_type": {
        "table_map": "Sơ đồ bàn",
        "menu_listing": "Thực đơn",
        "order_list": "Danh sách đơn",
        "online_orders": "Đơn online",
        "functions": "Chức năng",
        "reservations": "Đặt bàn",
        "table_qr": "Gọi món QR tại bàn"
      },
      "match": {
        "word": "Nguyên từ",
        "anywhere": "Mọi vị trí, kể cả trong từ"
      },
      "shape": {
        "rect": "Chữ nhật",
        "square": "Vuông",
        "round": "Tròn"
      },
      "station_type": {
        "kitchen": "Bếp",
        "bar": "Quầy bar",
        "pastry": "Bánh ngọt",
        "expo": "Ra món",
        "other": "Khác"
      },
      "default_language": {
        "vi": "Tiếng Việt",
        "en": "Tiếng Anh"
      },
      "paused_reason": {
        "store_offline": "Cửa hàng mất kết nối",
        "staff_paused": "Nhân viên tạm dừng",
        "capacity": "Quá tải",
        "outside_hours": "Ngoài giờ mở cửa",
        "max_orders": "Quá nhiều đơn đang mở"
      },
      "status": {
        "open": "Đang mở",
        "active": "Hoạt động",
        "inactive": "Ngừng",
        "locked": "Bị khóa",
        "disabled": "Vô hiệu hóa",
        "setup": "Đang thiết lập",
        "closed": "Đã đóng",
        "pending": "Chờ kích hoạt",
        "revoked": "Đã thu hồi",
        "draft": "Nháp",
        "paused": "Tạm dừng",
        "ended": "Đã kết thúc",
        "used_up": "Đã dùng hết",
        "expired": "Hết hạn",
        "cancelled": "Đã hủy",
        "blocked": "Bị khóa",
        "lost": "Bị mất",
        "published": "Đã xuất bản",
        "unpublished": "Đã gỡ"
      },
      "step_type": {
        "select_table": "Chọn bàn",
        "enter_guests": "Nhập số khách",
        "select_customer": "Chọn khách hàng",
        "prompt": "Hỏi thông tin",
        "take_order": "Gọi món",
        "send_to_kitchen": "Gửi bếp",
        "print_bill": "In tạm tính",
        "take_payment": "Thanh toán",
        "assign_driver": "Chọn tài xế",
        "close": "Đóng đơn",
        "accept_order": "Nhận đơn trực tuyến",
        "mark_ready": "Báo món xong",
        "hand_over": "Giao cho khách",
        "out_for_delivery": "Giao cho tài xế",
        "deliver": "Đã giao xong"
      },
      "target_type": {
        "item": "Một món",
        "deal": "Một combo",
        "page": "Trang khác"
      },
      "terminal_type": {
        "fixed_pos": "Máy POS cố định",
        "tablet": "Máy tính bảng",
        "handheld": "Máy cầm tay",
        "kds": "Màn hình bếp",
        "kiosk": "Kiosk"
      },
      "theme": {
        "g10": "Sáng",
        "g100": "Tối"
      },
      "trigger_event": {
        "order_start": "Bắt đầu đơn",
        "item_added": "Thêm món",
        "before_payment": "Trước khi thanh toán"
      }
    },
    "resources": {
      "org_brand": "Thương hiệu",
      "org_legal_entity": "Pháp nhân",
      "org_store": "Cửa hàng",
      "org_store_opening_hours": "Giờ mở cửa",
      "org_store_group": "Nhóm cửa hàng",
      "org_store_group_member": "Cửa hàng",
      "org_app_user": "Nhân viên",
      "org_user_store_role": "Phân quyền",
      "org_role": "Vai trò",
      "org_role_permission": "Quyền",
      "geo_country": "Quốc gia",
      "geo_admin_level": "Cấp địa chỉ",
      "geo_admin_unit_type": "Loại đơn vị hành chính",
      "geo_region": "Vùng",
      "geo_admin_division": "Tỉnh, quận/huyện và phường/xã",
      "geo_postal_code": "Mã bưu chính",
      "catalog_item": "Món và hàng hóa",
      "catalog_item_uom": "Đơn vị bán",
      "catalog_item_group": "Nhóm biến thể",
      "catalog_item_barcode": "Mã vạch",
      "catalog_item_category_map": "Nhóm hàng",
      "catalog_item_modifier_group": "Nhóm tùy chọn",
      "catalog_recipe": "Định lượng",
      "catalog_store_recipe": "Định lượng theo cửa hàng",
      "catalog_item_cost": "Giá vốn chuẩn",
      "catalog_item_category": "Nhóm hàng",
      "catalog_modifier_group": "Nhóm tùy chọn",
      "catalog_modifier": "Tùy chọn",
      "catalog_deal": "Combo",
      "catalog_deal_cost": "Giá vốn chuẩn",
      "catalog_deal_component": "Thành phần",
      "catalog_deal_component_item": "Lựa chọn",
      "catalog_deal_availability": "Thời gian và nơi bán",
      "catalog_deal_rule": "Quy tắc",
      "catalog_tax_category": "Nhóm thuế",
      "catalog_tax_rate": "Thuế suất",
      "catalog_uom": "Đơn vị tính",
      "catalog_uom_conversion": "Quy đổi đơn vị",
      "menu_menu": "Thực đơn",
      "menu_menu_entry": "Món trong thực đơn",
      "menu_menu_assignment": "Áp dụng",
      "menu_menu_layout": "Bố cục thực đơn",
      "menu_menu_page": "Trang",
      "menu_menu_button": "Nút",
      "menu_price_list": "Bảng giá",
      "menu_price_list_entry": "Giá",
      "menu_menu_price_list": "Thực đơn",
      "menu_price_list_assignment": "Áp dụng",
      "config_sales_channel": "Kênh bán",
      "config_sale_type": "Loại bán hàng",
      "config_order_flow": "Quy trình bán",
      "config_order_flow_step": "Các bước",
      "config_pos_layout": "Bố cục POS",
      "config_pos_layout_section": "Khu vực màn hình",
      "config_pos_profile": "Hồ sơ POS",
      "config_pos_profile_sale_type": "Loại bán hàng",
      "config_pos_button": "Nút chức năng",
      "config_payment_method": "Phương thức thanh toán",
      "config_payment_method_assignment": "Nơi áp dụng",
      "config_delivery_service": "Dịch vụ giao hàng",
      "config_delivery_service_assignment": "Nơi áp dụng",
      "config_charge_type": "Phí và phụ thu",
      "config_brand_site": "Website thương hiệu",
      "config_brand_site_domain": "Tên miền",
      "config_delivery_fee_rule": "Phí giao hàng",
      "online_channel_store": "Cửa hàng bán online",
      "online_blocked_word": "Từ bị chặn",
      "online_channel_store_hours": "Giờ nhận đơn online",
      "membership_member_club": "Chương trình hội viên",
      "membership_member_scheme": "Hạng hội viên",
      "membership_point_rule": "Quy tắc tích điểm",
      "membership_member_account": "Tài khoản hội viên",
      "membership_member_contact": "Người dùng thẻ",
      "membership_member_card": "Thẻ hội viên",
      "promotions_promotion": "Mã giảm giá",
      "promotions_coupon_batch": "Lô mã",
      "promotions_coupon": "Mã",
      "membership_gift_voucher_batch": "Phiếu quà tặng",
      "membership_gift_voucher": "Phiếu",
      "membership_reward_program": "Chương trình ưu đãi",
      "crm_segment": "Nhóm khách hàng",
      "crm_segment_part": "Kết hợp từ",
      "cms_page": "Trang",
      "config_discount_preset": "Mẫu giảm giá",
      "config_reason_code": "Lý do",
      "config_prompt": "Câu hỏi",
      "config_prompt_answer": "Câu trả lời",
      "config_prompt_trigger": "Khi nào hỏi",
      "config_document_template": "Mẫu in",
      "config_template_assignment": "Nơi áp dụng",
      "einvoice_einvoice_profile": "Mẫu hóa đơn điện tử",
      "einvoice_profile_store": "Cửa hàng",
      "store_terminal": "Máy bán hàng",
      "store_device": "Máy in và thiết bị",
      "store_station": "Khu bếp và quầy",
      "store_station_routing": "Món chuyển đến",
      "store_table_area": "Khu vực bàn",
      "store_floor_plan": "Sơ đồ bàn",
      "store_dining_table": "Bàn",
      "store_section_floor_plan": "Hiển thị ở khu vực POS",
      "store_shift_definition": "Ca làm việc",
      "store_shift_settings": "Thiết lập ca",
      "store_item_availability": "Món tạm hết",
      "store_delivery_service_availability": "Dịch vụ giao hàng tạm ngưng",
      "org_permission": "Quyền",
      "config_pos_action": "Chức năng POS",
      "integration_provider_account": "Tài khoản hóa đơn điện tử"
    },
    "groups": {
      "org": "Tổ chức",
      "catalog": "Danh mục hàng hóa",
      "menu": "Thực đơn và giá",
      "pos": "Thiết lập POS",
      "tables": "Bàn",
      "geo": "Địa điểm",
      "promotions": "Mã giảm giá và phiếu quà tặng",
      "loyalty": "Khách hàng thân thiết",
      "marketing": "Tiếp thị",
      "cms": "CMS",
      "einvoice": "Hóa đơn điện tử",
      "online": "Bán hàng online",
      "devices": "Thiết bị và in",
      "stock": "Tình trạng món",
      "shifts": "Ca làm việc"
    }
  },
  "orders": {
    "title": "Đơn hàng",
    "create": {
      "title": "Đơn mới",
      "saleType": "Hình thức bán",
      "menu": "Thực đơn",
      "searchItems": "Tìm món",
      "cart": "Đơn này",
      "emptyCart": "Chọn món từ thực đơn.",
      "totalHint": "Tổng tiền được tính khi lưu đơn.",
      "add": "Thêm",
      "noPrice": "Chưa có giá",
      "unit": "Đơn vị",
      "openPrice": "Giá",
      "submit": "Tạo đơn",
      "chooseSaleType": "Chọn hình thức bán để xem thực đơn.",
      "min": "Chọn ít nhất {{count}}",
      "max": "Chọn tối đa {{count}}"
    },
    "back": "Đơn hàng",
    "search": "Tìm theo số đơn, tên hoặc số điện thoại khách",
    "all": "Tất cả",
    "readOnly": "Đơn hàng được sửa tại cửa hàng. Đây là bản sao ở văn phòng chính.",
    "hoEmpty": "Đơn hàng sẽ hiện ở đây khi cửa hàng gửi về văn phòng chính.",
    "filters": {
      "status": "Trạng thái",
      "saleType": "Hình thức bán",
      "store": "Cửa hàng",
      "from": "Từ ngày",
      "to": "Đến ngày",
      "openedAt": "Ngày mở",
      "member": "Hội viên",
      "withMember": "Có hội viên",
      "withoutMember": "Không có hội viên",
      "payment": "Thanh toán",
      "kitchen": "Bếp",
      "fulfilment": "Giao hàng"
    },
    "columns": {
      "number": "Số đơn",
      "openedAt": "Giờ mở",
      "saleType": "Hình thức",
      "guests": "Số khách",
      "customer": "Khách hàng",
      "status": "Trạng thái",
      "total": "Tổng tiền",
      "balance": "Còn phải trả",
      "store": "Cửa hàng",
      "member": "Hội viên"
    },
    "status": {
      "open": "Đang mở",
      "completed": "Hoàn tất",
      "voided": "Đã huỷ",
      "merged": "Đã gộp",
      "cancelled": "Đã huỷ bỏ"
    },
    "paymentStatus": {
      "unpaid": "Chưa thanh toán",
      "partially_paid": "Đã trả một phần",
      "paid": "Đã thanh toán",
      "overpaid": "Trả dư"
    },
    "kitchenStatus": {
      "not_sent": "Chưa gửi bếp",
      "partially_sent": "Đã gửi bếp một phần",
      "sent": "Đã gửi bếp",
      "in_progress": "Bếp đang làm",
      "ready": "Bếp đã xong",
      "served": "Đã phục vụ"
    },
    "fulfilmentStatus": {
      "waiting": "Đang chờ",
      "ready": "Sẵn sàng",
      "out_for_delivery": "Đang giao",
      "handed_over": "Đã giao cho khách",
      "delivered": "Đã giao tới nơi",
      "served": "Đã phục vụ",
      "failed": "Giao không thành công"
    },
    "statusKinds": {
      "order": "Trạng thái đơn",
      "payment": "Trạng thái thanh toán",
      "kitchen": "Trạng thái bếp",
      "fulfilment": "Trạng thái giao"
    },
    "summary": {
      "subtotal": "Tiền món",
      "discounts": "Giảm giá",
      "charges": "Phụ phí",
      "taxIncluded": "Đã gồm thuế",
      "tax": "Thuế",
      "rounding": "Làm tròn",
      "total": "Tổng tiền",
      "paid": "Đã trả",
      "balance": "Còn phải trả",
      "guests": "Số khách",
      "openedAt": "Giờ mở",
      "paidAt": "Giờ thanh toán",
      "promisedAt": "Hẹn giao lúc",
      "customer": "Khách hàng",
      "customerNote": "Ghi chú của khách",
      "kitchenNote": "Ghi chú cho bếp",
      "menu": "Thực đơn",
      "priceList": "Bảng giá",
      "member": "Hội viên",
      "openMember": "Mở tài khoản hội viên"
    },
    "tabs": {
      "items": "Món",
      "payments": "Thanh toán",
      "delivery": "Giao hàng",
      "history": "Lịch sử"
    },
    "actions": {
      "addItems": "Thêm món",
      "editDetails": "Sửa thông tin",
      "changeSaleType": "Đổi hình thức bán",
      "addDiscount": "Thêm giảm giá",
      "addCharge": "Thêm phụ phí",
      "recordPayment": "Ghi nhận thanh toán",
      "voidOrder": "Huỷ đơn",
      "editLine": "Sửa món",
      "voidLine": "Huỷ món",
      "remove": "Bỏ",
      "refund": "Hoàn tiền",
      "dispatch": "Giao đi",
      "updateStatus": "Cập nhật trạng thái",
      "more": "Thao tác khác"
    },
    "lines": {
      "item": "Món",
      "amount": "Thành tiền",
      "unit": "Đơn vị",
      "tax": "Thuế suất",
      "taxAmount": "Tiền thuế",
      "quantity": "SL",
      "unitPrice": "Đơn giá",
      "discount": "Giảm giá",
      "total": "Thành tiền",
      "note": "Ghi chú",
      "options": "Tuỳ chọn",
      "status": "Trạng thái",
      "empty": "Chưa có món.",
      "statusValues": {
        "new": "Chưa gửi",
        "sent": "Đã gửi",
        "voided": "Đã huỷ"
      }
    },
    "discounts": {
      "title": "Giảm giá",
      "preset": "Mẫu giảm giá",
      "manual": "Nhập giảm giá",
      "name": "Tên",
      "method": "Loại",
      "percent": "Phần trăm",
      "amount": "Số tiền",
      "value": "Giá trị",
      "reason": "Lý do",
      "appliesTo": "Áp dụng cho",
      "wholeOrder": "Cả đơn"
    },
    "charges": {
      "title": "Phụ phí",
      "type": "Phụ phí"
    },
    "details": {
      "guests": "Số khách",
      "customer": "Khách hàng",
      "name": "Tên",
      "phone": "Số điện thoại",
      "province": "Tỉnh, thành phố",
      "ward": "Phường, xã",
      "street": "Số nhà, đường",
      "addressNote": "Ghi chú địa chỉ",
      "promisedAt": "Giờ hẹn",
      "customerNote": "Ghi chú của khách",
      "kitchenNote": "Ghi chú cho bếp"
    },
    "saleType": {
      "title": "Đổi hình thức bán",
      "hint": "Giá, phụ phí và thuế sẽ theo hình thức bán mới."
    },
    "void": {
      "orderTitle": "Huỷ đơn",
      "lineTitle": "Huỷ món",
      "reason": "Lý do",
      "note": "Ghi chú",
      "unsentHint": "Món này chưa gửi bếp nên sẽ được bỏ khỏi đơn.",
      "orderHint": "Đơn vẫn được giữ lại cùng lịch sử và được đánh dấu đã huỷ."
    },
    "payments": {
      "method": "Phương thức",
      "amount": "Số tiền",
      "tendered": "Tiền khách đưa",
      "change": "Tiền thừa",
      "reference": "Mã giao dịch",
      "kind": "Loại",
      "paidAt": "Thời gian",
      "receivedBy": "Người nhận",
      "refundable": "Có thể hoàn",
      "status": "Trạng thái",
      "empty": "Chưa có thanh toán.",
      "kinds": {
        "payment": "Thanh toán",
        "refund": "Hoàn tiền"
      },
      "changeDue": "Tiền thừa trả khách: {{amount}}",
      "balanceDue": "Còn phải trả: {{amount}}",
      "posOnly": "Nhận tại máy POS"
    },
    "methodTypes": {
      "cash": "Tiền mặt",
      "card": "Thẻ",
      "qr": "QR",
      "bank_transfer": "Chuyển khoản",
      "e_wallet": "Ví điện tử",
      "voucher": "Phiếu quà tặng",
      "points": "Điểm",
      "pay_later": "Trả sau",
      "other": "Khác"
    },
    "refund": {
      "title": "Hoàn tiền",
      "amount": "Số tiền hoàn",
      "reason": "Lý do",
      "max": "Tối đa {{amount}}",
      "hint": "Hoàn tiền tạo một bản ghi mới; khoản thanh toán và đơn đã thanh toán được giữ nguyên."
    },
    "delivery": {
      "empty": "Đơn này chưa được giao đi.",
      "notDelivery": "Chỉ đơn giao hàng mới được giao đi.",
      "method": "Hình thức",
      "methods": {
        "own_driver": "Tài xế của cửa hàng",
        "provider": "Đơn vị giao hàng"
      },
      "driverName": "Tài xế",
      "driverPhone": "Số điện thoại tài xế",
      "providerCode": "Mã đơn vị giao hàng",
      "providerReference": "Mã vận đơn",
      "trackingUrl": "Liên kết theo dõi",
      "track": "Theo dõi",
      "fee": "Phí giao hàng",
      "address": "Địa chỉ",
      "status": "Trạng thái",
      "newStatus": "Trạng thái mới",
      "failureReason": "Lý do giao không được",
      "note": "Ghi chú",
      "attempt": "Lần giao {{number}}",
      "statuses": {
        "pending": "Đang chờ tài xế",
        "assigned": "Đã có tài xế",
        "picked_up": "Đã lấy hàng",
        "out_for_delivery": "Đang giao",
        "delivered": "Đã giao",
        "failed": "Giao không được",
        "cancelled": "Đã huỷ",
        "searching_driver": "Đang tìm tài xế",
        "no_driver": "Không có tài xế",
        "cancel_requested": "Đang huỷ",
        "returned": "Đã trả lại"
      },
      "knownProvider": "Nhà cung cấp đã dùng",
      "providerName": "Tên nhà cung cấp",
      "booking": "Đặt giao",
      "bookingModes": {
        "provider": "Qua nhà cung cấp",
        "manual": "Nhập tay"
      },
      "eta": "Thời gian dự kiến",
      "etaMinutes": "khoảng {{minutes}} phút"
    },
    "history": {
      "empty": "Chưa có lịch sử.",
      "by": "bởi {{name}}",
      "unknownUser": "không rõ người thực hiện",
      "events": {
        "order.created": "Tạo đơn",
        "order.line_added": "Thêm món",
        "order.line_changed": "Sửa món",
        "order.line_voided": "Huỷ món",
        "order.discount_added": "Thêm giảm giá",
        "order.discount_removed": "Bỏ giảm giá",
        "order.charge_added": "Thêm phụ phí",
        "order.charge_removed": "Bỏ phụ phí",
        "order.details_changed": "Sửa thông tin",
        "order.sale_type_changed": "Đổi hình thức bán",
        "order.payment_recorded": "Ghi nhận thanh toán",
        "order.paid": "Đã thanh toán đủ",
        "order.refunded": "Hoàn tiền",
        "order.voided": "Huỷ đơn",
        "order.delivery_created": "Giao đi",
        "order.delivery_status_changed": "Cập nhật giao hàng",
        "order.sent": "Gửi bếp",
        "order.payment_removed": "Bỏ khoản thanh toán"
      }
    },
    "approval": {
      "voidLine": "Huỷ {{name}}",
      "voidOrder": "Huỷ đơn {{number}}",
      "discount": "Giảm giá cho đơn {{number}}",
      "refund": "Hoàn {{amount}}"
    },
    "createOrder": "Tạo đơn",
    "memberOnly": "Đơn của hội viên {{member}}",
    "allMembers": "Hiện mọi đơn",
    "einvoice": {
      "label": "Hóa đơn điện tử",
      "loading": "Đang hỏi văn phòng chính…",
      "number": "Số {{number}}",
      "seller": "MST bên bán {{taxCode}}",
      "lookupCode": "Mã tra cứu {{code}}",
      "lookUp": "Tra cứu",
      "status": {
        "waiting": "Chưa đến văn phòng chính",
        "pending": "Đang phát hành",
        "issued": "Đã phát hành",
        "failed": "Văn phòng chính đang xử lý",
        "not_configured": "Cửa hàng chưa có cấu hình hóa đơn điện tử"
      }
    },
    "afterTax": "sau VAT"
  },
  "transactions": {
    "filters": {
      "provider": "Nhà cung cấp",
      "from": "Từ ngày",
      "to": "Đến ngày",
      "store": "Cửa hàng",
      "status": "Trạng thái",
      "kind": "Loại",
      "methodType": "Hình thức",
      "all": "Tất cả",
      "noProvider": "Không qua nhà cung cấp (tiền mặt, chuyển khoản trực tiếp)",
      "ownDriver": "Tài xế của cửa hàng",
      "active": "Đang xử lý",
      "date": "Ngày"
    },
    "payments": {
      "title": "Giao dịch thanh toán",
      "search": "Tìm theo số đơn, mã giao dịch hoặc 4 số cuối thẻ",
      "columns": {
        "paidAt": "Thời gian",
        "order": "Đơn",
        "store": "Cửa hàng",
        "provider": "Nhà cung cấp",
        "method": "Phương thức",
        "kind": "Loại",
        "amount": "Số tiền",
        "reference": "Mã giao dịch",
        "status": "Trạng thái",
        "confirmation": "Xác nhận bởi",
        "receivedBy": "Người nhận"
      },
      "summary": {
        "count": "{{count}} giao dịch",
        "paid": "Đã thu",
        "refunded": "Đã hoàn",
        "net": "Thực thu"
      },
      "confirmation": {
        "auto": "Tự động",
        "terminal": "Máy quẹt thẻ",
        "provider_callback": "Nhà cung cấp",
        "manual": "Nhân viên"
      },
      "statuses": {
        "pending": "Đang chờ",
        "approved": "Thành công",
        "declined": "Bị từ chối",
        "voided": "Đã huỷ",
        "failed": "Thất bại"
      },
      "empty": "Không có thanh toán nào phù hợp."
    },
    "shipping": {
      "title": "Giao dịch giao hàng",
      "search": "Tìm theo số đơn, mã vận đơn, tài xế hoặc khách hàng",
      "columns": {
        "createdAt": "Giờ giao đi",
        "order": "Đơn",
        "store": "Cửa hàng",
        "provider": "Nhà cung cấp",
        "reference": "Mã vận đơn",
        "driver": "Tài xế",
        "customer": "Khách hàng",
        "fee": "Phí",
        "status": "Trạng thái",
        "deliveredAt": "Giờ giao xong"
      },
      "summary": {
        "count": "{{count}} chuyến",
        "active": "Đang giao",
        "delivered": "Đã giao",
        "failed": "Thất bại",
        "fees": "Phí"
      },
      "empty": "Không có chuyến giao nào phù hợp."
    },
    "detail": {
      "history": "Lịch sử",
      "back": "Quay lại",
      "paymentTitle": "Thanh toán {{reference}}",
      "refundTitle": "Hoàn tiền {{reference}}",
      "shippingTitle": "Giao hàng cho đơn {{number}}",
      "facts": {
        "order": "Đơn",
        "store": "Cửa hàng",
        "provider": "Nhà cung cấp",
        "method": "Phương thức",
        "kind": "Loại",
        "amount": "Số tiền",
        "tendered": "Tiền khách đưa",
        "change": "Tiền thừa",
        "reference": "Mã giao dịch",
        "qrReference": "Mã QR",
        "card": "Thẻ",
        "status": "Trạng thái",
        "confirmation": "Xác nhận bởi",
        "receivedBy": "Người nhận",
        "paidAt": "Thời gian",
        "refundable": "Có thể hoàn",
        "refundOf": "Hoàn cho",
        "driver": "Tài xế",
        "customer": "Khách hàng",
        "address": "Địa chỉ",
        "fee": "Phí",
        "createdAt": "Giờ giao đi",
        "pickedUpAt": "Giờ lấy hàng",
        "deliveredAt": "Giờ giao xong",
        "failureReason": "Lý do giao không được",
        "tracking": "Theo dõi"
      },
      "events": {
        "recorded": "Ghi nhận",
        "approved": "Được duyệt",
        "declined": "Bị từ chối",
        "voided": "Đã huỷ",
        "failed": "Thất bại",
        "refunded": "Hoàn tiền",
        "removed": "Đã bỏ"
      },
      "refunds": "Các lần hoàn tiền",
      "noRefunds": "Chưa hoàn tiền.",
      "otherAttempts": "Các lần giao khác của đơn này",
      "timeline": "Diễn biến",
      "noEvents": "Chưa có lịch sử.",
      "by": "bởi {{name}}",
      "system": "hệ thống",
      "open": "Xem lịch sử"
    }
  },
  "pos": {
    "menu": {
      "emptyPage": "Trang này chưa có món.",
      "soldOut": "Hết món",
      "noPrice": "Chưa có giá",
      "search": "Tìm món",
      "results": "Kết quả tìm kiếm",
      "noResults": "Không có món nào khớp “{{query}}”.",
      "categories": "Nhóm món",
      "scanned": "Đã thêm {{name}}",
      "scanUnknown": "Không có món với mã vạch {{code}}.",
      "dealUnavailable": "Hiện không bán"
    },
    "ticket": {
      "label": "Phiếu gọi món",
      "tools": "Thao tác với đơn",
      "dealItem": "{{quantity}} × {{name}}",
      "option": "{{quantity}} × {{name}}",
      "empty": "Chạm vào món trong thực đơn để bắt đầu đơn.",
      "voided": "Đã huỷ",
      "held": "Đang giữ",
      "subtotal": "Tạm tính",
      "discounts": "Giảm giá",
      "taxIncluded": "Đã gồm thuế",
      "tax": "Thuế",
      "rounding": "Làm tròn",
      "total": "Tổng cộng",
      "paid": "Đã trả",
      "balance": "Còn lại",
      "discount": "Giảm giá",
      "itemDiscounts": "Giảm giá món",
      "deliveryCharge": "Phí giao hàng"
    },
    "modifiers": {
      "optional": "Không bắt buộc",
      "upTo_one": "Tối đa {{count}}",
      "upTo_other": "Tối đa {{count}}",
      "choose_one": "Chọn {{count}}",
      "choose_other": "Chọn {{count}}",
      "atLeast_one": "Ít nhất {{count}}",
      "atLeast_other": "Ít nhất {{count}}",
      "between": "Chọn {{min}}–{{max}}",
      "groups": "Nhóm tuỳ chọn",
      "needsChoice": "Hãy chọn để tiếp tục",
      "quantity": "Số lượng",
      "less": "Bớt một",
      "more": "Thêm một",
      "lessHint": "Nhấp chuột phải, nhấn giữ hoặc nhấn Delete để bớt một.",
      "times": "× {{count}}",
      "add": "Thêm · {{price}}",
      "save": "Lưu · {{price}}"
    },
    "deal": {
      "includedOptions": "Tùy chọn cho {{name}}, có sẵn trong combo",
      "chooseOptions": "Chọn tùy chọn",
      "included": "Đã gồm",
      "chosen": "Đã chọn",
      "remove": "Bỏ {{name}}",
      "add": "Thêm · {{price}}",
      "addNoPrice": "Thêm combo",
      "choosePrompt": "Chọn món để xem giá",
      "pricing": "Đang tính giá…",
      "times": "× {{count}}",
      "freeChoice": "Đã gồm trong giá",
      "includes": "Đã gồm: {{items}}"
    },
    "actions": {
      "back": "Quay lại",
      "more": "Thêm",
      "notAvailable": "Máy này chưa có chức năng này.",
      "labels": {
        "send": "Gửi bếp",
        "pay": "Thanh toán",
        "print_bill": "In hoá đơn",
        "preview_bill": "Xem hoá đơn",
        "hold_fire": "Giữ và gọi món",
        "order_note": "Ghi chú đơn",
        "order_discount": "Giảm giá",
        "add_charge": "Thêm phụ phí",
        "remove_charge": "Bỏ phụ phí",
        "void_order": "Huỷ đơn",
        "split_bill": "Tách hoá đơn",
        "merge_bills": "Gộp hoá đơn",
        "change_sale_type": "Hình thức",
        "guest_count": "Số khách",
        "member_lookup": "Hội viên",
        "redeem_points": "Đổi điểm",
        "apply_code": "Mã giảm giá",
        "line_quantity": "Số lượng",
        "line_note": "Ghi chú",
        "line_seat": "Ghế",
        "line_course": "Lượt món",
        "line_discount": "Giảm giá",
        "edit_modifiers": "Tuỳ chọn",
        "repeat_line": "Gọi thêm",
        "void_line": "Huỷ món",
        "transfer_table": "Chuyển bàn",
        "merge_tables": "Gộp bàn",
        "split_table": "Tách bàn",
        "take_over_table": "Nhận bàn",
        "reset_table": "Dọn bàn",
        "no_sale": "Mở két",
        "refund": "Hoàn tiền",
        "reprint_receipt": "In lại hóa đơn thanh toán",
        "order_customer": "Khách hàng",
        "order_invoice": "Hóa đơn VAT"
      },
      "sendCount_one": "Gửi bếp · {{count}} món mới",
      "sendCount_other": "Gửi bếp · {{count}} món mới",
      "payAmount": "Thanh toán · {{amount}}"
    },
    "payment": {
      "title": "Thanh toán",
      "balanceDue": "Còn phải trả",
      "quickCash": "Tiền mặt nhanh",
      "exact": "Đủ tiền",
      "tenders": "Hình thức thanh toán",
      "applied": "Đã thanh toán",
      "remove": "Bỏ {{tender}}",
      "reference": "Mã giao dịch {{tender}}",
      "confirm": "Xác nhận {{tender}}",
      "back": "Về thực đơn",
      "completed": "Đã thanh toán",
      "changeDue": "Tiền thừa trả khách",
      "noChange": "Không có tiền thừa",
      "nextOrder": "Đơn tiếp theo",
      "done": "Xong",
      "returning": "Đang về {{section}}…",
      "stay": "Ở lại màn hình này",
      "amount": "Số tiền thanh toán",
      "remaining": "Còn lại {{amount}} sau lần này",
      "useBalance": "Dùng toàn bộ số còn lại",
      "payWith": "Thanh toán bằng",
      "fullHint": "Toàn bộ số còn lại. Dùng bàn phím số để nhập số khác.",
      "overpay": "Lớn hơn số còn lại: tiền mặt trả lại {{amount}}; các hình thức khác chỉ thu đúng số còn lại.",
      "voucherCode": "Mã phiếu quà tặng",
      "voucherPartial": "Phiếu quà tặng trả được {{amount}}; còn lại {{due}}.",
      "quantityMax": "Tối đa {{max}}.",
      "pointsAvailable": "{{points}} điểm có thể dùng",
      "pointValue": "1 điểm = {{amount}}",
      "pointsMin": "ít nhất {{points}}",
      "pointsMaxShare": "tối đa {{percent}}% giá trị món chưa VAT",
      "pointsNoOtherDiscounts": "không dùng cùng giảm giá khác",
      "redemptionExcludedByDeal": "Combo trên đơn này không thanh toán được bằng phiếu quà tặng.",
      "qr": {
        "title": "Quét mã để thanh toán",
        "amount": "Số tiền cần thanh toán",
        "preparing": "Đang tạo mã QR…",
        "waiting": "Đang chờ khách thanh toán bằng {{provider}}",
        "expiresIn": "Còn hiệu lực {{time}}",
        "check": "Kiểm tra thanh toán",
        "checkSoon": "Kiểm tra thanh toán sau {{seconds}} giây",
        "cancel": "Huỷ mã QR",
        "paid": "Đã thanh toán",
        "failed": "Thanh toán không thành công. Vui lòng chọn hình thức khác.",
        "expired": "Mã QR đã hết hạn trước khi được thanh toán. Vui lòng chọn hình thức khác.",
        "cancelled": "Đã huỷ mã QR. Vui lòng chọn hình thức khác.",
        "refunded": "Khách đã thanh toán sau khi mã QR kết thúc; văn phòng chính sẽ hoàn tiền. Vui lòng chọn hình thức khác.",
        "otherTender": "Chọn hình thức khác",
        "codeLabel": "Mã QR để thanh toán bằng {{provider}}"
      },
      "paidAmount": "Số tiền",
      "tendersHint": "Chạm phương thức để thanh toán số tiền bên phải"
    },
    "home": {
      "newOrder": "Đơn mới",
      "empty": "Chưa có đơn nào ở đây. Chạm Đơn mới để bắt đầu.",
      "loadFailed": "Không tải được danh sách đơn. Sẽ thử lại sau vài giây.",
      "quickSale": "Bán nhanh",
      "quickSaleHint": "Mở một đơn {{saleType}} mới.",
      "filters": {
        "label": "Hiển thị",
        "active": "Đơn đang mở",
        "today": "Tất cả hôm nay"
      },
      "columns": {
        "number": "Đơn",
        "customer": "Khách hàng",
        "status": "Trạng thái",
        "time": "Giờ mở",
        "amount": "Tổng tiền",
        "saleType": "Hình thức"
      },
      "businessDay": "Ngày kinh doanh",
      "changeTerminal": "Đổi máy POS",
      "logOff": "Đăng xuất",
      "noSections": "Cấu hình POS này chưa có mục nào. Nhờ văn phòng chính thêm.",
      "search": "Tìm theo số đơn hoặc khách hàng",
      "hoDataTaken": "Nhận lần cuối {{time}}",
      "hoDataNever": "Chưa nhận dữ liệu từ văn phòng trung tâm",
      "syncNow": "Đồng bộ ngay",
      "syncNowDone_one": "Đã cập nhật: nhận {{count}} thay đổi.",
      "syncNowDone_other": "Đã cập nhật: nhận {{count}} thay đổi.",
      "syncNowMore": "Đã nhận thay đổi. Phần còn lại tiếp tục được nhận trong nền.",
      "showMore_one": "Xem thêm (còn {{count}})",
      "showMore_other": "Xem thêm (còn {{count}})"
    },
    "terminal": {
      "title": "Thiết lập máy POS",
      "hint": "Quản lý đăng nhập và chọn máy này là máy POS nào. Lựa chọn được lưu trên máy.",
      "choose": "Chọn máy POS",
      "none": "Cửa hàng chưa có máy POS nào. Thêm máy trong cổng quản trị cửa hàng, mục Thiết bị.",
      "notAllowed": "Chỉ quản lý có quyền thiết lập thiết bị mới chọn được máy POS.",
      "use": "Dùng {{code}}",
      "cancel": "Giữ máy POS hiện tại",
      "app": "Ứng dụng POS trên máy này",
      "forgetStore": "Kết nối cửa hàng khác",
      "exitApp": "Đóng ứng dụng POS"
    },
    "order": {
      "newOrder": "Đơn mới",
      "back": "Quay lại",
      "sent": "Đã gửi bếp",
      "removed": "Đã bỏ {{name}}",
      "undo": "Hoàn tác",
      "conflict": "Đơn vừa được người khác thay đổi và đã được tải lại; hãy kiểm tra rồi thử lại.",
      "readOnly": "Không kết nối được máy chủ cửa hàng. Đơn chỉ xem được cho đến khi kết nối lại.",
      "quantity": "Số lượng {{name}}",
      "note": "Ghi chú cho {{name}}",
      "orderNote": "Ghi chú cho bếp",
      "save": "Lưu",
      "reason": "Lý do",
      "discountTitle": "Giảm giá",
      "lineDiscountTitle": "Giảm giá {{name}}",
      "presets": "Mẫu giảm giá",
      "enterDiscount": "Hoặc nhập giảm giá",
      "percent": "Phần trăm",
      "amount": "Số tiền",
      "apply": "Áp dụng giảm giá",
      "chargeTitle": "Thêm phụ phí",
      "saleTypeTitle": "Đổi hình thức bán",
      "saleTypeHint": "Giá, phụ phí và thuế sẽ theo hình thức mới.",
      "voidOrderTitle": "Huỷ đơn {{number}}",
      "voidOrderHint": "Chọn lý do. Đơn vẫn được giữ lại cùng lịch sử.",
      "voidLineTitle": "Huỷ {{name}}",
      "voidLineHint": "Món này đã gửi bếp. Chọn lý do.",
      "confirmVoid": "Huỷ đơn",
      "guests_one": "{{count}} khách",
      "guests_other": "{{count}} khách",
      "cancel": "Huỷ bỏ",
      "noLines": "Thêm món trước khi gửi bếp.",
      "nothingNew": "Không có món mới để gửi.",
      "paid": "Đơn đã thanh toán. Mọi thay đổi là hoàn tiền, làm trong cổng quản trị cửa hàng.",
      "ticket": "Phiếu · {{count}}",
      "menu": "Thực đơn",
      "removeNote": "Xóa ghi chú",
      "appliedDiscounts": "Giảm giá đã áp dụng",
      "removeDiscount": "Bỏ {{name}}",
      "removeDiscountTitle": "Bỏ giảm giá",
      "removeDiscountBody": "{{name}} sẽ được bỏ khỏi đơn.",
      "noteRemoved": "Đã xóa ghi chú",
      "quantityPrefix": "Số lượng {{count}}",
      "notApplicable": "Không áp dụng",
      "onOrder": "Đã có trong đơn",
      "presetOrderOnly": "Chỉ áp dụng cho cả đơn.",
      "presetLineOnly": "Chỉ áp dụng cho từng món.",
      "adjustmentRemoved": "Đã bỏ {{name}}: {{reason}}",
      "chargeEnter": "Nhập số tiền",
      "chargeValueTitle": "{{name}}: nhập số tiền",
      "chargeValueHint": "Nhập số tiền cho đơn này.",
      "chargeValueMax": "Nhập số tiền cho đơn này, tối đa {{max}}.",
      "chargeApply": "Thêm {{value}}",
      "chargeApplyEmpty": "Thêm phụ phí",
      "presetEnterAmount": "Nhập số tiền",
      "presetEnterPercent": "Nhập phần trăm",
      "discountValueTitle": "{{name}}: nhập mức giảm",
      "discountValueHint": "Nhập số tiền giảm.",
      "discountValuePercentHint": "Nhập phần trăm giảm.",
      "discountValueMax": "Nhập số tiền giảm, tối đa {{max}}.",
      "discountValuePercentMax": "Nhập phần trăm giảm, tối đa {{max}}.",
      "discountApplyValue": "Giảm {{value}}",
      "discountReasonTitle": "{{name}}: chọn lý do",
      "discountReasonHint": "Giảm giá này cần lý do.",
      "discountReasonNone": "Giảm giá này cần lý do nhưng chưa có lý do nào. Hãy nhờ trụ sở thêm lý do giảm giá.",
      "overpaid": "Khách đã trả nhiều hơn giá trị đơn hiện tại: hoàn lại {{amount}} trước khi hoàn tất đơn.",
      "afterTax": "Sau VAT",
      "appliedCharges": "Phí đã áp dụng",
      "addCharge": "Thêm phí",
      "removeCharge": "Bỏ {{name}}",
      "removeChargeTitle": "Bỏ phí",
      "removeChargeBody": "{{name}} sẽ được bỏ khỏi đơn.",
      "discountSubtitle": "Áp dụng giảm giá cho đơn này",
      "lineDiscountSubtitle": "Áp dụng giảm giá cho món này",
      "discountAmount": "Số tiền giảm",
      "presetsTitle": "Mẫu giảm giá",
      "presetsHint": "Chạm để áp dụng mẫu giảm giá",
      "manualTitle": "Hoặc nhập giảm giá",
      "manualHint": "Chọn phần trăm hoặc số tiền, rồi nhập giá trị",
      "presetCustom": "Tuỳ chỉnh",
      "chargeSubtitle": "Thêm phụ phí vào đơn này",
      "chargeAmount": "Số tiền phụ phí",
      "chargeTypesTitle": "Phụ phí",
      "chargeTypesHint": "Chạm để thêm phụ phí",
      "chargeEntryNone": "Phụ phí cần nhập số tiền sẽ mở bàn phím ở đây."
    },
    "guests": {
      "label": "Số khách",
      "invalid": "Nhập số khách từ 1 đến {{max}}.",
      "title": "Số khách",
      "start": "Mở bàn"
    },
    "tables": {
      "table": "Bàn {{code}}",
      "status": {
        "available": "Trống",
        "seated": "Đã ngồi",
        "ordered": "Đã gọi món",
        "bill_printed": "Đã in hóa đơn",
        "cleaning": "Đang dọn",
        "reserved": "Đã đặt trước",
        "blocked": "Tạm khóa"
      },
      "guests_one": "{{count}} khách",
      "guests_other": "{{count}} khách",
      "minutes_one": "{{count}} phút",
      "minutes_other": "{{count}} phút",
      "hoursMinutes": "{{hours}} giờ {{minutes}}",
      "search": "Tìm bàn",
      "floorPlans": "Sơ đồ",
      "guestsFor": "Bàn {{code}} có bao nhiêu khách?",
      "noPlans": "Khu vực này chưa có sơ đồ bàn. Trụ sở thiết lập trong mục Bàn.",
      "noMatch": "Không có bàn phù hợp. Chọn Tất cả để xem mọi bàn.",
      "loadFailed": "Không tải được sơ đồ bàn. Sẽ thử lại sau vài giây.",
      "moves": {
        "split": "Thêm nhóm khách",
        "splitGuests": "Nhóm khách khác ở bàn {{code}}: số khách",
        "pickTransfer": "Chọn bàn trống để chuyển bàn {{code}} sang.",
        "pickMerge": "Chọn bàn để gộp với bàn {{code}}.",
        "notFree": "Không trống",
        "thisParty": "Nhóm khách này",
        "confirmTitle": "Gộp bàn {{from}} vào bàn {{into}}?",
        "confirmBody": "Các món của bàn {{from}} được chuyển vào hóa đơn của bàn {{into}} và số khách được cộng thêm. Hai bàn sẽ dùng chung một đơn.",
        "transferred": "Đã chuyển bàn {{from}} sang {{to}}.",
        "merged": "Đã gộp bàn: {{tables}}.",
        "chargesDropped": "Phụ phí không được chuyển: {{names}}.",
        "choose": {
          "transfer": "Chọn bàn cần chuyển.",
          "merge": "Chọn bàn để gộp bàn khác vào.",
          "split": "Chọn bàn để thêm nhóm khách.",
          "unmerge": "Chọn bàn cần tách khỏi nhóm bàn đã gộp."
        },
        "notInUse": "Bàn trống",
        "splitTitle": "Thêm nhóm khách vào bàn {{code}}?",
        "splitBody": "Nhóm khách mới có đơn riêng; bàn khi đó hiện một ô cho mỗi nhóm.",
        "label": "Thao tác bàn",
        "unmerge": "Tách bàn đã gộp",
        "notMerged": "Chưa gộp",
        "unmergeTitle": "Tách bàn {{code}} khỏi {{tables}}?",
        "unmergeBody": "Bàn {{code}} sẽ trống trở lại. Nhóm khách vẫn ngồi ở {{rest}} cùng đơn và số khách; để một phần nhóm có hóa đơn riêng, hãy dùng Tách hóa đơn.",
        "unmerged": "Bàn {{code}} đã trống. Nhóm khách ngồi ở {{tables}}."
      },
      "toolbar": "Bàn"
    },
    "header": {
      "label": "POS",
      "terminal": "POS {{code}} · {{name}}",
      "notifications": "Thông báo",
      "noNotifications": "Không có gì cần chú ý.",
      "profile": "Tài khoản của bạn",
      "lock": "Khóa màn hình"
    },
    "bill": {
      "title": "Xem trước hoá đơn",
      "notice": "Chỉ xem trước, chưa in.",
      "order": "Đơn {{number}}",
      "table": "Bàn {{code}}",
      "opened": "Mở lúc {{time}}",
      "empty": "Đơn này chưa có món nào.",
      "back": "Về thực đơn",
      "sentTo": "Đã gửi hoá đơn tới {{printer}}",
      "reprinted": "Đã in lại hoá đơn (lần {{number}}) trên {{printer}}",
      "noPrinter": "Máy này chưa có máy in hoá đơn. Hoá đơn đã được đánh dấu là đã in nhưng chưa in ra giấy.",
      "notPrinted": "Không gửi được hoá đơn tới máy in. Hãy kiểm tra hàng đợi in."
    },
    "flow": {
      "waiting": "{{action}} thực hiện sau bước: {{step}}.",
      "action": {
        "take_payment": "Thanh toán",
        "send_to_kitchen": "Gửi bếp",
        "take_order": "Nhận món",
        "accept_order": "Nhận đơn",
        "mark_ready": "Báo món xong",
        "out_for_delivery": "Giao cho tài xế",
        "hand_over": "Giao cho khách",
        "deliver": "Báo đã giao"
      },
      "step": {
        "take_order": "nhận món",
        "send_to_kitchen": "gửi bếp",
        "take_payment": "thanh toán",
        "select_customer": "Khách hàng",
        "print_bill": "in tạm tính",
        "assign_driver": "giao tài xế",
        "accept_order": "nhận đơn trực tuyến",
        "mark_ready": "báo món xong",
        "out_for_delivery": "giao cho tài xế",
        "hand_over": "giao cho khách",
        "deliver": "báo đã giao"
      },
      "printBill": "In tạm tính",
      "billPrinted": "Đã in tạm tính",
      "assignDriver": "Giao tài xế",
      "run": {
        "mark_ready": "Món xong",
        "out_for_delivery": "Giao tài xế",
        "hand_over": "Đã giao khách",
        "served": "Đã phục vụ",
        "deliver": "Đã giao xong"
      },
      "done": {
        "mark_ready": "Đã báo món xong. Khách được thông báo.",
        "out_for_delivery": "Tài xế đã nhận đơn. Khách được thông báo.",
        "hand_over": "Đã giao cho khách. Đơn hoàn tất.",
        "deliver": "Đã giao xong. Đơn hoàn tất."
      }
    },
    "form": {
      "required": "{{label}} (bắt buộc)",
      "optional": "{{label}} (tùy chọn)",
      "requiredToSave": "Cần nhập trước khi lưu."
    },
    "customer": {
      "title": "Khách hàng",
      "required": "Đơn này cần thông tin khách trước khi thêm món.",
      "optional": "Không bắt buộc. Tên hoặc số điện thoại giúp tìm đơn dễ hơn.",
      "skip": "Bỏ qua",
      "name": "Tên",
      "phone": "Số điện thoại",
      "street": "Địa chỉ",
      "ward": "Phường / xã",
      "province": "Quận / thành phố",
      "note": "Ghi chú",
      "known": "Khách quen: {{name}}",
      "new": "Khách mới. Thông tin được lưu cho lần sau.",
      "blocked": "Khách hàng này đã bị chặn.",
      "addresses": "Địa chỉ đã lưu",
      "search": "Tìm",
      "matches": "Khách phù hợp",
      "email": "Email",
      "emailInvalid": "Nhập email dạng ten@vidu.com.",
      "phoneOrEmail": "Cần số điện thoại hoặc email."
    },
    "driver": {
      "title": "Giao tài xế",
      "hint": "Nhập tài xế của cửa hàng, hoặc chọn đơn vị vận chuyển.",
      "name": "Tên tài xế",
      "phone": "Số điện thoại tài xế",
      "own": "Tài xế cửa hàng",
      "providers": "Đơn vị vận chuyển",
      "saved": "Tài xế của cửa hàng",
      "add": "Tài xế mới",
      "edit": "Sửa",
      "remove": "Xóa khỏi danh sách",
      "vehicle": "Xe hoặc biển số",
      "saveDriver": "Lưu tài xế",
      "section": "Tài xế",
      "addDriver": "Thêm tài xế",
      "actions": "Thao tác với {{name}}",
      "removeTitle": "Bỏ tài xế",
      "recentFees": "Phí giao gần đây",
      "removeBody": "{{name}} sẽ được bỏ khỏi danh sách tài xế. Các đơn giao trước đó vẫn giữ tài xế.",
      "loadFailed": "Không tải được danh sách tài xế hoặc phí giao gần đây."
    },
    "invoice": {
      "title": "Hóa đơn VAT",
      "hint": "Thông tin công ty để xuất hóa đơn điện tử VAT. Để trống nếu xuất hóa đơn bán lẻ.",
      "taxCode": "Mã số thuế",
      "taxCodeInvalid": "Nhập 10 chữ số, hoặc 13 số cho chi nhánh.",
      "companyName": "Tên công ty",
      "address": "Địa chỉ công ty",
      "email": "Email nhận hóa đơn",
      "emailInvalid": "Nhập địa chỉ email hợp lệ.",
      "clear": "Xóa",
      "tag": "Hóa đơn VAT"
    },
    "delivery": {
      "title": "Giao hàng",
      "chooseHint": "Chọn cách giao đơn này.",
      "ownDrivers": "Tài xế của quán",
      "ownHint": "Chọn tài xế giao đơn này và nhập phí giao hàng.",
      "assign": "Giao tài xế",
      "offlineHint": "Không có kết nối với văn phòng chính: vẫn chọn được nhà cung cấp và nhập phí, mã đơn giao bằng tay.",
      "quoting": "Đang hỏi phí từ nhà cung cấp…",
      "quote": "Phí {{fee}}",
      "eta": "khoảng {{minutes}} phút",
      "etaLabel": "Thời gian dự kiến",
      "fixedFee": "Phí {{fee}}",
      "fee": "Phí giao hàng",
      "number": "Mã đơn giao hàng",
      "numberHint": "Mã mà nhà cung cấp đã đưa cho bạn.",
      "handHint": "Đặt ngoài hệ thống: nhập phí và, nếu có, mã đơn giao hàng.",
      "hoDown": "Không có kết nối với văn phòng chính. Hãy nhập phí bằng tay hoặc thử lại sau.",
      "requestDriver": "Gọi tài xế",
      "byHand": "Nhập tay",
      "askHo": "Hỏi nhà cung cấp",
      "entered": "Nhập tay",
      "refresh": "Làm mới",
      "cancel": "Huỷ giao hàng",
      "change": "Đổi dịch vụ",
      "track": "Theo dõi đơn giao",
      "history": "Lịch sử",
      "noDriverHint": "Chưa tìm được tài xế. Hãy huỷ hoặc chọn dịch vụ khác.",
      "cancelPending": "Đang huỷ… chờ nhà cung cấp xác nhận.",
      "status": {
        "pending": "Mới",
        "searching_driver": "Đang tìm tài xế",
        "no_driver": "Không có tài xế",
        "assigned": "Đã có tài xế",
        "picked_up": "Đã lấy hàng",
        "out_for_delivery": "Đang giao",
        "delivered": "Đã giao",
        "failed": "Thất bại",
        "cancel_requested": "Đang huỷ",
        "cancelled": "Đã huỷ",
        "returned": "Đã trả lại"
      },
      "orderStatus": "Trạng thái",
      "providerStatus": "Trạng thái từ nhà cung cấp",
      "driverTitle": "Tài xế",
      "deliveryTitle": "Giao hàng",
      "driverPending": "Chưa có tài xế",
      "driverVehicle": "Phương tiện",
      "trackingUrl": "Liên kết theo dõi",
      "copyLink": "Mở",
      "ownFeeHint": "Tính cho khách và cộng vào hóa đơn.",
      "ownTitle": "Giao bằng tài xế của cửa hàng"
    },
    "shift": {
      "title": "Ca làm việc",
      "none": "Chưa mở ca.",
      "noneRequired": "Chưa mở ca. Hãy mở ca trước khi nhận thanh toán.",
      "unscheduled": "Ca ngoài lịch",
      "window": "{{from}} – {{to}}",
      "openedBy": "Mở lúc {{time}} bởi {{name}}",
      "openedAt": "Mở lúc {{time}}",
      "due": "Đến giờ: {{name}} ({{window}})",
      "next": "Ca tiếp theo: {{name}} lúc {{time}}",
      "overdue": "{{name}} lẽ ra kết thúc lúc {{time}}. Hãy đếm tiền và đóng ca.",
      "open": "Mở ca",
      "openTitle": "Mở {{name}}",
      "float": "Tiền đầu ca",
      "floatTerminal": "Tiền đầu ca, máy {{code}}",
      "cashMove": "Thu chi tiền mặt",
      "paidIn": "Thu tiền",
      "paidOut": "Chi tiền",
      "cashDrop": "Nộp két",
      "movementType": "Loại",
      "amount": "Số tiền",
      "reason": "Lý do",
      "reasonNone": "Khác (ghi rõ)",
      "note": "Lý do",
      "record": "Ghi nhận",
      "close": "Đóng ca",
      "closeTitle": "Đếm tiền và đóng {{name}}",
      "closeTitleNoCount": "Đóng {{name}}",
      "counted": "Tiền mặt đếm được",
      "countedTerminal": "Tiền mặt đếm được, máy {{code}}",
      "store": "Cửa hàng",
      "expected": "Phải có",
      "variance": "Thừa hoặc thiếu",
      "over": "Thừa {{amount}}",
      "short": "Thiếu {{amount}}",
      "even": "Khớp",
      "tolerance": "Thừa hoặc thiếu quá {{amount}} cần quản lý duyệt.",
      "closeNote": "Ghi chú",
      "noCount": "Cửa hàng không kiểm đếm tiền khi đóng ca.",
      "empty": "Ca này chưa có đơn hay thanh toán nào.",
      "forceClose": "Đóng ca không kiểm đếm",
      "forceReason": "Vì sao đóng ca không kiểm đếm?",
      "printReport": "In báo cáo ca",
      "printed": "Đã gửi báo cáo ca đến {{printer}}.",
      "notPrinted": "Máy này và cửa hàng chưa có máy in hóa đơn.",
      "closed": "Đã đóng ca. Phải có {{expected}}, đếm được {{counted}}.",
      "closedNoCount": "Đã đóng ca.",
      "approve": "Duyệt kết quả đếm tiền của {{name}}: {{variance}}",
      "cancel": "Hủy",
      "takings": "Doanh thu theo phương thức",
      "movements": "Thu chi tiền mặt",
      "reportTitle": "Báo cáo ca: {{name}}",
      "closedAt": "Đóng lúc {{time}}",
      "done": "Xong",
      "orders": "Đơn hàng theo trạng thái",
      "status": "Trạng thái",
      "count": "Số đơn",
      "total": "Tổng",
      "allOrders": "Tất cả đơn",
      "noOrders": "Ca này chưa có đơn hàng.",
      "noTakings": "Ca này chưa nhận thanh toán.",
      "method": "Phương thức thanh toán",
      "payments": "Lượt thanh toán",
      "refunded": "Đã hoàn",
      "net": "Số tiền",
      "openOrders_one": "Còn {{count}} đơn đang mở. Hãy thanh toán hoặc hủy, nếu không đơn sẽ chuyển sang ca sau.",
      "openOrders_other": "Còn {{count}} đơn đang mở. Hãy thanh toán hoặc hủy, nếu không các đơn sẽ chuyển sang ca sau.",
      "figures": "Số khách {{guests}} · trung bình/đơn {{average}} · hủy món, hủy đơn {{voids}} ({{voidAmount}})",
      "otherMethods": "Phương thức khác",
      "otherMethodsHint": "Không bắt buộc: nhập số tiền mà bản kết toán của máy thẻ hoặc đơn vị thanh toán ghi nhận cho ca này. Chênh lệch được ghi vào báo cáo.",
      "methodShows": "{{method}}: ghi nhận",
      "methodTook": "POS đã thu",
      "methodCounted": "Đối chiếu",
      "noSale": "Mở két",
      "noSaleHint": "Mở ngăn kéo tiền khi không bán hàng. Lần mở được ghi lại kèm tên bạn, thời gian và lý do, và được đếm trong báo cáo ca.",
      "noSaleOpen": "Mở két",
      "noSaleApprove": "Mở két không bán hàng",
      "noSaleOpened": "Đã mở két. Lần mở không bán đã được ghi lại.",
      "noSaleNoPrinter": "Lần mở không bán đã được ghi lại, nhưng chưa cài máy in hóa đơn để mở két.",
      "noSales": "Mở két không bán: {{count}}",
      "noneAuto": "Chưa có ca nào mở. Ca sẽ mở cùng khoản thanh toán tiếp theo.",
      "handsOver": "{{name}} nhận ca lúc {{time}}.",
      "endedTitle": "Ca đã kết thúc cần đóng",
      "endedAt": "Kết thúc lúc {{time}}",
      "countAndClose": "Đếm tiền và đóng ca",
      "countLater": "Ca sau đã dùng két này. Hãy đếm toàn bộ tiền trong két bây giờ; hệ thống sẽ tính chênh lệch của ca này.",
      "blindCount": "Đếm tiền mà không xem số liệu; chênh lệch sẽ hiện sau khi đóng ca.",
      "approveBlind": "Chấp nhận số tiền đếm của {{name}}",
      "endedNotice_one": "Còn {{count}} ca đã kết thúc chờ đếm tiền.",
      "endedNotice_other": "Còn {{count}} ca đã kết thúc chờ đếm tiền."
    },
    "split": {
      "title": "Tách hóa đơn {{number}}",
      "hint": "Đánh dấu món, rồi chuyển sang hóa đơn mới cả món hoặc từng phần, hoặc chia đều. Mỗi hóa đơn thanh toán riêng.",
      "thisBill": "Hóa đơn này",
      "bill": "Hóa đơn {{number}}",
      "bills": "Hóa đơn mới",
      "addBill": "Thêm hóa đơn",
      "tools": "Thao tác tách hóa đơn",
      "markAll": "Chọn tất cả",
      "move": "Chuyển sang {{bill}}",
      "moveOne": "Chuyển 1 sang {{bill}}",
      "moveBack": "Chuyển lại",
      "evenly": "Chia đều ({{count}} hóa đơn)",
      "allEvenly": "Chia đều cả hóa đơn",
      "byAmount": "Theo số tiền",
      "reset": "Làm lại",
      "save_other": "Tạo {{count}} hóa đơn mới",
      "empty": "Không có món",
      "guestsTitle": "Chia đều cả hóa đơn",
      "guestsHint": "Bao nhiêu khách? Mỗi khách nhận phần bằng nhau của từng món; phần lẻ để lại hóa đơn này.",
      "amountTitle": "Tách theo số tiền",
      "amountHint_other": "Số tiền của hóa đơn mới, nhỏ hơn {{total}}. Hóa đơn mới lấy cùng một tỷ lệ của từng món đã đánh dấu, hoặc của mọi món nếu chưa đánh dấu món nào.",
      "apply": "Áp dụng",
      "billsTitle": "Các hóa đơn của bàn",
      "billsHint": "Mở một hóa đơn để thanh toán.",
      "billNumber": "Hóa đơn {{number}}",
      "payNext": "Thanh toán hóa đơn {{number}}",
      "tableBills": "Các hóa đơn của bàn {{code}}"
    },
    "points": {
      "title": "Đổi điểm",
      "hint": "Điểm của {{name}} được trừ vào đơn như một khoản giảm giá. Trụ sở giữ điểm đến khi đơn được thanh toán.",
      "label": "Số điểm muốn đổi",
      "apply": "Đổi điểm",
      "appliedTitle": "Điểm đã dùng cho đơn",
      "remove": "Bỏ {{name}}",
      "removeTitle": "Bỏ điểm khỏi đơn",
      "removeBody": "{{name}} được bỏ khỏi đơn và điểm trả lại cho hội viên.",
      "applied": "{{name}}: giảm {{amount}} cho đơn.",
      "removed": "Đã bỏ điểm khỏi đơn và trả lại cho hội viên.",
      "needMember": "Hãy tìm hội viên trước: điểm là của hội viên."
    },
    "coupon": {
      "title": "Nhập mã giảm giá",
      "hint": "Nhập hoặc quét mã giảm giá. Trụ sở kiểm tra và giữ mã cho đơn này.",
      "lineHint": "Mã dành cho một món sẽ áp dụng cho {{name}}.",
      "label": "Mã",
      "apply": "Áp dụng mã",
      "applied": "Đã áp dụng mã.",
      "appliedTitle": "Mã trên đơn này",
      "remove": "Bỏ {{name}}",
      "removeTitle": "Bỏ mã",
      "removeBody": "Bỏ {{name}} khỏi đơn? Mã có thể được dùng lại.",
      "removed": "Đã bỏ mã."
    },
    "member": {
      "title": "Hội viên",
      "hint": "Tìm hội viên theo số điện thoại hoặc số thẻ. Trụ sở lưu hội viên và điểm của họ.",
      "enrolHint": "Đăng ký khách làm hội viên tại trụ sở. Hỏi khách trước khi đánh dấu đồng ý nhận tiếp thị.",
      "query": "Số điện thoại hoặc số thẻ",
      "queryHelp": "Nhập hoặc quét thẻ.",
      "search": "Tìm",
      "matches": "Hội viên tìm thấy",
      "use": "Chọn hội viên",
      "enrol": "Đăng ký hội viên mới",
      "enrolSave": "Đăng ký",
      "backToSearch": "Quay lại tìm",
      "name": "Họ tên",
      "phone": "Số điện thoại",
      "email": "Email (không bắt buộc)",
      "cardNo": "Số thẻ (không bắt buộc)",
      "cardNoHelp": "Dùng cho thẻ in sẵn. Để trống, trụ sở sẽ cấp số thẻ.",
      "consent": "Khách đồng ý nhận ưu đãi và tin tức",
      "remove": "Bỏ hội viên",
      "change": "Đổi hội viên",
      "points": "{{points}} điểm có thể dùng",
      "tag": "Hội viên: {{name}}",
      "attached": "Đã gắn {{name}} vào đơn.",
      "removed": "Đã bỏ hội viên khỏi đơn."
    },
    "pdf": {
      "ready": {
        "bill": "Phiếu tạm tính {{number}} đã có bản PDF",
        "kitchen_ticket": "Phiếu bếp {{number}} đã có bản PDF",
        "shift_report": "Báo cáo ca đã có bản PDF",
        "day_report": "Báo cáo ngày đã có bản PDF",
        "test_page": "Trang in thử đã có bản PDF",
        "other": "Có một tài liệu dạng PDF",
        "receipt": "Hóa đơn thanh toán {{number}} đã có bản PDF"
      },
      "save": "Lưu PDF",
      "failed": "Không lưu được PDF. Hãy thử lại."
    },
    "online": {
      "title": "Yêu cầu từ bàn",
      "listLabel": "Yêu cầu gọi món qua QR đang chờ",
      "empty": "Chưa có yêu cầu hay lượt gọi nào từ bàn. Khi có sẽ hiện ở đây kèm chuông báo.",
      "loadFailed": "Không tải được các yêu cầu. Sẽ thử lại sau vài giây.",
      "notAllowed": "Yêu cầu từ bàn cần quyền quản lý đơn trực tuyến. Hãy hỏi quản lý.",
      "unknownTable": "?",
      "unknownItem": "Món không có trong thực đơn của cửa hàng",
      "unknownOption": "Tùy chọn không có trong thực đơn của cửa hàng",
      "waiting": "Đã chờ {{time}}",
      "justNow": "chưa đến 1 phút",
      "hours": "{{hours}} giờ {{minutes}}",
      "guestNote": "Ghi chú của khách: {{note}}",
      "confirming": "Đang xác nhận",
      "confirmed": "Đã thêm vào đơn của bàn {{table}}. Mở đơn để gửi xuống bếp.",
      "reject": "Từ chối",
      "rejected": "Đã từ chối yêu cầu từ bàn {{table}}. Khách sẽ thấy lý do.",
      "rejectTitle": "Từ chối yêu cầu từ bàn {{table}}?",
      "reason": "Lý do (khách sẽ thấy)",
      "reasons": {
        "sold_out": "Hết món",
        "kitchen_busy": "Bếp đang quá tải",
        "wrong_table": "Sai bàn",
        "duplicate": "Gửi trùng",
        "store_closed": "Cửa hàng sắp đóng cửa",
        "other": "Lý do khác"
      },
      "note": "Ghi chú cho khách (không bắt buộc)",
      "noteHelper": "Ví dụ: món có thể gọi thay thế.",
      "tableBadge_other": "{{count}} yêu cầu QR đang chờ",
      "waitingNotice_other": "{{count}} yêu cầu từ bàn đang chờ.",
      "channels": {
        "label": "Kênh bán online",
        "why": "Vì sao tạm dừng nhận đơn online?",
        "pauseAll": "Tạm dừng nhận đơn online",
        "pause": "Tạm dừng",
        "resume": "Nhận đơn online trở lại",
        "unknown": "Kênh online: không kết nối được văn phòng chính",
        "hoUnavailable": "Không kết nối được văn phòng chính nên chưa thể tạm dừng hay mở lại đơn online. Các yêu cầu đã tới vẫn xác nhận được.",
        "reasons": {
          "staff_paused": "Nhân viên tạm dừng",
          "capacity": "Đang quá tải"
        },
        "status": {
          "open": "{{channel}}: đang nhận đơn",
          "closed": "{{channel}}: đã đóng",
          "staff_paused": "{{channel}}: nhân viên tạm dừng",
          "capacity": "{{channel}}: tạm dừng, quá tải",
          "store_offline": "{{channel}}: tạm dừng, cửa hàng mất kết nối",
          "outside_hours": "{{channel}}: tạm dừng, ngoài giờ mở cửa",
          "max_orders": "{{channel}}: quá nhiều đơn đang mở"
        },
        "someStopped": "Một số kênh online đang tạm dừng",
        "allStopped": "Không nhận đơn online",
        "busy": "Đang đông",
        "busyHint": "Đơn online sẽ lâu hơn trong một lúc: khách thấy thời gian dài hơn và khung giờ muộn hơn.",
        "busyMinutes": "Lâu hơn bao nhiêu",
        "busyFor": "Trong bao lâu",
        "plusMinutes_one": "+{{count}} phút",
        "plusMinutes_other": "+{{count}} phút",
        "forHours_one": "{{count}} giờ",
        "forHours_other": "{{count}} giờ",
        "busyStart": "Bật chế độ đông",
        "busyEnd": "Trở lại bình thường",
        "busyUntil": "Đang đông: đơn lâu hơn {{minutes}} phút đến {{time}}."
      },
      "web": {
        "title": "Đơn online",
        "listLabel": "Đơn website và ứng dụng đang chờ trả lời",
        "empty": "Không có đơn website hay ứng dụng nào đang chờ. Đơn mới hiện ở đây kèm chuông báo.",
        "loadFailed": "Không tải được đơn online. Sẽ thử lại sau vài giây.",
        "heading": "{{number}} · {{fulfilment}}",
        "fulfilment": {
          "delivery": "Giao hàng",
          "pickup": "Tự đến lấy",
          "dine_in": "Ăn tại nhà hàng"
        },
        "payment": {
          "cod": "thu tiền khi giao",
          "pay_at_pickup": "trả tại quầy",
          "online": "thanh toán trực tuyến"
        },
        "total": "{{total}}, {{payment}}",
        "note": "Ghi chú của khách: {{note}}",
        "answerWithin": "Trả lời trong {{time}}",
        "answerBy": "Trả lời trước {{time}}",
        "timeUp": "Đã hết giờ",
        "accept": "Nhận đơn",
        "acceptWith_one": "Nhận đơn, xong trong {{count}} phút",
        "acceptWith_other": "Nhận đơn, xong trong {{count}} phút",
        "acceptTitle": "Nhận đơn {{number}}?",
        "prep": "Thời gian chuẩn bị (khách được báo)",
        "accepted": "Đã nhận đơn {{number}}. Hãy gửi xuống bếp khi sẵn sàng. Khách được báo xong trong {{minutes}} phút.",
        "reject": "Từ chối",
        "rejectTitle": "Từ chối đơn {{number}}?",
        "reason": "Lý do (khách sẽ thấy)",
        "reasons": {
          "sold_out": "Hết món",
          "too_busy": "Đang quá đông",
          "closing": "Sắp đóng cửa",
          "out_of_area": "Không giao tới đó",
          "other": "Khác"
        },
        "rejectNote": "Ghi chú cho khách (không bắt buộc)",
        "rejected": "Đã từ chối đơn {{number}}. Khách sẽ thấy lý do.",
        "answered": "Xong hôm nay",
        "status": {
          "accepted": "Đã nhận",
          "acceptedFor_one": "Đã nhận, {{count}} phút",
          "acceptedFor_other": "Đã nhận, {{count}} phút",
          "rejected": "Đã từ chối",
          "cancelled": "Không trả lời kịp",
          "ready": "Đã xong",
          "completed": "Đã giao",
          "outForDelivery": "Đang giao"
        },
        "waitingNotice_one": "{{count}} đơn online đang chờ trả lời.",
        "waitingNotice_other": "{{count}} đơn online đang chờ trả lời.",
        "customerLanguage": "Ngôn ngữ của khách: {{language}}",
        "inProgress": "Đang làm",
        "ready": "Đã xong",
        "handedOver": "Đã giao",
        "readyDone": "Đơn {{number}} đã xong. Khách được báo.",
        "handedOverDone": "Đã giao đơn {{number}}.",
        "handedToDriver": "Đã giao tài xế",
        "handedToDriverDone": "Đơn {{number}} đang được giao. Khách được báo.",
        "delivered": "Đã giao tới khách",
        "deliveredDone": "Đơn {{number}} đã giao tới khách.",
        "takePayment": "Thu tiền",
        "notPaid": "Chưa thanh toán",
        "served": "Đã phục vụ",
        "servedDone": "Đơn {{number}} đã được phục vụ.",
        "paid": "Đã thanh toán",
        "customerCancelled": "Khách đã huỷ đơn này trước khi được nhận. Số tiền thanh toán trực tuyến được hoàn lại toàn bộ.",
        "refundAtCounter": "Đơn đã thanh toán tại quầy: hãy hoàn tiền cho khách tại quầy.",
        "dueNotice_one": "Có {{count}} đơn hẹn giờ đã đến lúc làm: hãy gửi bếp.",
        "dueNotice_other": "Có {{count}} đơn hẹn giờ đã đến lúc làm: hãy gửi bếp."
      },
      "list": {
        "online": "Trực tuyến · {{channel}}",
        "waiting": "Nhận đơn trong {{time}}",
        "timeUp": "Đã hết giờ nhận đơn",
        "status": {
          "pending": "Chờ nhận đơn",
          "accepted": "Đã nhận",
          "ready": "Món xong",
          "out_for_delivery": "Đang giao",
          "completed": "Hoàn tất",
          "rejected": "Đã từ chối",
          "cancelled": "Không được trả lời",
          "customerCancelled": "Khách đã huỷ"
        },
        "columns": {
          "type": "Hình thức",
          "payment": "Thanh toán",
          "prep": "Thời gian chuẩn bị"
        },
        "upcoming": "Đặt trước",
        "scheduledOn": "Hẹn {{time}}",
        "scheduledFor": "Hẹn {{time}}",
        "startBy": "Hẹn {{time}} · làm lúc {{start}}"
      },
      "calls": {
        "kinds": {
          "staff": "Gọi nhân viên",
          "bill": "Gọi thanh toán"
        },
        "tableBadge_one": "{{count}} lượt gọi từ bàn",
        "tableBadge_other": "{{count}} lượt gọi từ bàn",
        "waitingNotice_one": "{{count}} khách đang gọi từ bàn.",
        "waitingNotice_other": "{{count}} khách đang gọi từ bàn.",
        "doneShort": "Xong"
      },
      "openOrder": "Mở đơn",
      "confirmShort": "Xác nhận",
      "request": "Yêu cầu {{number}} · {{time}}",
      "qrRequests_one": "{{count}} yêu cầu",
      "qrRequests_other": "{{count}} yêu cầu",
      "qrCalls_one": "{{count}} lượt gọi",
      "qrCalls_other": "{{count}} lượt gọi"
    },
    "receipt": {
      "print": "In hóa đơn thanh toán",
      "reprint": "In lại hóa đơn thanh toán",
      "sentTo": "Đã gửi hóa đơn thanh toán tới {{printer}}",
      "reprinted": "Đã in lại hóa đơn thanh toán (lần {{number}}) trên {{printer}}",
      "noPrinter": "Máy này chưa có máy in hoá đơn. Chưa in ra giấy.",
      "notPrinted": "Không gửi được hóa đơn thanh toán tới máy in. Hãy kiểm tra hàng đợi in."
    },
    "variants": {
      "choose": "Chọn · {{price}}",
      "chooseNoPrice": "Chọn",
      "notWithAbove": "Không có với lựa chọn trên",
      "unavailable": "Hết món hoặc chưa bán"
    },
    "reservations": {
      "title": "Đặt bàn",
      "intro": "Lượt đặt bàn trong ngày: lượt đặt trực tuyến cần xác nhận, lượt đặt qua điện thoại hoặc tại quầy, và khách cần xếp bàn.",
      "previousDay": "Ngày trước",
      "nextDay": "Ngày sau",
      "today": "Hôm nay",
      "day": "Ngày",
      "off": "Cửa hàng chưa nhận đặt bàn. Văn phòng chính bật tính năng này.",
      "newBooking": "Đặt bàn mới",
      "toConfirm": "Cần xác nhận",
      "bookings": "Lượt đặt bàn",
      "none": "Không có lượt đặt bàn trong ngày.",
      "noneHint": "Nhận đặt bàn qua điện thoại hoặc tại quầy bằng Đặt bàn mới; lượt đặt trực tuyến sẽ hiện ở đây để xác nhận.",
      "slots": "Khung giờ",
      "slotLoad_one": "{{time}} · {{count}} lượt · {{guests}} khách",
      "slotLoad_other": "{{time}} · {{count}} lượt · {{guests}} khách",
      "full": "Kín chỗ",
      "when_one": "{{time}} · {{count}} khách",
      "when_other": "{{time}} · {{count}} khách",
      "status": {
        "pending": "Cần xác nhận",
        "confirmed": "Đã xác nhận",
        "declined": "Đã từ chối",
        "expired": "Không được trả lời",
        "cancelled": "Đã huỷ",
        "no_show": "Không đến",
        "seated": "Đã xếp bàn"
      },
      "source": {
        "website": "Website",
        "app": "Ứng dụng",
        "pos": "Tại cửa hàng"
      },
      "answerBy": "Trả lời trước {{time}}",
      "dishes": "Món đặt trước: {{items}}",
      "confirm": "Xác nhận",
      "decline": "Từ chối",
      "edit": "Thay đổi",
      "seat": "Xếp bàn",
      "noShow": "Khách không đến",
      "guestCancelled": "Khách huỷ",
      "save": "Lưu lượt đặt",
      "newTitle": "Đặt bàn mới",
      "editTitle": "Thay đổi lượt đặt: {{name}}",
      "confirmTitle": "Xác nhận lượt đặt {{reference}}",
      "declineTitle": "Từ chối lượt đặt {{reference}}",
      "seatTitle_one": "Xếp bàn cho {{name}}, {{count}} khách",
      "seatTitle_other": "Xếp bàn cho {{name}}, {{count}} khách",
      "date": "Ngày",
      "time": "Giờ",
      "party": "Số khách",
      "name": "Tên",
      "phone": "Số điện thoại",
      "note": "Ghi chú",
      "reason": "Lý do",
      "reasons": {
        "full": "Đã kín chỗ",
        "closed": "Không mở cửa vào giờ đó",
        "other": "Lý do khác"
      },
      "table": "Bàn trống",
      "seats_one": "{{count}} chỗ",
      "seats_other": "{{count}} chỗ",
      "noFreeTable": "Hiện không có bàn trống.",
      "needsHo": "Xác nhận và từ chối lượt đặt trực tuyến cần kết nối văn phòng chính. Hãy thử lại khi có kết nối.",
      "dayBookings_one": "{{count}} lượt đặt",
      "dayBookings_other": "{{count}} lượt đặt",
      "dayGuests_one": "{{count}} khách",
      "dayGuests_other": "{{count}} khách",
      "finished": "Đã vào bàn và đã kết thúc",
      "noneLeft": "Không còn khách nào sắp đến trong ngày.",
      "view": "Chế độ xem",
      "viewDay": "Ngày",
      "viewMonth": "Tháng",
      "previousMonth": "Tháng trước",
      "nextMonth": "Tháng sau",
      "more_one": "+{{count}} lượt nữa",
      "more_other": "+{{count}} lượt nữa",
      "calendarTruncated": "Có quá nhiều lượt đặt để hiện hết ở đây. Mở một ngày để xem đầy đủ."
    },
    "attendance": {
      "title": "Chấm công",
      "punch": "Chấm công vào hoặc ra",
      "backToLogin": "Quay lại đăng nhập",
      "clockedIn": "{{name}} đã chấm công vào lúc {{time}}.",
      "clockedOut": "{{name}} đã chấm công ra lúc {{time}}.",
      "openOrders_one": "Còn {{count}} đơn của bạn đang mở: hãy bàn giao cho đồng nghiệp.",
      "openOrders_other": "Còn {{count}} đơn của bạn đang mở: hãy bàn giao cho đồng nghiệp.",
      "since": "Đã chấm công vào từ {{time}}.",
      "notIn": "Bạn chưa chấm công vào.",
      "day": "Hôm nay: {{orders}} đơn hoàn tất, {{sales}}.",
      "clockIn": "Chấm công vào",
      "clockOut": "Chấm công ra"
    },
    "customerDisplay": {
      "title": "Màn hình khách",
      "welcome": "Xin chào quý khách",
      "yourOrder": "Đơn của quý khách",
      "due": "Cần thanh toán",
      "scanToPay": "Quét mã để thanh toán bằng {{provider}}",
      "qrLabel": "Mã QR để thanh toán bằng {{provider}}",
      "thanks": "Cảm ơn quý khách!",
      "paid": "Đã thanh toán {{amount}}",
      "change": "Tiền thối lại"
    },
    "functions": {
      "dayOpen": "Đang mở",
      "dayNotOpen": "Chưa mở",
      "daysToClose_one": "{{count}} ngày chờ đóng",
      "daysToClose_other": "{{count}} ngày chờ đóng",
      "shiftOpen": "Đang mở",
      "shiftNone": "Chưa có ca",
      "shiftOverdue": "Quá giờ",
      "clockedIn": "Đã chấm công vào",
      "notClockedIn": "Chưa chấm công",
      "hoData": "Dữ liệu từ văn phòng trung tâm",
      "thisDevice": "Thiết bị này",
      "terminal": "Máy {{code}} · {{name}}",
      "store": "Máy chủ cửa hàng"
    }
  },
  "tableSetup": {
    "title": "Thiết lập bàn nhanh",
    "hint": "Chọn cửa hàng, số khu vực và số bàn. Hệ thống tự điền sẵn các bàn: đổi tên, số ghế, thêm hoặc bớt bàn, rồi lưu tất cả một lần. Mỗi khu vực có sơ đồ riêng.",
    "store": "Cửa hàng",
    "chooseStore": "Chọn cửa hàng",
    "existing": "Cửa hàng đã có {{areas}} khu vực và {{tables}} bàn. Mã mới sẽ bỏ qua các mã đang dùng.",
    "areas": "Số khu vực",
    "tablesPerArea": "Số bàn mỗi khu vực",
    "seats": "Số ghế mỗi bàn",
    "generate": "Tạo bàn",
    "generateAgain": "Tạo lại (thay bản nháp)",
    "summary": "Bản nháp: {{areas}} khu vực, {{tables}} bàn. Chưa lưu.",
    "areaName": "Khu vực {{n}}",
    "areaNameLabel": "Tên khu vực",
    "areaCode": "Mã khu vực",
    "tableCount": "Số bàn",
    "renumber": "Đánh số lại",
    "removeArea": "Xóa khu vực {{name}}",
    "tablesOf": "Các bàn trong {{name}}",
    "tableCode": "Bàn",
    "seatsShort": "Ghế",
    "shape": "Hình dạng",
    "shapes": {
      "square": "Vuông",
      "rect": "Chữ nhật",
      "round": "Tròn"
    },
    "removeTable": "Xóa bàn {{code}}",
    "addTable": "Thêm bàn",
    "addArea": "Thêm khu vực",
    "discard": "Bỏ bản nháp",
    "save": "Lưu {{areas}} khu vực và {{tables}} bàn",
    "fix_one": "Sửa {{count}} lỗi trước khi lưu.",
    "fix_other": "Sửa {{count}} lỗi trước khi lưu.",
    "saved": "Đã tạo {{areas}} khu vực và {{tables}} bàn cho {{store}}. Cửa hàng sẽ nhận trong lần đồng bộ tới.",
    "viewAreas": "Xem khu vực bàn",
    "problems": {
      "required": "Bắt buộc",
      "format": "Chỉ dùng chữ, số, . _ -",
      "duplicate": "Bị trùng",
      "taken": "Đã có ở cửa hàng này",
      "capacity": "Từ 1 đến 100"
    }
  },
  "posSync": {
    "emptyTitle": "Không có cửa hàng để hiển thị",
    "empty": "Cửa hàng xuất hiện ở đây khi đã được tạo tại trụ sở.",
    "title": "Đồng bộ tới cửa hàng",
    "tab": "Đồng bộ tới cửa hàng",
    "hint": "Thay đổi của hồ sơ này, các nút, loại bán hàng và bố cục chỉ tới cửa hàng khi bạn đồng bộ tới cửa hàng đó. Cửa hàng hiện Đã cập nhật khi đã áp dụng hồ sơ; Chờ cửa hàng nhận nghĩa là cửa hàng chưa tải về.",
    "changedAt": "Thay đổi gần nhất lúc {{time}}.",
    "columns": {
      "store": "Cửa hàng",
      "terminals": "Máy POS đang dùng",
      "status": "Trạng thái",
      "synced": "Đồng bộ gần nhất"
    },
    "status": {
      "current": "Đã cập nhật",
      "outdated": "Có thay đổi mới",
      "never": "Chưa đồng bộ",
      "pending": "Chờ cửa hàng nhận"
    },
    "usedBy": "Máy POS đang dùng",
    "usedYes": "Đang dùng",
    "usedNo": "Chưa dùng",
    "selected_one": "Đã chọn {{count}} cửa hàng",
    "selected_other": "Đã chọn {{count}} cửa hàng",
    "sync_one": "Đồng bộ tới {{count}} cửa hàng",
    "sync_other": "Đồng bộ tới {{count}} cửa hàng",
    "confirmTitle_one": "Đồng bộ {{profile}} tới {{count}} cửa hàng?",
    "confirmTitle_other": "Đồng bộ {{profile}} tới {{count}} cửa hàng?",
    "confirmBody": "Máy POS của các cửa hàng này sẽ dùng hồ sơ và bố cục như hiện tại từ lần đồng bộ tới, thường trong vòng một phút. Đơn đang mở không bị ảnh hưởng.",
    "confirm": "Đồng bộ ngay",
    "done_one": "Đã đồng bộ tới {{count}} cửa hàng. Cửa hàng sẽ áp dụng ở lần đồng bộ tới.",
    "done_other": "Đã đồng bộ tới {{count}} cửa hàng. Các cửa hàng sẽ áp dụng ở lần đồng bộ tới.",
    "syncGroup": "Đồng bộ theo nhóm cửa hàng",
    "groupEmpty": "Không có cửa hàng nào trong {{group}} nhận được hồ sơ này. Hãy thêm cửa hàng vào nhóm, hoặc kiểm tra thương hiệu của hồ sơ."
  },
  "posSettings": {
    "invalid": "Cấu hình này không phải JSON hợp lệ nên không hiển thị được dạng tùy chọn. Hãy nhờ bộ phận hỗ trợ sửa lại.",
    "switches": {
      "allowTableSplit": "Cho phép hai nhóm khách ngồi chung bàn",
      "invoiceQr": "Mã QR trên hóa đơn để lấy hóa đơn GTGT"
    },
    "help": {
      "invoiceQr": "Hóa đơn thanh toán của đơn chưa có thông tin xuất hóa đơn sẽ in kèm mã QR. Khách quét mã để nhập thông tin công ty trên website của thương hiệu và nhận hóa đơn GTGT. Cần có website của thương hiệu và cấu hình hóa đơn điện tử."
    },
    "receiptPrint": {
      "label": "In hóa đơn thanh toán",
      "auto": "Khi đơn được thanh toán",
      "ask": "Hỏi ở màn hình hoàn tất",
      "off": "Chỉ khi được yêu cầu (In lại hóa đơn thanh toán)"
    },
    "accent": {
      "label": "Màu nhấn của POS",
      "help": "Nút Gửi và mục đang chọn trên các máy dùng hồ sơ này. Để trống: màu chính của thương hiệu. Màu quá nhạt để chữ trắng đọc được sẽ được làm đậm.",
      "invalid": "Viết màu dạng #RRGGBB, ví dụ #1F7A4D.",
      "useBrand": "Dùng màu của thương hiệu",
      "pick": "Chọn màu nhấn của POS"
    }
  },
  "logs": {
    "headOffice": "Văn phòng chính",
    "payload": "Nội dung",
    "copy": "Sao chép",
    "copied": "Đã sao chép",
    "showMore": "Xem thêm",
    "showLess": "Thu gọn",
    "selected_one": "Đã chọn {{count}}",
    "selected_other": "Đã chọn {{count}}",
    "columns": {
      "time": "Thời gian",
      "store": "Cửa hàng",
      "staff": "Nhân viên",
      "action": "Hành động",
      "target": "Bản ghi",
      "terminal": "Máy POS",
      "approval": "Phê duyệt của quản lý",
      "received": "Nhận lúc",
      "processed": "Xử lý lúc",
      "nextAttempt": "Thử lại lúc",
      "messageType": "Thông điệp",
      "table": "Bảng",
      "record": "Bản ghi",
      "status": "Trạng thái",
      "attempts": "Số lần thử",
      "error": "Lỗi gần nhất",
      "message": "Mã thông điệp",
      "sequence": "#",
      "sentTo": "Gửi tới",
      "resolution": "Cách xử lý",
      "versions": "Phiên bản",
      "profile": "Hồ sơ POS",
      "by": "Người đồng bộ",
      "rows": "Số dòng"
    },
    "audit": {
      "title": "Nhật ký kiểm tra",
      "hint": "Ai đã làm gì, ở đâu và khi nào, tại mọi cửa hàng và văn phòng chính: đăng nhập, hủy món, hoàn tiền, giảm giá và phê duyệt của quản lý. Không thể sửa bản ghi.",
      "actions": {
        "identity_login": "Đăng nhập",
        "identity_login_failed": "Đăng nhập thất bại",
        "identity_logout": "Đăng xuất",
        "identity_approval_granted": "Quản lý đã phê duyệt",
        "identity_approval_refused": "Quản lý từ chối phê duyệt",
        "identity_approval_consumed": "Đã dùng phê duyệt",
        "identity_ho_login": "Đăng nhập văn phòng chính",
        "identity_ho_login_failed": "Đăng nhập văn phòng chính thất bại",
        "identity_ho_logout": "Đăng xuất văn phòng chính"
      }
    },
    "sync": {
      "title": "Nhật ký đồng bộ",
      "hint": "Những gì được trao đổi giữa văn phòng chính và các cửa hàng. Mở một dòng để xem nội dung.",
      "received": "Nhận từ cửa hàng",
      "sent": "Gửi tới cửa hàng",
      "conflicts": "Xung đột",
      "publications": "Đồng bộ hồ sơ POS",
      "statuses": {
        "received": "Đang chờ",
        "processing": "Đang xử lý",
        "processed": "Đã áp dụng",
        "failed": "Lỗi, đang thử lại",
        "dead": "Đã dừng"
      },
      "scopes": {
        "tenant": "Mọi cửa hàng",
        "brand": "Cửa hàng của thương hiệu",
        "store": "Một cửa hàng"
      },
      "resolutions": {
        "ignored_older": "Cũ hơn bản của văn phòng chính",
        "rejected_wrong_tenant": "Từ chối: khách hàng khác",
        "rejected_wrong_store": "Từ chối: dữ liệu của cửa hàng khác",
        "rejected_wrong_id": "Từ chối: sai mã",
        "rejected_not_store_data": "Từ chối: dữ liệu của văn phòng chính"
      },
      "versions": "Gửi v{{incoming}} · VPC v{{current}}",
      "retry_one": "Thử lại {{count}} thông điệp",
      "retry_other": "Thử lại {{count}} thông điệp",
      "retried_one": "Đã đưa lại {{count}} thông điệp vào hàng đợi.",
      "retried_other": "Đã đưa lại {{count}} thông điệp vào hàng đợi."
    },
    "integration": {
      "title": "Nhật ký tích hợp",
      "hint": "Mọi lệnh gọi tới đối tác giao hàng, thanh toán, tin nhắn hoặc hóa đơn điện tử: yêu cầu gì, kết quả ra sao và mất bao lâu. Tìm theo mã đơn của chúng ta hoặc mã của đối tác; mở một lệnh gọi để xem các lượt trao đổi và mọi việc khác đã xảy ra với cùng đơn giao, thanh toán, tin nhắn hoặc hóa đơn.",
      "any": "Tất cả",
      "ms": "{{ms}} ms",
      "trace": "Mã trace",
      "columns": {
        "at": "Thời gian",
        "capability": "Mảng",
        "provider": "Đối tác",
        "operation": "Lệnh gọi",
        "outcome": "Kết quả",
        "duration": "Thời gian xử lý"
      },
      "outcomes": {
        "ok": "Thành công",
        "unavailable": "Đối tác không phản hồi (sẽ thử lại)",
        "uncertain": "Không có trả lời (kiểm tra trước khi thử lại)",
        "refused": "Bị từ chối",
        "account_rejected": "Tài khoản bị từ chối",
        "rejected": "Webhook bị từ chối",
        "error": "Lỗi"
      },
      "capabilities": {
        "shipping": "Giao hàng",
        "payment": "Thanh toán",
        "messaging": "Tin nhắn khách hàng",
        "einvoice": "Hóa đơn điện tử"
      }
    }
  },
  "optionItem": {
    "button": "Món tùy chọn mới",
    "title": "Tạo món tùy chọn",
    "hint": "Tùy chọn là một món thuộc loại “Chỉ làm tùy chọn”. Đặt tên, rồi đặt giá trong bảng giá như mọi món hoặc cho món giá cơ bản; không có cả hai thì miễn phí.",
    "hintGroup": "Món được tạo và thêm vào nhóm tùy chọn này. Đặt giá trong bảng giá như mọi món hoặc cho món giá cơ bản; không có cả hai thì miễn phí.",
    "kind": "Loại tùy chọn",
    "kindText": "Chỉ là chữ, miễn phí (vd. “Ít hành”)",
    "kindItem": "Có giá, hoặc có thông tin riêng",
    "textHint": "Nhập nội dung tùy chọn. Tùy chọn miễn phí, dùng nhóm thuế và đơn vị tính mặc định; mã được tạo từ tên.",
    "textHintGroup": "Nhập nội dung tùy chọn. Tùy chọn miễn phí, được thêm vào nhóm tùy chọn này, dùng nhóm thuế và đơn vị tính mặc định; mã được tạo từ tên.",
    "name": "Nội dung",
    "namePlaceholder": "Ít hành",
    "nameEn": "Tiếng Anh (không bắt buộc)",
    "nameRequired": "Hãy nhập nội dung tùy chọn."
  },
  "catalog": {
    "item": {
      "basePrice": "Giá cơ bản",
      "basePriceHelp": "Giá của một đơn vị cơ bản. Dùng khi không bảng giá nào có giá cho món và đơn vị đó; các đơn vị khác tính theo quy cách.",
      "baseUnitHelp": "Đơn vị mà giá cơ bản áp dụng. Đây là đơn vị bán cơ bản của món và không đổi được khi đã có đơn vị khác hoặc giá dùng nó."
    },
    "unit": {
      "factorHelp": "Một đơn vị này bằng bao nhiêu đơn vị cơ bản, ví dụ 6 cho một khay 6 lon. Phải lớn hơn 0.",
      "defaultHelp": "Đơn vị mà nút menu hoặc lần quét bán khi không chỉ rõ. Chỉ một đơn vị là mặc định.",
      "baseLocked": "Đơn vị cơ bản đi theo món và không sửa được ở đây.",
      "optionUnitHelp": "Đơn vị mà tùy chọn này thêm vào, là một đơn vị bán của món, ví dụ phần gấp đôi. Để trống để dùng đơn vị cơ bản của món. Giá theo đơn vị này.",
      "choiceUnitHelp": "Đơn vị mà combo bao gồm, là một đơn vị bán của món, ví dụ lốc 6. Để trống để dùng đơn vị cơ bản của món. Số lượng tính theo đơn vị này."
    },
    "deal": {
      "taxHelp": "Nhóm thuế VAT cho mọi món trong combo, dùng khi các món thuộc các nhóm thuế khác nhau. Để trống để mỗi món tính theo VAT của nó."
    },
    "cost": {
      "storeHelp": "Để trống: giá vốn cho cả thương hiệu. Giá vốn riêng của cửa hàng được dùng tại cửa hàng đó.",
      "itemHelp": "Giá vốn của một đơn vị cơ bản. Không có giá vốn thì món được tính theo định lượng.",
      "dealHelp": "Giá vốn của một combo. Trên đơn hàng, giá vốn được chia cho các món trong combo; không có thì mỗi món giữ giá vốn của mình.",
      "storeRecipeHelp": "Định lượng của cửa hàng thay cho định lượng của món tại cửa hàng đó, khi tính giá vốn."
    }
  },
  "priceTable": {
    "emptyTitle": {
      "item": "Chưa đặt giá món nào",
      "deal": "Chưa đặt giá combo nào"
    },
    "title": "Giá",
    "group": "Nhóm",
    "state": "Thay đổi",
    "groups": {
      "item": "Món",
      "deal": "Combo"
    },
    "add": {
      "item": "Thêm món và đơn vị",
      "deal": "Thêm combo"
    },
    "empty": {
      "item": "Bảng giá chưa có món nào. Món không có giá ở đây sẽ bán theo giá cơ bản.",
      "deal": "Bảng giá chưa có combo nào."
    },
    "states": {
      "new": "Mới",
      "changed": "Đã sửa",
      "removed": "Sẽ xóa",
      "missing": "Cần nhập giá"
    },
    "columns": {
      "code": "Mã",
      "name": "Tên",
      "unit": "Đơn vị",
      "vat": "VAT",
      "price": "Giá ({{currency}})",
      "from": "Từ ngày",
      "to": "Đến ngày"
    },
    "taxIncluded": "Giá tính bằng {{currency}}, đã gồm thuế.",
    "taxExcluded": "Giá tính bằng {{currency}}, chưa gồm thuế.",
    "otherEntries_one": "{{count}} giá phụ thu lựa chọn combo không hiển thị ở đây và được giữ nguyên.",
    "otherEntries_other": "{{count}} giá phụ thu lựa chọn combo không hiển thị ở đây và được giữ nguyên.",
    "unitHint": "Mỗi giá là của một đơn vị của món. Đơn vị không có giá ở đây lấy giá đơn vị cơ bản nhân quy cách, nếu không thì theo giá cơ bản của món.",
    "baseUnit": "Đơn vị cơ bản",
    "unitSize": "{{factor}} đơn vị cơ bản",
    "unitsOf": "Đơn vị của {{name}}",
    "search": "Tìm theo mã, tên hoặc đơn vị",
    "searchCatalog": "Tìm theo mã, tên hoặc nhóm",
    "selectShown": "Chọn tất cả {{count}} dòng đang hiện",
    "chosen_one": "Đã chọn {{count}}",
    "chosen_other": "Đã chọn {{count}}",
    "inList": "Đã có trong bảng",
    "inactive": "Ngừng bán",
    "showMore": "Xem thêm ({{shown}}/{{total}})",
    "priceForAll": "Giá chung",
    "priceForAllHelp": "Để trống để nhập giá trong bảng.",
    "addChosen_one": "Thêm {{count}}",
    "addChosen_other": "Thêm {{count}}",
    "priceOf": "Giá của {{name}}",
    "unitOf": "Đơn vị của {{name}}",
    "vatOf": "VAT của {{name}} trên bảng giá này",
    "itemVat": "VAT của món ({{name}})",
    "itemVatUnknown": "VAT của món",
    "dealVat": "VAT của combo ({{name}})",
    "dealItemsVat": "VAT của từng món",
    "vatHint": "VAT được đặt cho từng món hoặc combo trên bảng giá này và áp dụng cho mọi đơn vị. Để là VAT của món hoặc combo để dùng nhóm thuế đặt ở đó. VAT của combo áp dụng cho mọi món trong combo.",
    "fromOf": "{{name}} từ ngày",
    "toOf": "{{name}} đến ngày",
    "remove": "Xóa {{name}}",
    "undoRemove": "Giữ {{name}}",
    "problems": {
      "price": "Nhập giá",
      "from": "Nhập ngày bắt đầu",
      "dates": "Phải sau ngày bắt đầu",
      "duplicate": "Có hai giá cùng bắt đầu ngày này"
    },
    "unsaved_one": "{{count}} thay đổi chưa lưu",
    "unsaved_other": "{{count}} thay đổi chưa lưu",
    "fix_one": "Sửa {{count}} dòng trước khi lưu.",
    "fix_other": "Sửa {{count}} dòng trước khi lưu.",
    "conflict": "Người khác vừa thay đổi bảng giá này. Tải lại để xem thay đổi của họ, rồi sửa lại phần của bạn.",
    "discard": "Bỏ thay đổi",
    "reload": "Tải lại",
    "save_one": "Lưu {{count}} thay đổi",
    "save_other": "Lưu {{count}} thay đổi",
    "saved_one": "Đã lưu {{count}} thay đổi. Cửa hàng nhận giá mới ở lần đồng bộ tới.",
    "saved_other": "Đã lưu {{count}} thay đổi. Cửa hàng nhận giá mới ở lần đồng bộ tới."
  },
  "priceMenus": {
    "unlink": "Gỡ liên kết",
    "emptyTitle": "Chưa liên kết thực đơn nào",
    "title": "Thực đơn",
    "add": "Thêm thực đơn",
    "search": "Tìm theo mã hoặc tên",
    "hintLinked": "Bảng giá này chỉ áp dụng cho các thực đơn này. Thực đơn khác dùng bảng giá riêng.",
    "hintNone": "Chưa gắn thực đơn: bảng giá này áp dụng cho mọi thực đơn chưa có bảng giá riêng.",
    "remove": "Bỏ gắn {{name}}",
    "link_one": "Gắn {{count}} thực đơn",
    "link_other": "Gắn {{count}} thực đơn"
  },
  "menuEditor": {
    "noPagesTitle": "Chưa có trang nào",
    "noTilesTitle": "Trang này chưa có gì",
    "noLayoutTitle": "Chưa có bố cục",
    "hint": "Món và combo đang bán được gửi xuống cửa hàng ở lần đồng bộ tiếp theo. Trang và ô chỉ đến cửa hàng khi đồng bộ các hồ sơ POS dùng bố cục này. Mỗi món có một ô cho từng đơn vị bán; ô không chọn đơn vị sẽ bán đơn vị bán mặc định của món.",
    "layout": "Bố cục thực đơn",
    "gridSize": "{{rows}} hàng × {{cols}} cột",
    "saveFirst": "Lưu hoặc bỏ thay đổi trước khi đổi bố cục.",
    "noLayout": "Thực đơn này chưa có bố cục. Tạo bố cục để sắp xếp các trang.",
    "createLayout": "Tạo bố cục",
    "gridRows": "Số hàng",
    "gridCols": "Số cột",
    "addPages": "Thêm trang",
    "addPagesCount_one": "Thêm {{count}} trang",
    "addPagesCount_other": "Thêm {{count}} trang",
    "pageNames": "Tên trang",
    "pageNamesHelp": "Mỗi dòng một trang, ví dụ Phở, Cơm, Đồ uống.",
    "pageName": "Tên trang",
    "palette": "Màu",
    "samePalette": "Theo màu trang",
    "unnamed": "Trang chưa có tên",
    "noPages": "Chưa có trang. Thêm trang để sắp xếp thực đơn trên POS.",
    "noTiles": "Trang này chưa có món hoặc combo.",
    "offPage": "Có trong thực đơn, không nằm trên trang",
    "offPageHint": "Nhân viên chỉ tìm được các mục này bằng tìm kiếm. Xoá sẽ bỏ khỏi thực đơn.",
    "search": "Tìm theo mã hoặc tên",
    "already": "Đã thêm",
    "defaultUnit": "Đơn vị mặc định",
    "onMenu": "Có trong thực đơn",
    "kinds": {
      "item": "Món",
      "deal": "Combo",
      "page": "Liên kết trang",
      "group": "Nhóm biến thể"
    },
    "add": {
      "item": "Thêm món và đơn vị",
      "deal": "Thêm combo",
      "group": "Thêm nhóm biến thể"
    },
    "addTo": {
      "item": "Thêm món vào {{page}}",
      "deal": "Thêm combo vào {{page}}",
      "group": "Thêm nhóm biến thể vào {{page}}"
    },
    "columns": {
      "label": "Tên trên ô",
      "row": "Hàng",
      "col": "Cột",
      "visible": "Hiển thị",
      "sort": "Thứ tự"
    },
    "labelOf": "Tên trên ô của {{name}}",
    "paletteOf": "Màu của {{name}}",
    "rowOf": "Hàng của {{name}}",
    "colOf": "Cột của {{name}}",
    "visibleOf": "Hiển thị {{name}}",
    "sortOf": "Thứ tự của {{name}}",
    "shown": "Hiện",
    "hidden": "Ẩn",
    "noRoom_one": "{{count}} mục không còn chỗ trên trang. Bỏ bớt ô hoặc tăng kích thước lưới rồi thêm lại.",
    "noRoom_other": "{{count}} mục không còn chỗ trên trang. Bỏ bớt ô hoặc tăng kích thước lưới rồi thêm lại.",
    "problems": {
      "name": "Nhập tên trang",
      "outside": "Nằm ngoài lưới",
      "overlap": "Hai ô trùng vị trí"
    },
    "fix_one": "Sửa {{count}} lỗi trước khi lưu.",
    "fix_other": "Sửa {{count}} lỗi trước khi lưu.",
    "conflict": "Người khác vừa thay đổi thực đơn này. Tải lại để xem thay đổi của họ rồi làm lại.",
    "saved_one": "Đã lưu {{count}} thay đổi.",
    "saved_other": "Đã lưu {{count}} thay đổi.",
    "groupButton": "Mở các biến thể của {{group}}",
    "groupButtonOff": "Bán món này",
    "groupButtonOn": "Mở chọn biến thể",
    "variants_one": "{{count}} biến thể",
    "variants_other": "{{count}} biến thể"
  },
  "posButtons": {
    "reset": {
      "button": "Đặt lại mặc định",
      "title": "Đặt lại các nút về mặc định?",
      "body": "Toàn bộ nút của {{name}} được thay bằng bộ mặc định: mọi nút POS hiển thị. Tên, biểu tượng và phím tắt bạn đã đặt sẽ bị xoá. Cửa hàng nhận thay đổi khi bạn đồng bộ hồ sơ.",
      "confirm": "Đặt lại nút",
      "done_one": "Đã đặt lại: {{count}} nút mặc định.",
      "done_other": "Đã đặt lại: {{count}} nút mặc định."
    }
  },
  "flows": {
    "steps": "Các bước",
    "emptyTitle": "Chưa có bước nào",
    "columns": {
      "number": "STT",
      "step": "Bước",
      "required": "Bắt buộc"
    },
    "moveUpOf": "Chuyển {{step}} lên",
    "moveDownOf": "Chuyển {{step}} xuống",
    "removeOf": "Xóa {{step}}",
    "hint": "Các bước mà một loại bán hàng thực hiện, theo thứ tự. Bước bắt buộc phải xong trước các thao tác sau nó; bước tùy chọn không chặn gì. Thay đổi được lưu cùng lúc.",
    "stepNumber": "Bước {{number}}",
    "required": "Bắt buộc",
    "optional": "Tùy chọn",
    "requiredOf": "{{step}} là bước bắt buộc",
    "moveUp": "Chuyển lên",
    "moveDown": "Chuyển xuống",
    "remove": "Xóa bước",
    "add": "Thêm bước",
    "addPlaceholder": "Chọn bước để thêm",
    "empty": "Quy trình này chưa có bước nào. Hãy thêm bước hoặc bắt đầu từ một mẫu.",
    "unsaved_other": "{{count}} thay đổi chưa lưu",
    "save_other": "Lưu {{count}} thay đổi",
    "discard": "Hủy thay đổi",
    "conflict": "Người khác đã thay đổi quy trình này. Hãy tải lại để xem thay đổi của họ.",
    "problems": {
      "repeated": "Mỗi bước chỉ xuất hiện một lần trong quy trình; chỉ bước hỏi thêm (prompt) được lặp lại.",
      "empty": "Quy trình cần ít nhất một bước.",
      "acceptFirst": "Bước nhận đơn trực tuyến phải là bước đầu tiên và là bước bắt buộc."
    },
    "preset": {
      "label": "Bắt đầu từ mẫu",
      "placeholder": "Thay các bước bằng một mẫu…",
      "name": "{{vi}}"
    },
    "fromPreset": {
      "button": "Tạo từ mẫu",
      "title": "Tạo quy trình bán từ mẫu",
      "body": "Quy trình mới bắt đầu với các bước của mẫu. Sau đó bạn có thể thêm, xóa, sắp xếp lại và đổi các bước.",
      "create": "Tạo",
      "code": "Mã",
      "name": "Tên",
      "placeholder": "Chọn một mẫu…",
      "preset": "Mẫu"
    },
    "step": {
      "select_table": "Chọn bàn",
      "enter_guests": "Nhập số khách",
      "select_customer": "Chọn khách hàng",
      "prompt": "Hỏi thêm (prompt)",
      "take_order": "Nhận món",
      "send_to_kitchen": "Gửi bếp",
      "print_bill": "In tạm tính",
      "take_payment": "Thanh toán",
      "assign_driver": "Giao tài xế",
      "close": "Đóng đơn",
      "accept_order": "Nhận đơn trực tuyến",
      "mark_ready": "Báo món xong",
      "out_for_delivery": "Giao cho tài xế",
      "hand_over": "Giao cho khách",
      "deliver": "Đã giao xong"
    }
  },
  "delivery": {
    "providers": {
      "title": "Nhà cung cấp giao hàng",
      "intro": "Các tài khoản văn phòng chính dùng để đặt giao hàng với nhà cung cấp. Thông tin xác thực được nhập tại đây, lưu mã hóa và không hiển thị lại. Cửa hàng không nhận được chúng.",
      "add": "Thêm tài khoản nhà cung cấp",
      "empty": "Chưa có tài khoản nhà cung cấp. Hãy thêm để cung cấp dịch vụ giao hàng của nhà cung cấp.",
      "columns": {
        "name": "Tài khoản",
        "provider": "Nhà cung cấp",
        "environment": "Môi trường",
        "credentials": "Xác thực",
        "status": "Trạng thái"
      },
      "env": {
        "sandbox": "Thử nghiệm",
        "production": "Chính thức"
      },
      "credentialsSet": "Đã nhập",
      "credentialsMissing": "Còn thiếu",
      "active": "Đang dùng",
      "inactive": "Tạm dừng",
      "deleteTitle": "Xóa tài khoản nhà cung cấp",
      "deleteBody": "Xóa “{{name}}”? Các dịch vụ giao hàng dùng tài khoản này sẽ không đặt được nữa.",
      "dialog": {
        "provider": "Nhà cung cấp",
        "name": "Tên",
        "environment": "Môi trường",
        "active": "Đang dùng",
        "credentials": "Thông tin xác thực",
        "credentialsHint": "Không hiển thị lại. Để trống một ô để giữ giá trị đã lưu.",
        "saved": "đã lưu",
        "replace": "Thay",
        "test": "Kiểm tra kết nối",
        "testOk": "Kết nối hoạt động.",
        "testFailed": "Kết nối thất bại ({{code}}).",
        "saveFirst": "Hãy lưu tài khoản trước khi thử kết nối."
      }
    },
    "services": {
      "title": "Dịch vụ giao hàng",
      "intro": "Những gì thu ngân có thể chọn khi giao hàng: tài xế của cửa hàng, hoặc dịch vụ của nhà cung cấp được đặt qua văn phòng chính. Một dịch vụ chỉ áp dụng ở nơi có dòng bật bên dưới.",
      "add": "Thêm dịch vụ giao hàng",
      "empty": "Chưa có dịch vụ giao hàng. Tài xế của cửa hàng luôn được cung cấp cho đến khi bạn thêm một dịch vụ.",
      "columns": {
        "code": "Mã",
        "name": "Tên",
        "kind": "Loại",
        "provider": "Nhà cung cấp",
        "fee": "Phí",
        "status": "Trạng thái"
      },
      "kinds": {
        "internal": "Tài xế cửa hàng",
        "external": "Nhà cung cấp"
      },
      "feeModes": {
        "manual": "Thu ngân nhập",
        "fixed": "Số tiền cố định",
        "quote": "Theo báo giá của nhà cung cấp"
      },
      "account": "Tài khoản nhà cung cấp",
      "serviceType": "Dịch vụ của nhà cung cấp",
      "fixedFee": "Phí cố định",
      "sortOrder": "Thứ tự trong danh sách",
      "noAccounts": "Hãy thêm tài khoản nhà cung cấp trước.",
      "created": "Đã lưu dịch vụ. Chọn bên dưới nơi áp dụng, rồi đóng.",
      "deleteTitle": "Xóa dịch vụ giao hàng",
      "deleteBody": "Xóa “{{name}}”? Dịch vụ sẽ không còn ở cửa hàng nào.",
      "scope": {
        "any": "Tất cả",
        "everywhere": "Mọi nơi",
        "unknown": "Không rõ ({{id}})",
        "brand": "Thương hiệu",
        "store": "Cửa hàng",
        "profile": "Hồ sơ POS",
        "saleType": "Loại bán hàng"
      },
      "assignments": {
        "title": "Nơi áp dụng",
        "hint": "Chỉ áp dụng ở nơi có dòng bật khớp. Dòng cụ thể nhất được ưu tiên: hồ sơ POS, rồi cửa hàng, thương hiệu, mọi nơi. Để ô là Tất cả để bao trùm.",
        "add": "Thêm",
        "none": "Chưa áp dụng ở đâu.",
        "deleteTitle": "Gỡ nơi áp dụng này",
        "deleteBody": "Gỡ “{{scope}}”? Dịch vụ sẽ không còn áp dụng ở đó.",
        "on": "Bật",
        "off": "Tắt"
      },
      "profiles": {
        "title": "Hồ sơ tích hợp",
        "hint": "Tài khoản nào đặt dịch vụ này cho một thương hiệu hoặc cửa hàng, với loại dịch vụ và thiết lập riêng. Hồ sơ của cửa hàng được dùng trước, rồi đến của thương hiệu, rồi hồ sơ cho tất cả; không có hồ sơ thì dùng tài khoản của dịch vụ.",
        "none": "Chưa có hồ sơ: mọi cửa hàng đặt bằng tài khoản của dịch vụ.",
        "add": "Thêm hồ sơ",
        "save": "Lưu hồ sơ",
        "editing": "Đang sửa “{{name}}”",
        "name": "Tên hồ sơ",
        "scope": "Áp dụng cho",
        "account": "Tài khoản",
        "noAccount": "Hãy thêm tài khoản của đối tác này trước.",
        "accountGone": "Tài khoản đã xóa",
        "serviceType": "Loại dịch vụ",
        "serviceTypeHelp": "Để trống: dùng loại của dịch vụ. Có thể nhập mã riêng của đối tác (vd. HAN-BIKE).",
        "settingsHint": "Thiết lập hồ sơ này dùng thay cho của tài khoản. Để trống để giữ giá trị của tài khoản.",
        "accountValue": "Theo tài khoản",
        "deleteTitle": "Xóa hồ sơ này?",
        "deleteBody": "Xóa “{{name}}”? Thương hiệu hoặc cửa hàng sẽ dùng hồ sơ tiếp theo phù hợp. Các đơn giao đã đặt không bị ảnh hưởng."
      }
    }
  },
  "integration": {
    "setting": {
      "scenario": "Kịch bản",
      "stepSeconds": "Số giây mỗi bước",
      "webhookSecret": "Khóa webhook",
      "baseUrl": "Địa chỉ API",
      "lookupUrl": "Trang tra cứu cho người mua",
      "invoiceDate": "Ngày lập hóa đơn",
      "taxCode": "Mã số thuế đăng nhập",
      "signOnIssue": "Ký số khi xuất (chứng thư số lưu tại nhà cung cấp)",
      "username": "Tên đăng nhập",
      "password": "Mật khẩu",
      "payPageUrl": "Trang thanh toán (mô phỏng)",
      "paymentUrl": "Địa chỉ trang thanh toán",
      "apiUrl": "Địa chỉ API",
      "serverIp": "Địa chỉ IP máy chủ",
      "vnpayTmnCode": "Mã website (vnp_TmnCode)",
      "vnpayHashSecret": "Chuỗi bí mật (hash secret)",
      "momoPartnerCode": "Mã đối tác (partner code)",
      "momoRequestType": "Loại yêu cầu",
      "momoStoreId": "Mã cửa hàng MoMo",
      "momoAccessKey": "Access key",
      "momoSecretKey": "Secret key",
      "zalopayAppId": "App id",
      "zalopayAppUser": "App user",
      "zalopayKey1": "Khóa MAC (key 1)",
      "zalopayKey2": "Khóa callback (key 2)",
      "brandname": "Brandname (tên người gửi SMS)",
      "smsUnicode": "Dấu tiếng Việt: auto (gửi SMS Unicode khi có dấu) hoặc never (gửi không dấu)",
      "zaloOaId": "Zalo OA id",
      "accessToken": "Access token",
      "gaponeClientId": "Client id",
      "gaponeClientSecret": "Client secret",
      "gaponeApiUrl": "Địa chỉ API quản lý",
      "vietguysPasscode": "Passcode (API token)",
      "zaloAppId": "Zalo app id",
      "zaloDevelopmentMode": "Chế độ phát triển (chỉ quản trị viên OA nhận tin)",
      "zaloOauthUrl": "Địa chỉ OAuth",
      "zaloSecretKey": "Khóa bí mật của ứng dụng",
      "zaloRefreshToken": "Refresh token",
      "clientId": "Client id",
      "tokenUrl": "Địa chỉ lấy token",
      "grabPaymentMethod": "Bên trả cước: CASHLESS (tài khoản Grab của cửa hàng) hoặc CASH",
      "grabCityCode": "Mã thành phố (không bắt buộc, theo danh sách của Grab)",
      "searchTimeoutMinutes": "Số phút tìm tài xế trước khi dừng",
      "clientSecret": "Client secret",
      "ahamoveMobile": "Số điện thoại của tài khoản Ahamove",
      "ahamovePaymentMethod": "Bên trả cước: BALANCE (ví của tài khoản), CASH hoặc CASH_BY_RECIPIENT",
      "apiKey": "API key",
      "xanhSmEndpoint": "Địa chỉ API kèm mã đối tác (…/gsm-partner-booking/{partnerId})",
      "xanhSmSenderName": "Tên người gửi",
      "xanhSmSenderPhone": "Số điện thoại người gửi",
      "xanhSmPaymentMethod": "Bên trả cước: partner_pay (tính vào công nợ cửa hàng) hoặc cash",
      "xanhSmCodAddonId": "Mã dịch vụ thu hộ COD (do Xanh SM cung cấp)",
      "xanhSmPackageSize": "Kích thước gói hàng",
      "xanhSmPackageWeight": "Khối lượng gói hàng (kg)",
      "xanhSmRefreshToken": "Application refresh token",
      "smtpHost": "Máy chủ SMTP",
      "smtpPort": "Cổng",
      "smtpSecurity": "Bảo mật: starttls (thường cổng 587), ssl (cổng 465) hoặc none (chỉ cho máy chủ chuyển tiếp nội bộ)",
      "fromAddress": "Địa chỉ người gửi",
      "fromName": "Tên người gửi",
      "maxPerSecond": "Số tin mỗi giây (mỗi worker)",
      "maxParallel": "Số tin gửi cùng lúc (mỗi worker)"
    }
  },
  "rolePermissions": {
    "search": "Tìm quyền",
    "count": "Bật {{granted}}/{{total}}",
    "none": "Không có quyền nào khớp.",
    "on": "Bật",
    "off": "Tắt",
    "allPermissions": "Tất cả quyền",
    "wholeArea": "Toàn bộ {{area}}, kể cả màn hình thêm sau này",
    "included": "Đã bao gồm",
    "feature": "Chức năng",
    "code": "Mã quyền",
    "read": "Xem",
    "manage": "Quản lý",
    "allowed": "Được phép",
    "area": {
      "reporting": "Báo cáo"
    },
    "wholeKey": "Mọi quyền thuộc {{code}}, kể cả màn hình thêm sau",
    "sensitive": "Nhạy cảm",
    "needs": "Cấp kèm {{codes}}, là quyền cần có",
    "dataKind": {
      "tenant": "Công ty",
      "brand": "Thương hiệu",
      "store": "Cửa hàng"
    }
  },
  "address": {
    "country": "Quốc gia",
    "choose": "Chọn hoặc gõ để tìm",
    "street": "Số nhà, tên đường",
    "postalCode": "Mã bưu chính",
    "unavailable": "Không tải được danh mục địa điểm.",
    "notSetUp": "Chưa có danh mục địa điểm. Hãy nhờ văn phòng chính nhập danh mục. Tạm thời chỉ cần nhập địa chỉ đường.",
    "required": "Bắt buộc nhập.",
    "noMatch": "Không có kết quả phù hợp. Hãy kiểm tra chính tả hoặc chọn trong danh sách."
  },
  "locations": {
    "title": "Nhập danh mục địa điểm",
    "intro": "Quốc gia, tỉnh/thành phố và phường/xã mà mọi địa chỉ sử dụng. Nhập danh mục đi kèm hệ thống hoặc một tệp mới hơn. Các cửa hàng nhận thay đổi qua đồng bộ.",
    "counts": "Đã nhập {{imported}}/{{total}} đơn vị hành chính",
    "invalidFile": "Tệp này không phải JSON hợp lệ. Hãy chọn tệp cùng định dạng với các danh mục có sẵn.",
    "importing": "Đang nhập…",
    "noDatasets": "Chưa có danh mục địa điểm nào để nhập.",
    "version": "Bộ dữ liệu ngày {{version}}",
    "import": "Nhập",
    "update": "Cập nhật",
    "uploadFile": "Nhập từ tệp",
    "fileHint": "Tệp JSON cùng định dạng với danh mục tích hợp. Đơn vị không còn trong tệp sẽ được đóng, không bị xóa.",
    "done": "Xong: thêm {{created}}, thay đổi {{updated}}, đóng {{closed}}."
  },
  "docs": {
    "title": "Hướng dẫn sử dụng NextGen POS",
    "userGuide": "Hướng dẫn sử dụng",
    "signIn": "Đăng nhập vào cổng quản trị",
    "home": "Tài liệu",
    "breadcrumb": "Đường dẫn",
    "pager": "Trang trước và trang sau",
    "previous": "Trước",
    "next": "Tiếp",
    "onThisPage": "Trong trang này",
    "copyLink": "Sao chép liên kết tới {{heading}}",
    "linkCopied": "Đã sao chép liên kết",
    "backHome": "Về trang chủ hướng dẫn",
    "search": {
      "label": "Tìm trong hướng dẫn",
      "placeholder": "Tìm trong hướng dẫn (nhấn / để nhập)",
      "results": "Kết quả tìm kiếm",
      "noResults": "Không có kết quả cho “{{query}}”. Thử ít từ hơn hoặc từ khác.",
      "resultsCount_other": "{{count}} kết quả"
    },
    "callout": {
      "note": "Lưu ý",
      "tip": "Mẹo",
      "warning": "Cảnh báo"
    },
    "image": {
      "missing": "Chưa có ảnh chụp màn hình",
      "enlarge": "Phóng to ảnh: {{caption}}",
      "label": "Ảnh chụp màn hình"
    },
    "loading": "Đang tải hướng dẫn",
    "notTranslated": {
      "title": "Trang này chưa có bản dịch; đang hiển thị bản tiếng Anh.",
      "subtitle": "Các phần còn lại của hướng dẫn bằng tiếng Việt."
    },
    "groups": {
      "gettingStarted": "Bắt đầu",
      "pos": "POS",
      "storeManager": "Quản lý cửa hàng",
      "hoAdministrator": "Quản trị trụ sở",
      "kitchenAndPrinters": "Bếp và máy in",
      "reference": "Tra cứu"
    },
    "englishOnly": {
      "title": "Hướng dẫn hiện chỉ có bằng tiếng Anh.",
      "subtitle": "Màn hình và nút bấm hiển thị bằng ngôn ngữ của bạn; nội dung hướng dẫn bằng tiếng Anh, kèm nhãn tiếng Việt trong ngoặc."
    },
    "notFound": {
      "title": "Không tìm thấy trang",
      "description": "Trang này của hướng dẫn không tồn tại. Có thể trang đã được chuyển: hãy tìm trong hướng dẫn hoặc bắt đầu từ trang chủ."
    },
    "landing": {
      "heading": "Hướng dẫn sử dụng NextGen POS",
      "intro": "Cách dùng NextGen POS hằng ngày: tại quầy, trong văn phòng cửa hàng và tại trụ sở. Chọn phần phù hợp với công việc của bạn hoặc tìm trong hướng dẫn.",
      "start": "Bắt đầu từ chương đầu tiên",
      "tiles": {
        "pos": {
          "title": "Dùng POS",
          "text": "Gọi món, bếp, hóa đơn, thanh toán, giao hàng và ngày kinh doanh, dành cho thu ngân và phục vụ."
        },
        "store": {
          "title": "Quản lý cửa hàng",
          "text": "Cổng quản trị cửa hàng: tổng quan, đơn hàng, theo dõi bếp và kết nối với trụ sở."
        },
        "ho": {
          "title": "Quản trị trụ sở",
          "text": "Thực đơn và giá, thiết lập POS, thiết bị, bàn, giao hàng, nhân viên và vai trò, đồng bộ và nhật ký."
        },
        "kitchen": {
          "title": "Bếp và máy in",
          "text": "Đơn đã gửi trở thành phiếu bếp như thế nào, cách kết nối và kiểm tra máy in."
        },
        "troubleshooting": {
          "title": "Xử lý sự cố",
          "text": "Sự cố và cách xử lý với POS, in, thanh toán và đồng bộ, kèm câu hỏi thường gặp."
        }
      }
    }
  },
  "shiftSetup": {
    "copy": {
      "button": "Sao chép từ cửa hàng khác",
      "title": "Sao chép ca từ cửa hàng khác",
      "confirm": "Sao chép ca",
      "from": "Sao chép từ",
      "to": "Đến cửa hàng",
      "replaces": "Các ca hiện có của cửa hàng này sẽ được thay bằng các ca sao chép.",
      "settings": "Sao chép cả thiết lập ca",
      "done": "Đã sao chép {{count}} ca."
    }
  },
  "rules": {
    "conditions": {
      "sale_type": "Loại bán hàng",
      "sales_channel": "Kênh bán",
      "store": "Cửa hàng",
      "table_area": "Khu vực bàn",
      "guest_count": "Số khách",
      "order_subtotal": "Giá trị đơn",
      "days_of_week": "Ngày trong tuần",
      "time_window": "Khung giờ",
      "date_range": "Khoảng ngày",
      "item_in_order": "Món trong đơn",
      "category_in_order": "Nhóm món trong đơn",
      "target_line_item": "Món được giảm",
      "member_tier": "Hạng hội viên",
      "member_points": "Điểm hiện có",
      "member_orders": "Số đơn đã thanh toán",
      "member_days_since_joined": "Số ngày từ khi gia nhập",
      "member_days_since_order": "Số ngày từ đơn gần nhất",
      "member_marketing_consent": "Đồng ý nhận tiếp thị",
      "customer_is_member": "Là hội viên",
      "customer_orders": "Số đơn đã thanh toán, toàn bộ",
      "customer_orders_30d": "Số đơn, 30 ngày qua",
      "customer_orders_90d": "Số đơn, 90 ngày qua",
      "customer_orders_365d": "Số đơn, 365 ngày qua",
      "customer_spend": "Đã chi, toàn bộ",
      "customer_spend_30d": "Đã chi, 30 ngày qua",
      "customer_spend_90d": "Đã chi, 90 ngày qua",
      "customer_spend_365d": "Đã chi, 365 ngày qua",
      "customer_average_order": "Giá trị đơn trung bình",
      "customer_days_since_order": "Số ngày từ đơn gần nhất",
      "customer_days_since_first_order": "Số ngày từ đơn đầu tiên",
      "customer_store": "Đã đặt tại",
      "customer_channel": "Đã đặt qua",
      "customer_category": "Đã mua, 365 ngày qua",
      "customer_birth_month": "Tháng sinh",
      "customer_birthday_this_month": "Sinh nhật trong tháng này",
      "customer_consent_zns": "Đồng ý nhận tin Zalo",
      "customer_consent_sms": "Đồng ý nhận SMS",
      "customer_consent_email": "Đồng ý nhận email"
    },
    "groups": {
      "order": "Đơn hàng",
      "where": "Ở đâu",
      "when": "Khi nào",
      "items": "Món",
      "member": "Hội viên",
      "customer": "Khách hàng",
      "habits": "Thói quen đặt món"
    },
    "params": {
      "in": "Một trong các",
      "min": "Tối thiểu",
      "max": "Tối đa",
      "days": "Ngày",
      "from": "Từ",
      "to": "Đến",
      "minQuantity": "Số lượng tối thiểu",
      "items": "Món",
      "categories": "Nhóm món"
    },
    "days": {
      "1": "T2",
      "2": "T3",
      "4": "T4",
      "8": "T5",
      "16": "T6",
      "32": "T7",
      "64": "CN"
    },
    "reason": {
      "points_not_with_discounts": "Điểm không dùng cùng giảm giá khác trên một hóa đơn nên đã được bỏ. Bỏ giảm giá kia để đổi lại điểm.",
      "points_over_limit": "Điểm được bỏ khi vượt quá {{max}}% giá trị món chưa VAT. Hãy đổi lại điểm cho tổng mới.",
      "sale_type": "Không áp dụng cho loại bán hàng này.",
      "sales_channel": "Không áp dụng cho kênh bán này.",
      "store": "Không áp dụng tại cửa hàng này.",
      "table_area": "Không áp dụng cho khu vực bàn này.",
      "guest_count": "Không áp dụng cho số khách này ({{actual}}).",
      "order_subtotal": "Không áp dụng cho giá trị đơn này ({{actual}}).",
      "days_of_week": "Không áp dụng vào ngày này.",
      "time_window": "Chỉ áp dụng từ {{from}} đến {{to}}.",
      "date_range": "Không áp dụng vào ngày này.",
      "item_in_order": "Đơn chưa có các món cần thiết.",
      "category_in_order": "Đơn chưa có các món cần thiết.",
      "target_line_item": "Không áp dụng cho món này.",
      "excluded": "Không áp dụng cho đơn này.",
      "unusable": "Cửa hàng không đọc được quy tắc. Hãy liên hệ văn phòng.",
      "evaluation_failed": "Không kiểm tra được quy tắc. Hãy liên hệ văn phòng."
    },
    "builder": {
      "always": "Luôn áp dụng",
      "alwaysHint": "Thêm điều kiện để giới hạn khi nào áp dụng.",
      "match": "Áp dụng khi",
      "all": "Thỏa tất cả",
      "any": "Thỏa một trong",
      "exclude": "Trừ khi điều kiện này đúng",
      "addCondition": "Thêm điều kiện",
      "addGroup": "Thêm nhóm",
      "remove": "Xóa {{name}}",
      "group": "Nhóm",
      "invalid": "Không dùng được quy tắc: {{problem}}",
      "loading": "Đang tải điều kiện",
      "and": "và",
      "or": "hoặc",
      "choose": "Chọn",
      "excluded": "Loại trừ"
    }
  },
  "chargeTypes": {
    "amountEntryHelp": "Thu ngân nhập giá trị khi thêm phí này trên POS; Giá trị là mức POS gợi ý.",
    "maxValueHelp": "Mức tối đa thu ngân được nhập (phần trăm không quá 100). Để trống nếu không giới hạn."
  },
  "promotions": {
    "downloadCodes": "Tải danh sách mã (CSV)",
    "downloadVouchers": "Tải danh sách phiếu (CSV)",
    "downloadFailed": "Không tải được tệp. Hãy thử lại."
  },
  "loyalty": {
    "points": {
      "tab": "Điểm",
      "balance": "{{points}} điểm",
      "reserved": "{{points}} điểm đang giữ cho đơn chưa xong",
      "adjust": "Điều chỉnh điểm",
      "adjustSave": "Điều chỉnh",
      "adjustPoints": "Số điểm",
      "adjustHelp": "Số dương để cộng điểm, số âm để trừ điểm.",
      "adjustNote": "Lý do",
      "empty": "Chưa có điểm",
      "columns": {
        "when": "Thời gian",
        "type": "Loại",
        "points": "Điểm",
        "balance": "Số dư",
        "note": "Ghi chú",
        "tierPoints": "Điểm xếp hạng",
        "expiresAt": "Hết hạn"
      },
      "types": {
        "earn": "Tích điểm",
        "reverse": "Thu hồi",
        "redeem": "Dùng điểm",
        "refund": "Hoàn điểm",
        "adjust": "Điều chỉnh",
        "reward": "Chương trình ưu đãi",
        "expire": "Hết hạn"
      },
      "tierPoints": "{{points}} điểm xếp hạng",
      "expiring": "{{points}} điểm hết hạn ngày {{date}}"
    },
    "cards": {
      "generate": "Tạo thẻ",
      "generateSave": "Tạo",
      "quantity": "Số thẻ",
      "quantityHelp": "Từ 1 đến 1.000 thẻ trống theo dãy số của chương trình, để in và phát cho khách.",
      "made": "Đã tạo {{count}} thẻ: từ {{first}} đến {{last}}."
    },
    "viewOrders": "Xem đơn hàng",
    "history": {
      "title": "Lịch sử điểm hội viên",
      "hint": "Mọi biến động điểm của hội viên, mới nhất trước. Tìm theo số tài khoản, số thẻ hoặc số đơn; mở một dòng để xem tài khoản hội viên.",
      "capped": "Có hơn 10.000 bút toán phù hợp. Hãy thu hẹp bộ lọc hoặc tìm kiếm để xem hết.",
      "account": "Tài khoản",
      "order": "Đơn hàng",
      "store": "Cửa hàng"
    },
    "rewards": {
      "tab": "Ưu đãi",
      "title": "Mã giảm giá và phiếu quà tặng",
      "hint": "Cấp cho hội viên này thủ công hoặc bởi chương trình ưu đãi. Mã chỉ hiển thị cho hội viên.",
      "issue": "Cấp ưu đãi",
      "issueSave": "Cấp",
      "kind": "Loại ưu đãi",
      "coupon": "Mã giảm giá",
      "giftVoucher": "Phiếu quà tặng",
      "promotion": "Chương trình khuyến mãi",
      "promotionHelp": "Một mã dùng một lần của chương trình đang hoạt động.",
      "batch": "Lô phiếu quà tặng",
      "batchHelp": "Một phiếu còn trống của lô được cấp cho hội viên.",
      "validDays": "Hiệu lực (ngày)",
      "validDaysHelp": "Để trống để dùng theo thời hạn của chương trình hoặc phiếu.",
      "note": "Ghi chú",
      "empty": "Hội viên này chưa được cấp ưu đãi nào.",
      "noEnd": "Không giới hạn",
      "byHand": "Thủ công",
      "byProgram": "Chương trình ưu đãi",
      "columns": {
        "issued": "Ngày cấp",
        "kind": "Loại",
        "code": "Mã",
        "validTo": "Hết hạn",
        "source": "Cấp bởi",
        "note": "Ghi chú"
      },
      "points": "Điểm"
    },
    "issueList": {
      "title": "Cấp ưu đãi cho hội viên",
      "hint": "Cấp cùng một mã giảm giá hoặc phiếu quà tặng cho danh sách hội viên theo số tài khoản, tối đa 1.000 mỗi lần. Gửi lại cùng danh sách sẽ không cấp trùng.",
      "batchHelp": "Mỗi hội viên nhận một phiếu còn trống của lô; hội viên vượt quá số còn lại sẽ được liệt kê.",
      "accounts": "Số tài khoản",
      "accountsHelp_one": "{{count}} tài khoản: mỗi dòng một số, hoặc cách nhau bằng dấu phẩy.",
      "accountsHelp_other": "{{count}} tài khoản: mỗi dòng một số, hoặc cách nhau bằng dấu phẩy.",
      "tooMany": "Tối đa 1.000 số tài khoản mỗi lần.",
      "issue_one": "Cấp cho {{count}} hội viên",
      "issue_other": "Cấp cho {{count}} hội viên",
      "issued_one": "Đã cấp cho {{count}} hội viên.",
      "issued_other": "Đã cấp cho {{count}} hội viên.",
      "refused": "Chưa cấp được",
      "accountNo": "Tài khoản",
      "reason": "Lý do",
      "another": "Cấp cho danh sách khác"
    },
    "programs": {
      "triggers": {
        "help": "Sự kiện thưởng cho hội viên ngay khi xảy ra; lịch hoặc điều kiện sẽ xét mọi hội viên của câu lạc bộ.",
        "chooseFirst": "Chọn khi nào chương trình thưởng cho hội viên để thiết lập.",
        "joined": "Gia nhập câu lạc bộ",
        "birthday": "Sinh nhật",
        "tier_reached": "Lên hạng",
        "order_milestone": "Mốc số đơn hàng",
        "schedule": "Theo lịch",
        "condition": "Hội viên đạt điều kiện",
        "segment_joined": "Vào một nhóm khách hàng",
        "segment_joinedHelp": "Hội viên được thưởng khi vào nhóm khách hàng chọn ở mục “Chỉ hội viên thuộc nhóm”, kể từ khi chương trình bắt đầu."
      },
      "rewards": {
        "help": "Mỗi hội viên nhận một lần cho mỗi dịp.",
        "chooseFirst": "Chọn phần thưởng để thiết lập.",
        "points": "Điểm",
        "coupon": "Mã giảm giá",
        "gift_voucher": "Phiếu quà tặng"
      },
      "settings": {
        "includeExisting": "Cả hội viên đã gia nhập trước khi chương trình bắt đầu",
        "includeExistingHelp": "Tắt: chỉ hội viên gia nhập từ bây giờ.",
        "daysBefore": "Số ngày trước sinh nhật",
        "daysBeforeHelp": "Từ 0 đến 60; 0 là thưởng đúng ngày. Sinh nhật 29/2 được tính vào 28/2 ở các năm khác.",
        "tierIds": "Hạng",
        "tierIdsHelp": "Không chọn: mọi hạng.",
        "orders": "Số đơn hàng đã thanh toán",
        "ordersHelp": "Đơn hàng được tích điểm, từ 1 đến 10.000.",
        "repeat": "Mỗi lần đạt thêm số đó",
        "repeatHelp": "Tắt: một lần, khi đạt số đó.",
        "mode": "Tần suất",
        "modeHelp": "Mọi hội viên đang hoạt động của câu lạc bộ, mỗi lần một phần thưởng.",
        "onDate": "Ngày",
        "onDateHelp": "Theo múi giờ của câu lạc bộ.",
        "day": "Ngày trong tháng",
        "dayHelp": "Từ 1 đến 28.",
        "weekday": "Thứ trong tuần",
        "weekdayHelp": "",
        "time": "Giờ",
        "timeHelp": "Từ giờ này trong ngày.",
        "period": "Mỗi hội viên được thưởng tối đa",
        "periodHelp": "Mọi hội viên được xét mỗi ngày; người đạt điều kiện được thưởng tối đa với tần suất này.",
        "points": "Số điểm",
        "pointsHelp": "Lớn hơn 0, tối đa 2 chữ số thập phân.",
        "promotionId": "Khuyến mãi",
        "promotionIdHelp": "Khuyến mãi đang hoạt động; mỗi hội viên nhận một mã dùng một lần.",
        "voucherBatchId": "Lô phiếu quà tặng",
        "voucherBatchIdHelp": "Mỗi hội viên nhận một phiếu miễn phí của lô khi lô còn phiếu.",
        "validDays": "Hiệu lực (ngày)",
        "validDaysHelp": "Để trống: theo thời hạn của khuyến mãi hoặc phiếu.",
        "modes": {
          "once": "Một lần",
          "monthly": "Hằng tháng",
          "weekly": "Hằng tuần"
        },
        "weekdays": {
          "1": "Thứ Hai",
          "2": "Thứ Ba",
          "3": "Thứ Tư",
          "4": "Thứ Năm",
          "5": "Thứ Sáu",
          "6": "Thứ Bảy",
          "7": "Chủ Nhật"
        },
        "periods": {
          "once": "Một lần",
          "year": "Mỗi năm một lần",
          "month": "Mỗi tháng một lần",
          "week": "Mỗi tuần một lần"
        }
      }
    }
  },
  "printTemplates": {
    "preview": "Xem trước",
    "fields": "Các trường dữ liệu",
    "help": "Thẻ và hàm",
    "previewHint": "Một {{document}} mẫu trên giấy {{width}} mm, như cửa hàng in ra. Dòng in đậm và cỡ đôi hiển thị như khi in.",
    "chooseType": "Chọn loại chứng từ để xem trước.",
    "previewError": "Dòng {{line}}, cột {{column}}: {{message}}",
    "previewErrorNoLine": "Không in được mẫu này: {{message}}",
    "previewFailed": "Hiện chưa xem trước được.",
    "startFromBuiltIn": "Bắt đầu từ mẫu có sẵn",
    "replaceTitle": "Thay nội dung mẫu?",
    "replaceBody": "Nội dung mẫu sẽ được thay bằng mẫu có sẵn của chứng từ này. Những gì bạn đã nhập sẽ mất.",
    "replace": "Thay",
    "footerOnly": "Chân trang được in bên dưới phiếu tạm tính hoặc hóa đơn có sẵn, đúng như đã nhập. Chọn Mẫu in để trình bày cả chứng từ.",
    "fieldsHint": "Các trường của {{document}}, kèm ví dụ mẫu. Danh sách dùng với for, ví dụ {{loop}}.",
    "field": "Trường",
    "example": "Ví dụ",
    "drawer": "Mở ngăn kéo tiền",
    "cut": "Cắt giấy",
    "helpIntro": "Mẫu in là văn bản Scriban. Mỗi dòng kết quả là một dòng in; dòng trống bị bỏ qua. Đặt thẻ ở đầu dòng để định dạng.",
    "tags": "Thẻ",
    "functions": "Hàm",
    "tag": {
      "center": "Căn giữa dòng",
      "right": "Căn phải dòng",
      "b": "In đậm",
      "double": "Cỡ đôi (chỉ vừa nửa số ký tự)",
      "rule": "Kẻ một đường ngang (<rule => kẻ bằng =)",
      "feed": "Dòng trống (<feed 2> cho hai dòng)",
      "cut": "Cắt giấy",
      "drawer": "Mở ngăn kéo tiền (chỉ khi thanh toán yêu cầu)",
      "qr": "Mã QR của một đường dẫn, căn giữa (<qr 5 đường dẫn> cho chấm lớn hơn) (đường dẫn lấy hóa đơn GTGT của hóa đơn bán hàng là invoice_form_url)"
    },
    "function": {
      "money": "Số tiền theo tiền tệ của đơn",
      "qty": "Số lượng, bỏ số 0 thừa",
      "time": "Thời gian theo múi giờ cửa hàng; có thể thêm định dạng như \"HH:mm\"",
      "row": "Nhãn và giá trị ở cuối dòng",
      "cols": "Các cột; độ rộng âm là căn phải",
      "rule": "Một đường gạch ngang hết khổ giấy",
      "pad": "pad_left, pad_right, fit: căn chữ theo độ rộng",
      "t": "Chữ theo ngôn ngữ của mẫu"
    },
    "paper": {
      "columns": "paper.columns: số ký tự mỗi dòng (32 hoặc 48)"
    }
  },
  "einvoice": {
    "status": {
      "not_configured": "Chưa có cấu hình",
      "pending": "Chờ gửi",
      "submitting": "Đang gửi",
      "uncertain": "Đang kiểm tra với nhà cung cấp",
      "awaiting_number": "Chờ cấp số",
      "issued": "Đã phát hành",
      "failed": "Lỗi"
    },
    "needsAdjustment": "Đã hoàn tiền: cần điều chỉnh",
    "list": {
      "title": "Hóa đơn điện tử",
      "intro": "Hóa đơn điện tử văn phòng chính phát hành cho mọi đơn đã thanh toán, theo thứ tự của từng cửa hàng. Sửa và gửi lại hóa đơn lỗi; điều chỉnh hóa đơn đã hoàn tiền tại nhà cung cấp.",
      "needsAdjustmentOnly": "Chỉ hóa đơn hoàn tiền sau khi phát hành",
      "back": "Quay lại hóa đơn điện tử"
    },
    "columns": {
      "paidAt": "Thanh toán",
      "order": "Đơn",
      "store": "Cửa hàng",
      "buyer": "Người mua",
      "total": "Tổng",
      "invoiceNo": "Số hóa đơn",
      "status": "Trạng thái"
    },
    "buyer": {
      "retail": "Khách lẻ (không lấy hóa đơn)",
      "company": "Doanh nghiệp",
      "companyName": "Tên đơn vị",
      "taxCode": "Mã số thuế",
      "address": "Địa chỉ",
      "email": "Email",
      "emailKept": "Để trống để giữ địa chỉ đã lưu."
    },
    "detail": {
      "intro": "Nội dung đã gửi nhà cung cấp và phản hồi của nhà cung cấp.",
      "seller": "Bên bán (MST · mẫu số · ký hiệu)",
      "lookupCode": "Mã tra cứu",
      "taxAuthorityCode": "Mã cơ quan thuế",
      "issuedAt": "Phát hành",
      "emailedAt": "Đã gửi email",
      "error": "Lỗi",
      "nextAttempt": "Lần gửi tới",
      "attempts": "Số lần gửi",
      "transactionUuid": "Mã giao dịch",
      "refunded": "Đã hoàn",
      "adjustmentNote": "Ghi chú điều chỉnh",
      "adjustmentNoteHelp": "Việc đã làm tại nhà cung cấp, ví dụ số hóa đơn điều chỉnh.",
      "pdf": "Tải PDF",
      "email": "Gửi email hóa đơn",
      "send": "Gửi",
      "emailToBuyer": "Để trống để gửi cho người mua ({{email}}).",
      "emailNeeded": "Người mua chưa có email: hãy nhập một địa chỉ.",
      "emailed": "Đã gửi hóa đơn qua email.",
      "fixBuyer": "Sửa người mua",
      "saveAndSend": "Lưu và gửi lại",
      "retry": "Gửi lại",
      "retried": "Đã xếp hàng để gửi lại.",
      "sendNow": "Gửi ngay",
      "sentNow": "Hóa đơn sẽ được gửi tới nhà cung cấp trong vài giây, cùng các hóa đơn trước đó của cửa hàng còn đang chờ.",
      "adjustmentDone": "Đánh dấu đã điều chỉnh",
      "needsAdjustmentTitle": "Đã hoàn tiền sau khi phát hành hóa đơn",
      "needsAdjustmentBody": "Đã hoàn {{amount}}. Lập hóa đơn điều chỉnh tại nhà cung cấp, rồi đánh dấu đã điều chỉnh.",
      "lines": "Dòng hóa đơn",
      "linesIntro": "Số tiền trước thuế, như đã gửi nhà cung cấp; tổng theo từng thuế suất đúng như trên phiếu thanh toán.",
      "buyerFromReceipt": "Khách gửi thông tin công ty qua mã QR trên hóa đơn"
    },
    "lines": {
      "name": "Hàng hóa",
      "quantity": "SL",
      "amount": "Thành tiền trước thuế",
      "rate": "Thuế GTGT",
      "tax": "Tiền thuế",
      "noVat": "Không chịu thuế",
      "atRate": "Cộng thuế suất {{rate}}"
    },
    "providers": {
      "title": "Nhà cung cấp hóa đơn điện tử",
      "intro": "Các tài khoản văn phòng chính dùng để phát hành hóa đơn điện tử, một hoặc nhiều tài khoản cho mỗi pháp nhân. Thông tin đăng nhập nhập tại đây và không bao giờ hiện lại.",
      "add": "Thêm tài khoản hóa đơn điện tử",
      "empty": "Thêm tài khoản của nhà cung cấp hóa đơn điện tử, cho pháp nhân mà tài khoản phát hành.",
      "legalEntityHelp": "Công ty mà tài khoản phát hành hóa đơn.",
      "chooseLegalEntity": "Chọn pháp nhân"
    }
  },
  "itemGroups": {
    "hint": "Một sản phẩm hiển thị thành một món: các biến thể là những món riêng (giá, tồn kho và tên bếp riêng), chọn theo kích thước, màu hoặc thuộc tính khác. Mỗi biến thể có một giá trị cho mỗi thuộc tính. Các thay đổi được lưu cùng lúc.",
    "tab": "Biến thể",
    "dimensions": "Thuộc tính",
    "noDimensions": "Chưa có thuộc tính",
    "noDimensionsHelp": "Thêm một thuộc tính, ví dụ kích thước, rồi thêm các giá trị.",
    "size": "Kích thước",
    "nameEn": "Tên (tiếng Anh)",
    "display": "Hiển thị dạng",
    "addDimension": "Thêm thuộc tính",
    "removeDimension": "Xoá thuộc tính {{name}}",
    "valuesOf": "Giá trị của {{name}}",
    "addValue": "Thêm giá trị",
    "removeValue": "Xoá giá trị {{name}}",
    "valueField": {
      "code": "Mã",
      "label": "Nhãn",
      "labelEn": "Nhãn (tiếng Anh)",
      "shortLabel": "Nhãn ngắn",
      "swatchColor": "Màu mẫu"
    },
    "members": "Biến thể",
    "noMembers": "Chưa có biến thể",
    "noMembersHelp": "Thêm các món là biến thể của sản phẩm này.",
    "addMember": "Thêm món",
    "searchItem": "Tìm theo mã hoặc tên",
    "choose": "Chọn",
    "valueOf": "{{dimension}} của {{item}}",
    "defaultOf": "{{item}} là mặc định",
    "moveUp": "Đưa {{item}} lên",
    "moveDown": "Đưa {{item}} xuống",
    "removeMember": "Xoá {{item}}",
    "unsaved": "Có thay đổi chưa lưu",
    "discard": "Huỷ thay đổi",
    "save": "Lưu biến thể",
    "conflict": "Người khác vừa sửa nhóm này. Huỷ thay đổi để tải bản mới.",
    "problem": {
      "dimensionCode": "Mỗi thuộc tính cần một mã (chữ, số, - hoặc _), không trùng nhau.",
      "dimensionName": "Hãy đặt tên cho mỗi thuộc tính.",
      "noValues": "Mỗi thuộc tính cần ít nhất một giá trị.",
      "valueCode": "Mỗi giá trị cần một mã, không trùng trong cùng thuộc tính.",
      "valueLabel": "Hãy đặt nhãn cho mỗi giá trị.",
      "swatch": "Viết màu mẫu theo dạng #C73F00.",
      "memberValue": "Hãy chọn giá trị của mỗi thuộc tính cho mọi biến thể.",
      "duplicate": "Có hai biến thể cùng giá trị.",
      "needsDimension": "Hãy thêm một thuộc tính trước khi thêm biến thể thứ hai."
    },
    "suggest": {
      "button": "Gợi ý nhóm",
      "title": "Nhóm biến thể được gợi ý",
      "help": "Các món có tên chỉ khác nhau ở ký hiệu kích thước, ví dụ \"Margherita (R)\" và \"Margherita (L)\". Chọn những nhóm muốn tạo; bạn có thể sửa sau.",
      "none": "Không có gợi ý: không có món nào của thương hiệu này chỉ khác nhau ở ký hiệu kích thước.",
      "create_one": "Tạo {{count}} nhóm",
      "create_other": "Tạo {{count}} nhóm"
    }
  },
  "tableQr": {
    "title": "Mã QR tại bàn",
    "intro": "Khách quét mã trên bàn để xem thực đơn của cửa hàng và gửi yêu cầu gọi món để thu ngân xác nhận. Tạo mã cho bàn mới, in mã, và đổi mã khi thẻ bị mất hoặc bị sao chép.",
    "store": "Cửa hàng",
    "chooseStore": "Chọn cửa hàng",
    "pickStore": "Chọn cửa hàng",
    "pickStoreHint": "Các bàn của cửa hàng và mã QR của chúng hiện ở đây.",
    "tableLabel": "Mã QR tại bàn của {{store}}",
    "columns": {
      "table": "Bàn",
      "area": "Khu vực",
      "status": "Trạng thái",
      "rotation": "Phiên bản",
      "rotatedAt": "Thay đổi lần cuối",
      "active": "Gọi món bằng QR"
    },
    "status": {
      "none": "Chưa có mã",
      "active": "Bật",
      "off": "Tắt",
      "tableOff": "Bàn không sử dụng"
    },
    "on": "Bật",
    "off": "Tắt",
    "activeLabel": "Gọi món bằng QR tại bàn {{code}}",
    "generate_other": "Tạo mã cho {{count}} bàn",
    "generating": "Đang tạo mã",
    "generated_other": "Đã tạo {{count}} mã. Tải bảng in để in mã.",
    "download": "Tải bảng in",
    "downloading": "Đang chuẩn bị bảng in",
    "rotate": "Đổi mã",
    "rotateTitle": "Đổi mã của bàn {{code}}?",
    "rotateBody": "Thẻ đã in cho bàn {{code}} ngừng hoạt động ngay; khách phải quét mã mới. Hãy in thẻ mới và thay thẻ cũ trên bàn.",
    "rotated": "Bàn {{code}} đã có mã mới. Hãy in và thay thẻ trên bàn.",
    "rotateAll": "Đổi tất cả mã",
    "rotateAllTitle": "Đổi mọi mã của {{store}}?",
    "rotateAllBody_other": "Tất cả {{count}} thẻ đã in tại cửa hàng này ngừng hoạt động ngay. Hãy in bảng mới và thay thẻ trên mọi bàn.",
    "rotatedAll_other": "Đã đổi {{count}} mã. Tải bảng in và thay các thẻ.",
    "turnedOn": "Đã bật gọi món bằng QR tại bàn {{code}}.",
    "turnedOff": "Đã tắt gọi món bằng QR tại bàn {{code}}. Khách quét thẻ sẽ thấy bàn này không nhận gọi món.",
    "emptyTitle": "Chưa có bàn",
    "empty": "Cửa hàng này chưa có bàn. Hãy thiết lập trong mục Bàn.",
    "copyLink": "Sao chép liên kết",
    "copied": "Đã sao chép liên kết của bàn {{code}}. Ai có liên kết đều gọi món được tại bàn đó: chỉ dùng để thử.",
    "linkMissing": "Bàn {{code}} chưa có liên kết để sao chép. Hãy đổi mã để có liên kết."
  },
  "images": {
    "title": "Hình ảnh",
    "intro": "Tải ảnh lên một lần rồi dùng địa chỉ của ảnh cho logo, ảnh món và trang web. Ảnh được kiểm tra, xoay đúng chiều, thu nhỏ còn 2048 px và lưu dạng WebP.",
    "columns": {
      "image": "Ảnh",
      "name": "Tên",
      "size": "Kích thước",
      "brand": "Thương hiệu",
      "uploaded": "Ngày tải lên"
    },
    "allBrands": "Mọi thương hiệu",
    "untitled": "Ảnh chưa có tên",
    "size": "{{width}} × {{height}} · {{kb}} KB",
    "copy": "Sao chép địa chỉ",
    "copied": "Đã sao chép địa chỉ của \"{{name}}\". Hãy dán vào ô ảnh.",
    "copyFailed": "Không sao chép được địa chỉ. Hãy chọn và tự sao chép: {{url}}",
    "deleteTitle": "Xóa ảnh?",
    "deleteBody": "\"{{name}}\" sẽ bị gỡ khỏi danh sách này và khỏi ô chọn ảnh. Các trang đang hiển thị ảnh vẫn hiển thị bình thường.",
    "deleted": "Đã xóa ảnh.",
    "empty": "Chưa có hình ảnh. Tải lên bằng nút Tải ảnh lên.",
    "emptyReadOnly": "Chưa có ảnh nào.",
    "upload": {
      "title": "Tải ảnh lên",
      "hint": "JPEG, PNG, WebP hoặc GIF, mỗi ảnh tối đa 10 MB.",
      "drop": "Kéo thả ảnh vào đây hoặc bấm để chọn ảnh",
      "dropOne": "Kéo thả một ảnh vào đây hoặc bấm để chọn ảnh",
      "brandHelp": "Để trống để dùng ảnh cho mọi thương hiệu.",
      "altText": "Mô tả",
      "altTextHelp": "Cho biết ảnh có gì, dành cho người không xem được ảnh.",
      "invalidType": "Tệp này không phải ảnh JPEG, PNG, WebP hoặc GIF.",
      "tooLarge": "Ảnh lớn hơn 10 MB.",
      "uploading": "Đang tải lên",
      "uploaded": "Đã tải lên",
      "remove": "Bỏ {{name}}",
      "done_one": "Đã tải lên {{count}} ảnh.",
      "done_other": "Đã tải lên {{count}} ảnh.",
      "existing_one": "{{count}} ảnh đã được tải lên trước đó, hệ thống dùng lại ảnh cũ.",
      "existing_other": "{{count}} ảnh đã được tải lên trước đó, hệ thống dùng lại ảnh cũ."
    },
    "picker": {
      "choose": "Chọn ảnh",
      "title": "Chọn một ảnh",
      "legend": "Ảnh đã tải lên",
      "use": "Dùng ảnh này",
      "preview": "Ảnh hiện tại: {{label}}",
      "empty": "Chưa có ảnh nào. Hãy tải ảnh lên ở trên."
    },
    "search": "Tìm theo tên hoặc mô tả",
    "noDescription": "Chưa có mô tả",
    "dimensions": "{{width}} × {{height}} px",
    "fileSize": "{{kb}} KB"
  },
  "brandSites": {
    "theme": {
      "previewName": "Thương hiệu của bạn",
      "primary": "Màu chính",
      "primaryHelp": "Nút và liên kết; chữ trắng trên màu này phải đọc được (4.5:1).",
      "accent": "Màu nhấn",
      "accentHelp": "Không bắt buộc: nhãn ưu đãi và \"mới\".",
      "hex": "Nhập màu dạng #RRGGBB, ví dụ #C73F00.",
      "fontPair": "Phông chữ",
      "fonts": {
        "be-vietnam-pro": "Be Vietnam Pro",
        "inter": "Inter",
        "nunito": "Nunito",
        "roboto-slab+inter": "Tiêu đề Roboto Slab, nội dung Inter"
      },
      "radius": "Góc bo",
      "radii": {
        "sharp": "Vuông",
        "soft": "Bo nhẹ",
        "round": "Bo tròn"
      },
      "neutralTint": "Màu xám",
      "tints": {
        "warm": "Ấm",
        "cool": "Lạnh",
        "pure": "Trung tính"
      },
      "darkMode": "Chế độ tối",
      "darkOff": "Tắt",
      "darkAuto": "Theo thiết bị",
      "preview": "Xem trước",
      "sampleText": "Nước dùng đậm đà, thịt bò tái, rau thơm.",
      "sampleButton": "Thêm vào giỏ",
      "sampleChip": "Pizza",
      "sampleBadge": "Ưu đãi",
      "sampleLink": "Xem thực đơn",
      "contrastOk": "Mọi chữ đều dễ đọc (WCAG AA)",
      "contrastProblems_one": "{{count}} cặp màu khó đọc",
      "contrastProblems_other": "{{count}} cặp màu khó đọc",
      "broken": "Giao diện đã lưu không phải JSON hợp lệ; chọn giá trị ở đây sẽ thay thế nó."
    }
  },
  "messaging": {
    "providers": {
      "title": "Tài khoản gửi tin nhắn",
      "intro": "Tài khoản Zalo ZNS, SMS và email (SMTP) dùng để gửi tin cho khách. Mỗi loại tin thử các kênh theo thứ tự đặt tại Mẫu tin nhắn cho khách › Thứ tự kênh.",
      "empty": "Chưa có tài khoản gửi tin nhắn.",
      "add": "Thêm tài khoản",
      "brand": "Thương hiệu",
      "brandHelp": "Tài khoản dùng cho một thương hiệu, hoặc mọi thương hiệu.",
      "allBrands": "Mọi thương hiệu"
    },
    "templates": {
      "title": "Mẫu tin nhắn cho khách",
      "intro": "Nội dung báo khách khi đơn online được nhận, đã xong, đang giao, hoàn tất hoặc không được nhận, khi điểm sắp hết hạn, và email tiếp thị của thương hiệu, theo từng kênh và ngôn ngữ. Tin nhắn không có mẫu sẽ không được gửi.",
      "add": "Thêm mẫu",
      "brand": "Thương hiệu",
      "empty": "Thương hiệu này chưa có mẫu tin nhắn.",
      "columns": {
        "event": "Tin nhắn",
        "channel": "Kênh",
        "language": "Ngôn ngữ",
        "content": "Nội dung",
        "status": "Trạng thái",
        "purpose": "Mục đích"
      },
      "znsId": "Mã mẫu ZNS",
      "znsHelp": "Mã mẫu Zalo đã duyệt cho Official Account của thương hiệu.",
      "smsBody": "Nội dung SMS",
      "smsHelp": "Có thể dùng {{values}}.",
      "deleteTitle": "Xoá mẫu tin nhắn?",
      "deleteBody": "Tin nhắn này sẽ không được gửi qua kênh và ngôn ngữ này nữa.",
      "parameters": {
        "title": "Tham số ZNS",
        "help": "Đặt tên từng tham số như trong mẫu Zalo đã duyệt và điền như nội dung SMS, với {{values}}. Không có tham số thì các giá trị được gửi theo đúng tên này.",
        "name": "Tham số",
        "value": "Giá trị",
        "add": "Thêm tham số",
        "remove": "Xóa tham số"
      },
      "tabs": {
        "templates": "Mẫu tin",
        "channels": "Thứ tự kênh",
        "email": "Cài đặt email"
      },
      "purpose": {
        "marketing": "Tiếp thị",
        "service": "Dịch vụ"
      },
      "name": "Tên mẫu",
      "nameHelp": "Email tiếp thị được chọn theo tên khi gửi chiến dịch; mỗi thương hiệu có thể có nhiều mẫu.",
      "marketingEmailOnly": "Hiện mẫu tiếp thị chỉ dùng cho email."
    },
    "events": {
      "order_accepted": "Đơn được nhận",
      "order_ready": "Đơn đã xong",
      "order_on_delivery": "Đơn đang giao",
      "order_completed": "Đơn hoàn tất",
      "order_not_taken": "Đơn không được nhận",
      "login_code": "Mã đăng nhập",
      "reservation_confirmed": "Đã xác nhận đặt bàn",
      "reservation_declined": "Không nhận đặt bàn",
      "reservation_cancelled": "Huỷ đặt bàn",
      "points_expiring": "Điểm sắp hết hạn",
      "marketing": "Tiếp thị"
    },
    "channels": {
      "zalo_zns": "Zalo ZNS",
      "sms": "SMS",
      "email": "Email"
    },
    "log": {
      "title": "Tin nhắn cho khách",
      "intro": "Những gì khách đã được báo, và tin nào chưa gửi, vì sao. Tin gửi qua tài khoản chế độ thử có nhãn \"Thử\": không tin nào tới khách. Số điện thoại được che.",
      "empty": "Chưa có tin nhắn nào cho thương hiệu này.",
      "allStatuses": "Mọi trạng thái",
      "test": "Thử",
      "sampleMessage": "tin thử",
      "columns": {
        "time": "Thời gian",
        "recipient": "Người nhận",
        "status": "Trạng thái"
      }
    },
    "status": {
      "pending": "Chờ gửi",
      "sending": "Đang gửi",
      "sent": "Đã gửi",
      "failed": "Sẽ thử lại",
      "skipped": "Không gửi",
      "dead": "Gửi không được"
    },
    "errors": {
      "no_messaging_account": "thương hiệu chưa có tài khoản gửi tin",
      "no_template": "chưa có mẫu cho tin này",
      "recipient_unreachable": "kênh này không tới được người nhận",
      "message_refused": "nhà cung cấp từ chối tin",
      "account_rejected": "tài khoản hoặc khóa không hợp lệ",
      "unavailable": "nhà cung cấp tạm lỗi",
      "other": "lỗi khác"
    },
    "test": {
      "action": "Gửi thử",
      "title": "Gửi tin thử",
      "intro": "Tin thử đi qua tài khoản gửi tin của thương hiệu, với số đơn TEST-0001 và cửa hàng thử nghiệm. Với tài khoản chế độ thử, không tin nào được gửi đi: xem nội dung trong Tin nhắn cho khách.",
      "recipient": "Số điện thoại nhận",
      "recipientHelp": "Ví dụ 0912 846 435.",
      "send": "Gửi thử",
      "queued": "Đã xếp tin thử. Xem kết quả trong Tin nhắn cho khách.",
      "emailRecipient": "Địa chỉ email",
      "emailRecipientHelp": "Ví dụ ten@example.com."
    },
    "email": {
      "subject": "Tiêu đề",
      "unsubscribe": "Huỷ nhận các email này",
      "preview": {
        "title": "Xem trước",
        "help": "Với giá trị mẫu, theo bố cục email của thương hiệu. Liên kết và nút trong bản xem trước không mở đi đâu."
      },
      "sender": {
        "override": "Người gửi (không bắt buộc)",
        "brandDefault": "Mặc định của thương hiệu",
        "account": "Hồ sơ SMTP",
        "accountHelp": "Tài khoản email dùng để gửi.",
        "noAccounts": "Chưa có tài khoản email: thêm trong Tài khoản gửi tin nhắn.",
        "accountGone": "Tài khoản không còn dùng được",
        "fromName": "Tên người gửi",
        "fromAddress": "Địa chỉ người gửi",
        "replyTo": "Địa chỉ nhận trả lời",
        "emailInvalid": "Nhập địa chỉ email như ten@example.com."
      },
      "settings": {
        "title": "Cài đặt email của thương hiệu",
        "intro": "Email của thương hiệu được gửi từ ai, và bố cục bao quanh mọi email của thương hiệu.",
        "service": "Email dịch vụ (cập nhật đơn, nhắc điểm)",
        "marketing": "Email tiếp thị",
        "accountDefault": "Mặc định: tài khoản email của thương hiệu, nếu không có thì của công ty",
        "layout": "Bố cục",
        "logo": "Địa chỉ logo",
        "logoHelp": "Hình ảnh bắt đầu bằng https://, hiện ở đầu mọi email.",
        "accent": "Màu nhấn",
        "background": "Màu nền",
        "colourHelp": "Ví dụ #0f62fe.",
        "colourInvalid": "Nhập màu dạng # và sáu chữ số hoặc chữ cái a–f.",
        "footer": "Chân email",
        "footerHelp": "Các dòng cuối mọi email: tên doanh nghiệp, địa chỉ, hotline.",
        "links": "Liên kết chân email",
        "linksHelp": "Tối đa {{max}} liên kết, như website, Facebook hoặc Zalo.",
        "linkLabel": "Chữ hiển thị",
        "linkUrl": "Liên kết",
        "removeLink": "Xoá liên kết",
        "addLink": "Thêm liên kết",
        "invalid": "Kiểm tra các trường được đánh dấu.",
        "pick": "Chọn màu",
        "logoInvalid": "Nhập địa chỉ bắt đầu bằng https://.",
        "linkInvalid": "Nhập liên kết bắt đầu bằng https://, http://, mailto: hoặc tel:."
      },
      "sample": {
        "subject": "Đơn {order_number} của bạn đã xong",
        "heading": "Đơn của bạn đã xong",
        "text": "Đơn {order_number} đang chờ bạn tại {store_name}.",
        "button": "Theo dõi đơn"
      },
      "body": "Nội dung",
      "bodyHelp": "Chèn giá trị của tin nhắn từ thanh công cụ, hoặc gõ dạng {tên}.",
      "bodyHelpNoValues": "Email tiếp thị chưa có giá trị; các chiến dịch sẽ tự thêm."
    },
    "routes": {
      "intro": "Các kênh gửi từng loại tin, kênh đầu được thử trước, áp dụng cho mọi thương hiệu. Một kênh được dùng khi thương hiệu có tài khoản và mẫu tin cho kênh đó và khách có địa chỉ tương ứng; nếu không, hoặc khi không tới được khách, hệ thống thử kênh tiếp theo.",
      "default": "Thứ tự mặc định",
      "up": "Chuyển lên",
      "down": "Chuyển xuống",
      "noneOn": "Bật ít nhất một kênh.",
      "save": "Lưu",
      "saving": "Đang lưu",
      "saved": "Đã lưu"
    },
    "values": {
      "order_number": "Số đơn",
      "store_name": "Tên cửa hàng",
      "prep_minutes": "Số phút chuẩn bị",
      "reason": "Lý do",
      "reference": "Mã đặt bàn",
      "time": "Thời gian",
      "party_size": "Số khách",
      "code": "Mã",
      "minutes": "Số phút hiệu lực",
      "points": "Số điểm",
      "expiry_date": "Ngày hết hạn",
      "club_name": "Tên câu lạc bộ",
      "account_no": "Số tài khoản"
    }
  },
  "translations": {
    "title": "Bản dịch",
    "intro": "Nội dung khách hàng đọc trên website, ứng dụng và trang gọi món tại bàn, theo từng ngôn ngữ của thương hiệu. Nội dung chưa dịch hiển thị bằng ngôn ngữ mặc định của thương hiệu.",
    "brand": "Thương hiệu",
    "kind": "Loại nội dung",
    "allKinds": "Tất cả loại",
    "show": "Hiển thị",
    "allTexts": "Tất cả nội dung",
    "missingIn": "Chưa dịch sang {{language}}",
    "summary": "Số bản dịch còn thiếu theo ngôn ngữ",
    "noSite": "Thương hiệu này chưa có website: đang hiển thị các ngôn ngữ khách hàng của hệ thống.",
    "missingCount_one": "{{language}}: thiếu {{count}}",
    "missingCount_other": "{{language}}: thiếu {{count}}",
    "complete": "{{language}}: đã đủ",
    "defaultLanguage": "{{language}} (mặc định)",
    "missing": "Chưa dịch",
    "search": "Tìm nội dung",
    "empty": "Không có nội dung phù hợp.",
    "emptyMissing": "Ngôn ngữ này không còn thiếu bản dịch.",
    "columns": {
      "text": "Nội dung"
    },
    "save": "Lưu",
    "saveCount_one": "Lưu {{count}} thay đổi",
    "saveCount_other": "Lưu {{count}} thay đổi",
    "saved_one": "Đã lưu {{count}} nội dung.",
    "saved_other": "Đã lưu {{count}} nội dung.",
    "refused_one": "{{count}} thay đổi chưa được lưu. Hãy tải lại trang và kiểm tra.",
    "refused_other": "{{count}} thay đổi chưa được lưu. Hãy tải lại trang và kiểm tra.",
    "download": "Tải CSV",
    "downloadFailed": "Không tải được tệp. Vui lòng thử lại.",
    "import": "Nhập CSV",
    "importing": "Đang nhập bản dịch…",
    "imported": "Đã nhập: {{updated}} nội dung thay đổi, {{unchanged}} nội dung đã giống tệp.",
    "importRefused_one": "{{count}} dòng chưa được lưu: dòng {{lines}}.",
    "importRefused_other": "{{count}} dòng chưa được lưu: dòng {{lines}}.",
    "importHeader": "Tệp này không phải tệp bản dịch đã xuất. Hãy tải CSV, điền các cột ngôn ngữ và nhập lại tệp đó.",
    "kinds": {
      "category": "Danh mục",
      "item": "Món",
      "modifier_group": "Nhóm tuỳ chọn",
      "item_group": "Nhóm món",
      "dimension": "Lựa chọn biến thể",
      "dimension_value": "Biến thể",
      "deal": "Combo",
      "deal_component": "Phần của combo"
    },
    "fields": {
      "name": "Tên",
      "label": "Nhãn",
      "description": "Mô tả"
    }
  },
  "menuImport": {
    "title": "Nhập dữ liệu thực đơn",
    "intro": "Danh mục, món, tùy chọn, giá, thực đơn và nút POS từ một sổ tính Excel. Các dòng được khớp theo mã và không có gì bị xóa.",
    "brand": "Thương hiệu",
    "chooseBrand": "Chọn thương hiệu",
    "download": "Tải sổ tính",
    "downloadFailed": "Không tải được sổ tính. Vui lòng thử lại.",
    "fileHint": "Tải sổ tính về, chỉnh sửa rồi thêm vào đây. Chỉ nhận tệp .xlsx tối đa 10 MB.",
    "drop": "Kéo thả sổ tính vào đây hoặc bấm để chọn",
    "invalidType": "Chỉ nhập được sổ tính Excel (.xlsx).",
    "tooLarge": "Tệp lớn hơn 10 MB.",
    "remove": "Gỡ {{name}}",
    "checking": "Đang kiểm tra sổ tính",
    "importing": "Đang nhập",
    "summary": "Những gì sẽ được nhập",
    "emptyFile": "Sổ tính không có dòng nào để nhập.",
    "problems_one": "Có {{count}} lỗi; cần sửa hết mới nhập được.",
    "problems_other": "Có {{count}} lỗi; cần sửa hết mới nhập được.",
    "firstProblems_one": "Chỉ hiển thị lỗi đầu tiên.",
    "firstProblems_other": "Chỉ hiển thị {{count}} lỗi đầu tiên.",
    "problemsTitle": "Lỗi",
    "searchProblems": "Tìm lỗi",
    "noMatch": "Không có lỗi nào khớp với từ tìm kiếm.",
    "import": "Nhập",
    "done": "Đã nhập: {{created}} mới, {{updated}} thay đổi, {{restored}} khôi phục, {{unchanged}} không đổi. Cửa hàng nhận thay đổi khi bạn phát hành dữ liệu gốc, như mọi thay đổi khác.",
    "toolbar": "Nhập",
    "columns": {
      "sheet": "Trang tính",
      "created": "Mới",
      "updated": "Thay đổi",
      "restored": "Khôi phục",
      "unchanged": "Không đổi",
      "row": "Dòng",
      "column": "Cột",
      "message": "Lỗi"
    },
    "sheet": {
      "categories": "Danh mục",
      "items": "Món",
      "units": "Đơn vị tính",
      "option_groups": "Nhóm tùy chọn",
      "options": "Tùy chọn",
      "item_options": "Tùy chọn của món",
      "deals": "Combo",
      "deal_components": "Thành phần combo",
      "deal_choices": "Lựa chọn combo",
      "menus": "Thực đơn",
      "layouts": "Bố cục",
      "price_lists": "Bảng giá",
      "prices": "Giá",
      "menu_items": "Món trong thực đơn",
      "buttons": "Nút POS"
    }
  },
  "channelStores": {
    "addAll": {
      "button": "Thêm cửa hàng",
      "title": "Đưa cửa hàng lên kênh",
      "confirm": "Thêm cửa hàng",
      "channel": "Kênh trực tuyến",
      "brand": "Thương hiệu",
      "brandHelp": "Để trống để thêm mọi cửa hàng của mọi thương hiệu.",
      "status": "Trạng thái khi thêm",
      "closed": "Đóng: mở từng cửa hàng khi sẵn sàng",
      "open": "Mở: nhận đơn ngay",
      "done": "Đã thêm {{added}} cửa hàng; {{alreadyOn}} cửa hàng đã có trên kênh và được giữ nguyên."
    }
  },
  "onlinePayments": {
    "providers": {
      "title": "Tài khoản thanh toán",
      "intro": "Các tài khoản MoMo, ZaloPay và VNPay khách hàng dùng để thanh toán, trên website, ứng dụng và tại quầy (phương thức QR hoặc ví điện tử chọn tài khoản của mình), cho một thương hiệu hoặc tất cả. Khóa được nhập tại đây, lưu mã hóa và không hiển thị lại; cửa hàng và website không bao giờ nhận được.",
      "empty": "Chưa có tài khoản thanh toán.",
      "add": "Thêm tài khoản thanh toán"
    }
  },
  "payments": {
    "profiles": {
      "title": "Cấu hình thanh toán",
      "intro": "Tài khoản người bán nào nhận tiền thanh toán: mỗi cấu hình thuộc một công ty và có một tài khoản cho mỗi nhà cung cấp (MoMo, VNPAY, ZaloPay…). Áp dụng cho thương hiệu, cửa hàng, kênh bán hoặc kết hợp; cấu hình cụ thể nhất được dùng, và cửa hàng chỉ nhận tiền vào tài khoản của chính công ty mình.",
      "add": "Thêm cấu hình",
      "editTitle": "Sửa cấu hình thanh toán",
      "empty": "Chưa có cấu hình thanh toán. Khi chưa có, tài khoản của nhà cung cấp theo cửa hàng, thương hiệu hoặc toàn hệ thống được dùng.",
      "columns": {
        "name": "Cấu hình",
        "entity": "Công ty",
        "accounts": "Tài khoản",
        "places": "Áp dụng cho",
        "status": "Trạng thái"
      },
      "noAccounts": "Chưa có tài khoản",
      "placeCount_one": "{{count}} nơi",
      "placeCount_other": "{{count}} nơi",
      "active": "Đang dùng",
      "inactive": "Tắt",
      "accounts": "Tài khoản",
      "places": "Nơi áp dụng",
      "deleteTitle": "Xóa cấu hình thanh toán này",
      "deleteBody": "Các cửa hàng và kênh bán sẽ không dùng cấu hình này nữa. Các khoản đã thanh toán được giữ nguyên.",
      "code": "Mã",
      "name": "Tên",
      "entity": "Công ty (pháp nhân)",
      "entityHelp": "Người bán sở hữu các tài khoản này. Chỉ cửa hàng của công ty này được dùng cấu hình.",
      "accountsTitle": "Tài khoản của {{name}}",
      "noAccount": "Không (không cung cấp)",
      "placesTitle": "Nơi áp dụng {{name}}",
      "addPlace": "Thêm",
      "noPlaces": "Chưa áp dụng ở đâu.",
      "place": "Thương hiệu: {{brand}} · Cửa hàng: {{store}} · Kênh: {{channel}}",
      "removePlace": "Bỏ áp dụng ở đây",
      "all": "Tất cả",
      "brand": "Thương hiệu",
      "store": "Cửa hàng",
      "channel": "Kênh bán"
    },
    "reconciliation": {
      "title": "Đối soát thanh toán",
      "intro": "Mọi khoản thanh toán qua nhà cung cấp, tại quầy (mã QR, ví) và trên website, ứng dụng: nhà cung cấp đã xác nhận và hoàn bao nhiêu, cửa hàng đã ghi nhận vào đơn chưa. Khoản đã thanh toán nhưng chưa ghi nhận thường đang được cửa hàng gửi lên, hoặc đang chờ cửa hàng nhận đơn.",
      "columns": {
        "time": "Thời gian",
        "reference": "Đơn",
        "channel": "Kênh",
        "store": "Cửa hàng",
        "account": "Tài khoản",
        "amount": "Số tiền",
        "refunded": "Đã hoàn",
        "match": "Đối soát"
      },
      "filters": {
        "provider": "Nhà cung cấp",
        "store": "Cửa hàng",
        "entity": "Công ty",
        "source": "Kênh",
        "state": "Thanh toán",
        "all": "Tất cả",
        "date": "Ngày tạo"
      },
      "source": {
        "store_payment": "Tại quầy (POS)",
        "online_order": "Website hoặc ứng dụng"
      },
      "state": {
        "open": "Đang chờ khách",
        "succeeded": "Đã thanh toán",
        "refunded": "Đã hoàn tiền",
        "not_paid": "Chưa thanh toán"
      },
      "match": {
        "matched": "Khớp",
        "not_recorded": "Chưa ghi nhận",
        "amount_differs": "Lệch số tiền",
        "refunded": "Đã hoàn",
        "open": "Đang chờ",
        "not_paid": "Chưa thanh toán"
      },
      "totals": "{{count}} khoản, đã thu {{paid}} ({{succeeded}} khoản), đã hoàn {{refunded}}",
      "detail": {
        "intent": "Mã thanh toán",
        "providerTransaction": "Mã giao dịch nhà cung cấp",
        "recorded": "Cửa hàng đã ghi nhận",
        "recordedOrder": "Đơn tại cửa hàng",
        "paidAt": "Thanh toán lúc",
        "late": "Thanh toán sau khi đã kết thúc (đã hoàn)",
        "state": "Trạng thái tại nhà cung cấp",
        "entity": "Công ty"
      }
    }
  },
  "crm": {
    "segments": {
      "people": {
        "tab": "Khách",
        "title": "Khách trong nhóm",
        "empty": "Chưa có khách trong nhóm",
        "emptyHint": "Nhóm được cập nhật mỗi ngày sau khi có số liệu trong ngày, hoặc ít phút sau khi chọn Cập nhật ngay.",
        "name": "Tên",
        "noName": "Chưa có tên",
        "phone": "Điện thoại",
        "email": "Email",
        "kind": "Loại",
        "member": "Hội viên",
        "guest": "Khách vãng lai",
        "orders": "Số đơn, 365 ngày qua",
        "spend": "Đã chi, 365 ngày qua",
        "lastOrder": "Đơn gần nhất"
      },
      "trend": {
        "day": "Ngày",
        "people": "Số khách",
        "summary": "Hiện có {{count}} khách."
      },
      "list": {
        "tab": "Danh sách",
        "notList": "Chỉ nhóm theo danh sách tải lên mới nhận danh sách. Khách của nhóm này đến từ điều kiện hoặc các nhóm được kết hợp.",
        "label": "Khách, mỗi dòng một người",
        "help": "Mỗi dòng một số điện thoại, email hoặc mã tài khoản hội viên. Số điện thoại và email chỉ được lưu dưới dạng khóa, không lưu chữ.",
        "mode": "Với danh sách này",
        "add": "Thêm những khách này",
        "replace": "Thay danh sách bằng những khách này",
        "upload": "Tải lên {{count}} dòng",
        "saved": "Đã lưu {{count}} khách. Nhóm sẽ được cập nhật lại trong vài phút.",
        "invalid": "{{count}} dòng không phải số điện thoại, email hay mã tài khoản.",
        "unknown": "Không có hội viên nào có các mã tài khoản: {{numbers}}."
      },
      "refresh": {
        "button": "Cập nhật ngay",
        "asked": "Đã yêu cầu cập nhật"
      },
      "conditions": {
        "notRules": "Chỉ nhóm theo điều kiện mới có điều kiện."
      },
      "estimate": {
        "button": "Ước tính số khách",
        "result": "Khoảng {{count}} trên {{people}} khách.",
        "sample": "Ước tính từ mẫu {{sampled}} khách; khi chạy, nhóm sẽ đếm tất cả."
      },
      "export": {
        "masked": "Xuất danh sách khách",
        "revealed": "Xuất kèm điện thoại và email"
      }
    }
  },
  "cms": {
    "blocks": {
      "title": "Khối nội dung",
      "add": "Thêm khối",
      "addItem": "Thêm",
      "up": "Lên trên",
      "down": "Xuống dưới",
      "remove": "Xoá",
      "types": {
        "hero": "Ảnh banner",
        "order_starter": "Bắt đầu đặt món",
        "rich_text": "Văn bản",
        "image": "Hình ảnh",
        "tiles": "Ô hình",
        "cta": "Kêu gọi hành động",
        "featured_items": "Món nổi bật",
        "deals_row": "Ưu đãi",
        "store_list": "Cửa hàng",
        "app_download": "Tải ứng dụng",
        "faq": "Hỏi đáp",
        "form": "Biểu mẫu"
      }
    },
    "fields": {
      "slides": "Các ảnh",
      "image": "Hình ảnh",
      "imageNarrow": "Ảnh cho điện thoại",
      "title": "Tiêu đề",
      "text": "Nội dung",
      "buttonLabel": "Nút",
      "href": "Liên kết",
      "linkHelp": "Một trang của website (/order-online) hoặc địa chỉ https.",
      "alt": "Mô tả hình ảnh",
      "caption": "Chú thích",
      "tiles": "Các ô",
      "categoryId": "Danh mục (để trống: tất cả)",
      "limit": "Số lượng",
      "headerLinks": "Menu đầu trang",
      "footerColumns": "Các cột chân trang",
      "links": "Liên kết",
      "label": "Nhãn",
      "social": "Mạng xã hội",
      "network": "Mạng",
      "apps": "Ứng dụng",
      "ios": "Liên kết App Store",
      "android": "Liên kết Google Play",
      "legal": "Thông tin công ty",
      "companyName": "Tên công ty",
      "address": "Địa chỉ",
      "registration": "Đăng ký kinh doanh",
      "taxCode": "Mã số thuế",
      "hotline": "Đường dây nóng",
      "email": "Email",
      "type": "Loại (ví dụ Deal)",
      "days": "Ngày (không chọn: mỗi ngày)",
      "hours": "Giờ",
      "from": "Từ (giờ)",
      "to": "Đến (giờ)",
      "channels": "Hình thức (không chọn: tất cả)",
      "dealId": "Combo để đặt",
      "orderHref": "Nút đặt món dẫn đến (trống: đặt hàng online)",
      "terms": "Điều kiện",
      "items": "Câu hỏi",
      "question": "Câu hỏi",
      "answer": "Câu trả lời",
      "formId": "Biểu mẫu",
      "fields": "Các trường",
      "key": "Mã (chữ, số, _)",
      "kind": "Loại",
      "required": "Bắt buộc",
      "help": "Gợi ý",
      "options": "Lựa chọn (cho danh sách)",
      "value": "Giá trị",
      "submitLabel": "Nút gửi",
      "successText": "Nội dung sau khi gửi",
      "consent": "Ô đồng ý (để trống: không có)"
    },
    "options": {
      "network": {
        "facebook": "Facebook",
        "instagram": "Instagram",
        "tiktok": "TikTok",
        "youtube": "YouTube",
        "zalo": "Zalo",
        "x": "X"
      },
      "days": {
        "0": "Chủ nhật",
        "1": "Thứ 2",
        "2": "Thứ 3",
        "3": "Thứ 4",
        "4": "Thứ 5",
        "5": "Thứ 6",
        "6": "Thứ 7"
      },
      "channels": {
        "delivery": "Giao hàng",
        "pickup": "Tự đến lấy",
        "dine_in": "Tại nhà hàng"
      },
      "kind": {
        "text": "Văn bản ngắn",
        "email": "Email",
        "phone": "Số điện thoại",
        "textarea": "Văn bản dài",
        "number": "Số",
        "date": "Ngày",
        "select": "Danh sách",
        "checkbox": "Ô đánh dấu"
      }
    },
    "publish": {
      "button": "Xuất bản",
      "unpublish": "Gỡ khỏi website",
      "title": "Xuất bản lên website",
      "confirm": "Xuất bản",
      "hint": "Bản nháp hiện tại sẽ thành một phiên bản mới trên website.",
      "from": "Hiển thị từ",
      "fromHelp": "Để trống: ngay bây giờ.",
      "until": "Hiển thị đến",
      "untilHelp": "Để trống: đến khi gỡ.",
      "note": "Ghi chú"
    },
    "versions": {
      "tab": "Phiên bản",
      "title": "Các phiên bản đã xuất bản",
      "empty": "Chưa xuất bản",
      "version": "Phiên bản",
      "onWebsite": "Đang trên website",
      "publishedAt": "Xuất bản lúc",
      "window": "Hiển thị",
      "note": "Ghi chú",
      "restore": "Dùng làm bản nháp",
      "restored": "Phiên bản đó đã thành bản nháp. Hãy xuất bản để đưa lên website.",
      "changes": "Bản nháp có thay đổi chưa có trên website."
    },
    "editor": {
      "toolbar": "Định dạng cho {{label}}",
      "style": "Kiểu chữ",
      "paragraph": "Đoạn văn",
      "heading": "Tiêu đề",
      "subheading": "Tiêu đề phụ",
      "smallHeading": "Tiêu đề nhỏ",
      "bold": "In đậm (Ctrl+B)",
      "italic": "In nghiêng (Ctrl+I)",
      "link": "Liên kết (Ctrl+K)",
      "unlink": "Bỏ liên kết",
      "bulletList": "Danh sách gạch đầu dòng",
      "orderedList": "Danh sách đánh số",
      "quote": "Trích dẫn",
      "image": "Hình ảnh",
      "table": "Bảng",
      "divider": "Đường phân cách",
      "undo": "Hoàn tác (Ctrl+Z)",
      "redo": "Làm lại (Ctrl+Shift+Z)",
      "tableTools": "Bảng",
      "addRow": "Thêm dòng bên dưới",
      "addColumn": "Thêm cột bên phải",
      "deleteRow": "Xóa dòng này",
      "deleteColumn": "Xóa cột này",
      "deleteTable": "Xóa bảng",
      "linkTitle": "Liên kết",
      "linkText": "Chữ hiển thị",
      "linkTextRequired": "Nhập chữ hiển thị.",
      "linkAddress": "Địa chỉ",
      "linkInvalid": "Dùng một trang của website (/stores) hoặc địa chỉ bắt đầu bằng https://.",
      "apply": "Áp dụng",
      "altTitle": "Mô tả hình ảnh",
      "altHelp": "Được trình đọc màn hình đọc to và hiện khi hình không tải được.",
      "altRequired": "Mô tả nội dung của hình.",
      "insert": "Chèn",
      "count": "{{count}} / {{max}} ký tự",
      "tooLong": "Quá dài: tối đa {{max}} ký tự. Hãy rút gọn hoặc tách sang một khối khác.",
      "insertValue": "Chèn giá trị",
      "importHtml": "Nhập HTML",
      "copyHtml": "Sao chép dạng HTML",
      "copied": "Đã sao chép dạng HTML và văn bản thường.",
      "importTitle": "Nhập HTML",
      "importSource": "Mã nguồn HTML",
      "importHelp": "Dán mã nguồn của một email hoặc trang web.",
      "importNote": "Chỉ giữ chữ và định dạng của chữ: tiêu đề, đậm, nghiêng, liên kết, danh sách, trích dẫn, bảng, hình ảnh và đường kẻ. Bố cục và kiểu dáng không được giữ: bố cục email của thương hiệu bao quanh mọi email. Nội dung nhập sẽ thay thế nội dung hiện tại.",
      "import": "Nhập",
      "emailLinkHelp": "Địa chỉ bắt đầu bằng https://, mailto: hoặc tel:, một giá trị như {tracking_url}, hoặc địa chỉ https có giá trị bên trong.",
      "emailLinkInvalid": "Nhập liên kết bắt đầu bằng https://, mailto: hoặc tel:, hoặc một giá trị."
    },
    "promotion": {
      "title": "Thông tin khuyến mãi"
    },
    "forms": {
      "title": "Biểu mẫu",
      "choose": "Chọn biểu mẫu",
      "none": "Thương hiệu chưa có biểu mẫu: tạo tại CMS › Biểu mẫu.",
      "brandFirst": "Chọn thương hiệu trước."
    },
    "preview": {
      "button": "Xem trước",
      "ready": "Đã mở bản xem trước ở thẻ mới. Liên kết hiển thị bản nháp đã lưu đến {{until}}; hãy lưu trước để thấy thay đổi mới nhất."
    }
  },
  "customerAccounts": {
    "title": "Khách hàng",
    "intro": "Tài khoản khách hàng trên website và ứng dụng: tìm theo đúng số điện thoại hoặc email, hoặc phần đầu của tên. Thông tin liên hệ được che.",
    "search": "Số điện thoại, email hoặc tên",
    "allStatuses": "Tất cả trạng thái",
    "empty": "Chưa có tài khoản website nào.",
    "noMatch": "Không có tài khoản phù hợp. Số điện thoại và email phải đúng hoàn toàn; tên khớp từ phần đầu.",
    "unnamed": "Tài khoản chưa có tên",
    "detailIntro": "Thiết bị, hoạt động và thao tác hỗ trợ. Thao tác có hiệu lực trên website trong vài giây.",
    "status": {
      "active": "Đang hoạt động",
      "locked": "Đã khóa",
      "erased": "Đã xóa"
    },
    "columns": {
      "name": "Tên",
      "phone": "Số điện thoại",
      "email": "Email",
      "member": "Tài khoản hội viên",
      "lastLogin": "Đăng nhập gần nhất",
      "status": "Trạng thái",
      "device": "Thiết bị",
      "network": "Mạng",
      "channel": "Kênh",
      "signedIn": "Đăng nhập lúc",
      "lastUsed": "Dùng lần cuối",
      "when": "Thời gian",
      "event": "Sự kiện",
      "actor": "Thực hiện bởi",
      "detail": "Chi tiết",
      "userAgent": "Trình duyệt (user agent)"
    },
    "fields": {
      "status": "Trạng thái",
      "phone": "Số điện thoại",
      "email": "Email",
      "member": "Tài khoản hội viên",
      "password": "Mật khẩu",
      "createdAt": "Ngày tạo",
      "lastLogin": "Đăng nhập gần nhất"
    },
    "profile": "Tài khoản",
    "devices": "Thiết bị",
    "activity": "Hoạt động",
    "noDevices": "Không có thiết bị nào đang đăng nhập.",
    "noActivity": "Chưa có hoạt động.",
    "unknownDevice": "Thiết bị không xác định",
    "more": "Xem hoạt động cũ hơn",
    "passwordSet": "Đã đặt",
    "passwordNone": "Chưa đặt (đăng nhập bằng mã OTP)",
    "passwordLocked": "Bị khóa đến {{until}} do nhập sai nhiều lần",
    "reveal": "Hiện thông tin liên hệ",
    "revealed": "Thông tin liên hệ đầy đủ (lượt xem này đã được ghi lại)",
    "sent": "Đã gửi. Website áp dụng trong vài giây.",
    "actor": {
      "customer": "Khách hàng",
      "staff": "Nhân viên",
      "system": "Hệ thống"
    },
    "commands": {
      "lock": "Khóa tài khoản",
      "unlock": "Mở khóa tài khoản",
      "sign_out": "Đăng xuất mọi thiết bị",
      "clear_lockout": "Gỡ khóa mật khẩu",
      "erase": "Xóa tài khoản"
    },
    "confirm": {
      "lock": {
        "title": "Khóa tài khoản này?",
        "text": "Mọi thiết bị sẽ bị đăng xuất và khách hàng không thể đăng nhập cho đến khi được mở khóa."
      },
      "unlock": {
        "title": "Mở khóa tài khoản này?",
        "text": "Khách hàng có thể đăng nhập lại."
      },
      "sign_out": {
        "title": "Đăng xuất mọi thiết bị?",
        "text": "Khách hàng phải đăng nhập lại trên từng thiết bị."
      },
      "clear_lockout": {
        "title": "Gỡ khóa mật khẩu?",
        "text": "Khách hàng có thể thử lại mật khẩu ngay."
      },
      "erase": {
        "title": "Xóa tài khoản này?",
        "text": "Thông tin, mật khẩu, địa chỉ và thiết bị của khách hàng sẽ bị xóa; đơn hàng online chỉ giữ thông tin đã ẩn. Không thể hoàn tác. Chỉ dùng khi khách hàng yêu cầu."
      }
    },
    "events": {
      "account_created": "Tạo tài khoản",
      "signed_in": "Đăng nhập",
      "code_failed": "Nhập sai mã OTP",
      "password_failed": "Nhập sai mật khẩu",
      "password_locked": "Khóa mật khẩu (nhập sai nhiều lần)",
      "signed_out": "Đăng xuất",
      "session_ended": "Một thiết bị đã đăng xuất",
      "session_reuse": "Phiên bị dùng hai lần: thiết bị bị đăng xuất",
      "password_set": "Đặt mật khẩu",
      "password_reset": "Đặt lại mật khẩu bằng mã OTP",
      "profile_changed": "Thay đổi thông tin cá nhân",
      "address_added": "Thêm địa chỉ",
      "address_changed": "Sửa địa chỉ",
      "address_removed": "Xóa địa chỉ",
      "staff_locked": "Nhân viên khóa tài khoản",
      "staff_unlocked": "Nhân viên mở khóa tài khoản",
      "staff_signed_out": "Nhân viên đăng xuất mọi thiết bị",
      "staff_lockout_cleared": "Nhân viên gỡ khóa mật khẩu",
      "staff_erased": "Nhân viên xóa tài khoản",
      "account_copied": "Sao chép về HO (tài khoản có từ trước nhật ký hoạt động)"
    },
    "revealNetwork": "Hiện địa chỉ IP và thiết bị"
  },
  "formSubmissions": {
    "title": "Nội dung gửi từ biểu mẫu",
    "intro": "Những gì khách gửi qua các biểu mẫu trên website. Mỗi lần mở được ghi vào nhật ký; nội dung được xóa sau một năm.",
    "allStatuses": "Mọi trạng thái",
    "empty": "Chưa có nội dung nào.",
    "status": {
      "new": "Mới",
      "handled": "Đã xử lý",
      "spam": "Thư rác"
    },
    "columns": {
      "when": "Thời gian gửi",
      "form": "Biểu mẫu",
      "preview": "Câu trả lời đầu",
      "status": "Trạng thái"
    },
    "answers": "Câu trả lời",
    "consent": "Đồng ý được liên hệ",
    "handledAt": "Đã xử lý lúc",
    "note": "Ghi chú",
    "noteHelp": "Được lưu cùng trạng thái bạn chọn.",
    "markHandled": "Đánh dấu đã xử lý",
    "markSpam": "Đánh dấu thư rác",
    "reopen": "Đánh dấu mới",
    "saved": "Đã lưu",
    "sentAt": "Gửi lúc {{when}}",
    "yes": "Có",
    "no": "Không"
  },
  "onlineOrders": {
    "title": "Đơn hàng",
    "intro": "Mọi đơn hàng từ website và ứng dụng: trạng thái, món đã đặt và cách thanh toán. Cửa hàng trả lời đơn; ở đây chỉ xem. Số điện thoại được che.",
    "search": "Mã đơn hoặc số điện thoại khách",
    "empty": "Chưa có đơn hàng online.",
    "progress": "Tiến trình đơn hàng",
    "summary": "Đơn hàng",
    "items": "Món",
    "receivedAt": "Nhận lúc {{when}}",
    "reveal": "Xem liên hệ",
    "revealed": "Liên hệ của khách (đã ghi nhật ký)",
    "prepaid": "đã thanh toán online",
    "minutes_one": "{{count}} phút",
    "minutes_other": "{{count}} phút",
    "columns": {
      "number": "Đơn",
      "received": "Nhận lúc",
      "store": "Cửa hàng",
      "channel": "Kênh",
      "customer": "Khách hàng",
      "fulfilment": "Hình thức",
      "payment": "Thanh toán",
      "total": "Tổng",
      "status": "Trạng thái",
      "item": "Món",
      "quantity": "SL",
      "amount": "Thành tiền"
    },
    "fields": {
      "phone": "Điện thoại",
      "note": "Ghi chú cho cửa hàng",
      "prepMinutes": "Thời gian chuẩn bị",
      "acceptBy": "Cửa hàng cần trả lời trước"
    },
    "fulfilment": {
      "delivery": "Giao hàng",
      "pickup": "Tự đến lấy",
      "dine_in": "Ăn tại nhà hàng"
    },
    "payment": {
      "cod": "Tiền mặt khi nhận hàng",
      "pay_at_pickup": "Trả khi đến lấy",
      "online": "Online"
    },
    "status": {
      "received": "Đã nhận",
      "awaiting_payment": "Chờ thanh toán",
      "relayed": "Đã gửi cửa hàng",
      "accepted": "Đã nhận đơn",
      "preparing": "Đang chuẩn bị",
      "ready": "Sẵn sàng",
      "out_for_delivery": "Đang giao",
      "delivered": "Hoàn thành",
      "rejected": "Không nhận",
      "cancelled": "Đã hủy"
    },
    "steps": {
      "received": "Đã nhận",
      "relayed": "Đã gửi cửa hàng",
      "accepted": "Đã nhận đơn",
      "ready": "Sẵn sàng",
      "outForDelivery": "Đang giao",
      "completed": "Hoàn thành",
      "served": "Đã phục vụ"
    },
    "reasons": {
      "store_unavailable": "Cửa hàng không nhận đơn lúc đó",
      "store_busy": "Cửa hàng đã đủ số đơn đang mở",
      "not_answered": "Cửa hàng không trả lời kịp",
      "payment_failed": "Thanh toán không thành công",
      "payment_expired": "Không thanh toán kịp thời hạn",
      "sold_out": "Hết món",
      "too_busy": "Cửa hàng quá đông",
      "closing": "Cửa hàng sắp đóng cửa",
      "out_of_area": "Ngoài khu vực giao hàng",
      "other": "Lý do khác",
      "customer_cancelled": "Khách đã huỷ đơn"
    },
    "totals": {
      "title": "Tổng cộng",
      "subtotal": "Tiền món",
      "discounts": "Giảm giá",
      "charges": "Phụ phí",
      "deliveryFee": "Phí giao hàng",
      "tax": "VAT",
      "total": "Tổng"
    }
  },
  "posLayouts": {
    "saleTypes": "Loại bán hàng hiển thị",
    "saleTypesPlaceholder": "Mọi loại bán hàng",
    "saleTypesHelp": "Mục này hiển thị các đơn đang mở thuộc những loại bán hàng đã chọn. Không chọn: mọi loại bán hàng."
  },
  "salesChannels": {
    "title": "Kênh bán hàng",
    "tab": "Kênh bán hàng",
    "intro": "Các kênh cửa hàng này bán. Tắt một kênh để ngừng bán trên kênh đó tại đây; cài đặt được giữ lại. Kênh online nhận đơn trong giờ nhận đơn, hoặc theo giờ mở cửa khi chưa đặt.",
    "channel": "Kênh",
    "status": "Trạng thái",
    "orderingHours": "Giờ nhận đơn online",
    "sells": "Bán tại đây",
    "sellsOn": "Bán trên {{name}} tại cửa hàng này",
    "alwaysOn": "Luôn bật",
    "off": "Tắt",
    "state": {
      "open": "Đang nhận đơn",
      "paused": "Tạm ngưng",
      "closed": "Đóng"
    },
    "windows_one": "{{count}} khung giờ",
    "windows_other": "{{count}} khung giờ",
    "sameAsOpening": "Giờ mở cửa",
    "editHours": "Sửa giờ",
    "closeHours": "Đóng",
    "hoursFor": "Giờ nhận đơn online: {{name}}",
    "hoursHelp": "Thêm một hoặc nhiều khung giờ cho mỗi ngày, ví dụ 10:00–14:00 và 17:00–21:30. Khung kết thúc trước hoặc bằng giờ bắt đầu sẽ kéo qua nửa đêm. Chỉ nhận đơn trong khung giờ và khi cửa hàng mở cửa. Không có khung giờ nào thì theo giờ mở cửa.",
    "copyFirstDay": "Giống nhau mọi ngày",
    "useOpeningHours": "Dùng giờ mở cửa",
    "copyFrom": "Chép từ kênh khác",
    "opens": "Từ",
    "closes": "Đến",
    "removeWindow": "Xóa khung giờ này",
    "addWindow": "Thêm khung giờ",
    "closedThisDay": "Không nhận đơn online",
    "openingHoursThisDay": "Giờ mở cửa"
  },
  "reservations": {
    "tab": "Đặt bàn",
    "intro": "Đặt bàn tại cửa hàng: khách đặt trên website, ứng dụng và nhân viên nhận đặt tại POS. Một bộ quy tắc cho mọi kênh. Lượt đặt trực tuyến chờ cửa hàng xác nhận trên POS. Thay đổi đến cửa hàng và website khi dữ liệu được xuất bản (Hệ thống › Xuất bản dữ liệu).",
    "saved": "Đã lưu. Hãy xuất bản dữ liệu (Hệ thống › Xuất bản dữ liệu) để gửi đến cửa hàng và website.",
    "minutes_one": "{{count}} phút",
    "minutes_other": "{{count}} phút",
    "hours": "Giờ nhận đặt bàn",
    "hoursHelp": "Thời gian khách có thể đặt bàn theo từng ngày trong tuần; có thể nhiều khung giờ mỗi ngày. Khung đặt bàn bắt đầu từ đầu mỗi khoảng giờ. Khoảng giờ kết thúc trước hoặc bằng giờ bắt đầu sẽ kéo qua nửa đêm. Không có khoảng giờ nào: theo giờ mở cửa của cửa hàng.",
    "opens": "Từ",
    "closes": "Đến",
    "removeWindow": "Xoá khoảng giờ này",
    "addWindow": "Thêm khoảng giờ",
    "noBookingsThisDay": "Không nhận đặt",
    "openingHoursThisDay": "Theo giờ mở cửa",
    "fields": {
      "enabled": "Nhận đặt bàn",
      "on": "Bật",
      "off": "Tắt",
      "slotMinutes": "Độ dài khung giờ",
      "daysAhead": "Số ngày khách được đặt trước",
      "maxParty": "Số khách tối đa mỗi lượt",
      "slotBookings": "Số lượt đặt tối đa mỗi khung giờ",
      "slotGuests": "Số khách tối đa mỗi khung giờ",
      "acceptMinutes": "Số phút để cửa hàng trả lời lượt đặt trực tuyến",
      "noLimit": "Để trống nếu không giới hạn"
    }
  },
  "reports": {
    "allStores": "Tất cả cửa hàng",
    "store": "Cửa hàng",
    "period": "Thời gian",
    "compareWith": "So sánh với",
    "compare": {
      "previous": "Kỳ trước",
      "last_year": "Cùng thứ năm trước",
      "none": "Không so sánh"
    },
    "vs": "so với {{value}}",
    "new": "Mới",
    "downloadCsv": "Tải CSV",
    "date": "Ngày",
    "orders": "Số đơn",
    "guests": "Số khách",
    "total": "Tổng doanh thu",
    "averageCheck": "Trung bình/đơn",
    "discounts": "Giảm giá",
    "tax": "Thuế",
    "refunds": "Hoàn tiền",
    "voids": "Hủy đơn",
    "quantity": "Số lượng",
    "net": "Doanh thu thuần",
    "share": "Tỷ trọng",
    "channel": "Kênh",
    "saleType": "Loại bán",
    "noSales": "Không có doanh thu trong kỳ",
    "weekdays": {
      "1": "T2",
      "2": "T3",
      "3": "T4",
      "4": "T5",
      "5": "T6",
      "6": "T7",
      "7": "CN"
    },
    "sales": {
      "title": "Doanh thu",
      "description": "Các đơn đã thanh toán của tất cả hoặc một cửa hàng, so với kỳ trước hoặc cùng thứ năm trước. Số liệu theo đồng bộ của cửa hàng, chậm khoảng một phút.",
      "byDay": "Doanh thu theo ngày",
      "byDaySummary": "Doanh thu theo ngày, tổng {{total}}",
      "byStore": "Doanh thu theo cửa hàng",
      "byChannel": "Doanh thu theo kênh và loại bán",
      "minutesOpen": "Số phút mở đơn",
      "growth": "Tăng trưởng",
      "compareTotal": "Doanh thu kỳ so sánh"
    },
    "products": {
      "title": "Cơ cấu món bán",
      "description": "Từng món, combo và nhóm hàng đã bán: số lượng, doanh thu thuần, tỷ trọng và tỷ suất lãi trên giá vốn chuẩn nếu món có giá vốn. Món trong combo tính là món; dòng combo là phần các món không mang.",
      "byCategory": "Theo nhóm hàng",
      "top": "Món bán chạy",
      "product": "Món",
      "kind": "Loại",
      "category": "Nhóm hàng",
      "margin": "Tỷ suất lãi",
      "cost": "Giá vốn chuẩn",
      "voided": "Đã hủy",
      "openItems": "Món nhập giá",
      "noCategory": "Chưa có nhóm",
      "kinds": {
        "item": "Món",
        "deal": "Combo",
        "open": "Nhập giá",
        "category": "Nhóm hàng"
      },
      "bestSeller": "Bán chạy nhất",
      "costedMargin": "Lãi gộp của món có giá vốn",
      "costedCaption": "Món có giá vốn chuẩn: {{share}} doanh thu thực"
    },
    "hours": {
      "title": "Doanh thu theo giờ",
      "description": "Khách đặt món lúc nào: doanh thu và số đơn theo thứ và theo giờ mở đơn, theo múi giờ của từng cửa hàng.",
      "hour": "Giờ",
      "grid": "Doanh thu và số đơn theo thứ và giờ",
      "summary": "Doanh thu theo giờ mở đơn",
      "note": "Mỗi ô: doanh thu · số đơn, cộng các ngày cùng thứ trong kỳ.",
      "busiestHour": "Giờ đông nhất",
      "busiestDay": "Ngày đông nhất trong tuần"
    },
    "payments": {
      "title": "Thanh toán và thuế",
      "description": "Tiền thu theo từng phương thức để đối soát ngân hàng, và thuế đầu ra theo cửa hàng và thuế suất như cửa hàng đã ghi, để kê khai GTGT.",
      "byMethod": "Tiền thu theo phương thức",
      "method": "Phương thức",
      "paid": "Đã thu",
      "refunded": "Đã hoàn",
      "count": "Số lần thanh toán",
      "none": "Không có thanh toán trong kỳ",
      "taxByStore": "Thuế đầu ra theo cửa hàng và thuế suất",
      "rate": "Thuế suất",
      "taxable": "Doanh thu chịu thuế",
      "netTaken": "Thực thu",
      "outputTax": "Thuế đầu ra"
    },
    "qr": {
      "title": "Đối soát QR",
      "description": "Mọi khoản thanh toán QR, chuyển khoản và ví điện tử cửa hàng xác nhận thủ công (khi đơn vị thanh toán không xác nhận được), đặt cạnh dữ liệu của đơn vị thanh toán: khoản trụ sở đã nhận, hoặc dòng sao kê ngân hàng hay bảng đối soát bạn tải lên. Các khoản cần kiểm tra hiện trước.",
      "upload": "Tải sao kê lên (CSV)",
      "uploaded": "Đã thêm {{imported}} dòng, {{duplicates}} dòng đã có, bỏ qua {{skipped}} khoản tiền ra.",
      "rejected": "Các dòng không đọc được: {{lines}}.",
      "reason": {
        "paid_at_invalid": "ngày giờ",
        "amount_invalid": "số tiền",
        "store_unknown": "mã cửa hàng"
      },
      "capped": "Có hơn 5.000 khoản xác nhận: chỉ hiện 5.000 khoản đầu. Hãy chọn khoảng thời gian ngắn hơn hoặc một cửa hàng.",
      "confirmations": "Xác nhận thủ công",
      "matched": "Đã khớp",
      "toCheck": "Cần kiểm tra",
      "count_one": "{{count}} khoản",
      "count_other": "{{count}} khoản",
      "confirmationsTitle": "Các khoản xác nhận thủ công",
      "status": "Trạng thái",
      "paidAt": "Thanh toán lúc",
      "store": "Cửa hàng",
      "method": "Phương thức",
      "reference": "Mã tham chiếu",
      "amount": "Số tiền",
      "evidence": "Dữ liệu đơn vị thanh toán",
      "evidenceAmount": "Số tiền đối chiếu",
      "staff": "Người xác nhận",
      "approved": "có duyệt",
      "none": "Không có khoản xác nhận thủ công trong kỳ",
      "match": {
        "not_found": "Không tìm thấy",
        "amount_differs": "Lệch số tiền",
        "reference": "Khớp mã tham chiếu",
        "gateway": "Trụ sở đã nhận",
        "amount_time": "Cùng số tiền và giờ"
      },
      "how": "Cách đối chiếu: trước hết là dòng sao kê có mã tham chiếu của khoản thanh toán, sau đó là khoản đơn vị thanh toán đã xác nhận với trụ sở cùng cửa hàng và số tiền trong vòng 30 phút, cuối cùng là dòng cùng số tiền trong vòng 30 phút. Mỗi khoản hay mỗi dòng chỉ chứng minh một khoản thanh toán.",
      "uploads": "Sao kê đã tải lên",
      "file": "Tệp",
      "uploadedAt": "Tải lên lúc",
      "lines": "Số dòng",
      "duplicates": "Dòng đã có",
      "noUploads": "Chưa tải lên sao kê nào",
      "templateHint": "Xuất sao kê của ngân hàng hoặc đơn vị thanh toán và sắp xếp theo mẫu: paid_at, amount, và nếu có thì transaction_id, memo, store_code.",
      "template": "Tải tệp mẫu",
      "removeTitle": "Xóa tệp đã tải lên?",
      "removeBody": "Tệp {{file}} và các dòng của nó sẽ bị xóa. Những khoản nó đã chứng minh sẽ hiện là không tìm thấy cho đến khi có sao kê khác."
    },
    "controls": {
      "title": "Hủy món và giảm giá",
      "description": "Những gì bị hủy, giảm giá, hoàn tiền hoặc bán khác giá menu, ở cửa hàng nào, ai làm, ai duyệt và vì sao. Hủy món sau khi bếp đã nhận và tỷ lệ giảm giá trên doanh thu của từng nhân viên là các dấu hiệu thường cần xem xét.",
      "allKinds": "Tất cả",
      "kindLabel": "Loại",
      "kind": {
        "line_void": "Hủy món",
        "order_void": "Hủy đơn",
        "discount": "Giảm giá",
        "refund": "Hoàn tiền",
        "price_override": "Sửa giá"
      },
      "voids": "Hủy món, hủy đơn",
      "voidsCaption": "{{count}} lần, {{afterSend}} lần sau khi bếp đã nhận",
      "discounts": "Giảm giá",
      "shareCaption": "{{count}} lần · {{share}} doanh thu",
      "refunds": "Hoàn tiền",
      "count_one": "{{count}} lần",
      "count_other": "{{count}} lần",
      "overrides": "Sửa giá",
      "approvedCaption": "{{count}} lần có quản lý duyệt",
      "byStaff": "Theo nhân viên",
      "staff": "Nhân viên",
      "sales": "Doanh thu các món họ thêm",
      "unknown": "Không rõ",
      "staffNote": "Mỗi ô: số lần · số tiền. Giảm giá kèm tỷ lệ trên doanh thu các món nhân viên đó thêm vào đơn. 50 nhân viên có nhiều lần nhất.",
      "events": "Chi tiết",
      "when": "Lúc",
      "store": "Cửa hàng",
      "order": "Đơn",
      "item": "Món",
      "amount": "Số tiền",
      "kitchen": "Bếp",
      "afterSend": "Đã gửi bếp",
      "reason": "Lý do",
      "approvedBy": "Người duyệt",
      "none": "Không có hủy món, giảm giá hay hoàn tiền trong kỳ",
      "detail": {
        "manual": "Thủ công",
        "promotion": "Khuyến mãi",
        "coupon": "Mã giảm giá",
        "member": "Thành viên",
        "marketplace": "Sàn TMĐT",
        "points": "Điểm",
        "cash": "Hoàn tiền mặt",
        "card": "Hoàn qua thẻ",
        "qr": "Hoàn qua QR",
        "bank_transfer": "Hoàn chuyển khoản",
        "e_wallet": "Hoàn ví điện tử"
      }
    },
    "journal": {
      "title": "Sổ doanh thu",
      "description": "Dành cho kế toán: mỗi cửa hàng mỗi ngày kinh doanh một dòng gồm tiền hàng, giảm giá, phụ thu, thuế theo từng thuế suất, làm tròn, tổng tiền, hoàn tiền và số tiền thu theo từng phương thức thanh toán, đúng như cửa hàng đã ghi. Tệp CSV có một cột cho mỗi thuế suất và mỗi phương thức thanh toán, sẵn để nhập vào phần mềm kế toán hoặc đối chiếu ngân hàng. Tối đa 31 ngày mỗi lần.",
      "date": "Ngày kinh doanh",
      "storeCode": "Mã cửa hàng",
      "store": "Cửa hàng",
      "orders": "Số đơn",
      "subtotal": "Tiền hàng",
      "discounts": "Giảm giá",
      "charges": "Phụ thu",
      "tax": "Thuế",
      "taxable": "chịu thuế",
      "rounding": "Làm tròn",
      "total": "Tổng tiền",
      "refunds": "Hoàn tiền",
      "tenders": "Tiền thu theo phương thức",
      "note": "Doanh thu là các đơn đã thanh toán theo ngày kinh doanh của đơn; hoàn tiền và tiền thu theo ngày phát sinh. Tổng tiền = tiền hàng − giảm giá + phụ thu (+ thuế nếu cộng thêm) + làm tròn.",
      "byDay": "Theo cửa hàng và ngày kinh doanh"
    },
    "einvoices": {
      "title": "Đối soát hóa đơn điện tử",
      "description": "Theo cửa hàng và ngày thanh toán, các đơn đã thanh toán cạnh hóa đơn điện tử của chúng: đã phát hành, đang chờ (đang giữ hoặc đang gửi), lỗi, thiếu (trụ sở chưa có yêu cầu xuất hóa đơn), hoặc chưa thiết lập (cửa hàng chưa có hồ sơ hóa đơn). Hóa đơn bị hoàn tiền sau khi phát hành cần được điều chỉnh.",
      "date": "Ngày thanh toán",
      "store": "Cửa hàng",
      "paidOrders": "Đơn đã thanh toán",
      "paidTotal": "Tổng đã thanh toán",
      "issued": "Đã phát hành",
      "issuedAmount": "Số tiền đã phát hành",
      "waiting": "Đang chờ",
      "failed": "Lỗi",
      "missing": "Thiếu",
      "notConfigured": "Chưa thiết lập",
      "company": "Khách là công ty",
      "toAdjust": "Cần điều chỉnh",
      "issuedTile": "Đã xuất hóa đơn",
      "ofPaid": "{{count}} hóa đơn trên {{orders}} đơn đã thanh toán ({{paid}})",
      "count_one": "{{count}} hóa đơn",
      "count_other": "{{count}} hóa đơn",
      "toCheck": "Cần kiểm tra",
      "toCheckCaption": "{{failed}} lỗi · {{missing}} thiếu · {{notConfigured}} chưa thiết lập",
      "toAdjustCaption": "Hoàn tiền sau khi đã phát hành",
      "problems": "Cần xem",
      "ok": "Đã xuất đủ",
      "failedTag": "{{count}} lỗi",
      "missingTag": "{{count}} thiếu",
      "notConfiguredTag": "{{count}} chưa thiết lập",
      "adjustTag": "{{count}} cần điều chỉnh",
      "note": "Ngày là ngày đơn được thanh toán, theo múi giờ của từng cửa hàng. Hóa đơn đang chờ là bình thường trong ngày: hồ sơ giữ hóa đơn trước khi gửi.",
      "openInvoices": "Mở danh sách hóa đơn điện tử để gửi lại hoặc sửa",
      "byDay": "Theo cửa hàng và ngày thanh toán"
    },
    "menu": {
      "title": "Phân tích thực đơn",
      "description": "Món nào bán chạy và có lãi: độ phổ biến so với lãi gộp, theo giá vốn chuẩn của từng món.",
      "item": "Món",
      "category": "Nhóm hàng",
      "cost": "Giá vốn chuẩn",
      "mix": "Tỷ trọng số lượng",
      "margin": "Lãi gộp mỗi món",
      "class": "Phân loại",
      "classes": {
        "star": "Ngôi sao",
        "plowhorse": "Ngựa thồ",
        "puzzle": "Câu đố",
        "dog": "Kém hiệu quả",
        "no_cost": "Chưa có giá vốn"
      },
      "hints": {
        "star": "Bán chạy và lãi cao: giữ nguyên",
        "plowhorse": "Bán chạy, lãi thấp: xem lại giá hoặc giá vốn",
        "puzzle": "Lãi cao, ít người gọi: đẩy mạnh giới thiệu",
        "dog": "Không đạt cả hai: làm lại hoặc bỏ"
      },
      "thresholds": "Bán chạy là chiếm từ {{popular}} số món bán ra; lãi cao là lãi gộp mỗi món từ {{margin}}.",
      "note": "Món bán trong combo được tính theo phần giá combo phân bổ cho món. Món chưa có giá vốn chuẩn được ghi là Chưa có giá vốn và không tính vào lãi gộp bình quân. Chỉ so sánh tối đa 500 sản phẩm bán chạy nhất.",
      "items": "Món"
    },
    "staff": {
      "title": "Hiệu suất nhân viên",
      "description": "Đơn đã thanh toán của từng nhân viên: doanh thu, số khách, trung bình mỗi đơn, số món mỗi khách, cùng hủy món và giảm giá.",
      "name": "Nhân viên",
      "unknown": "Không ghi nhận",
      "itemsPerGuest": "Số món mỗi khách",
      "voidAmount": "Tiền hủy món",
      "discountAmount": "Tiền giảm giá",
      "note": "Đơn được tính cho nhân viên đã mở đơn. Hủy món và giảm giá được tính cho người thực hiện, kèm tỷ lệ trên doanh thu của người đó. Hiển thị 200 nhân viên có doanh thu cao nhất.",
      "byStaff": "Theo nhân viên"
    },
    "operations": {
      "title": "Vận hành",
      "description": "Vòng quay bàn và doanh thu mỗi ghế, tốc độ cửa hàng nhận đơn website và ứng dụng, và đặt bàn.",
      "store": "Cửa hàng",
      "parties": "Lượt bàn",
      "covers": "Số khách",
      "minutes": "Số phút ngồi bàn",
      "spendPerGuest": "Chi tiêu mỗi khách",
      "tables": "Số bàn",
      "seats": "Số ghế",
      "turns": "Vòng quay mỗi ngày",
      "revpash": "Doanh thu mỗi ghế mỗi giờ",
      "partiesCaption_one": "{{count}} lượt bàn",
      "partiesCaption_other": "{{count}} lượt bàn",
      "onlineOrders": "Đơn trực tuyến",
      "accepted": "Đã nhận",
      "rejected": "Từ chối",
      "cancelled": "Đã hủy",
      "rejectedCaption": "{{share}} bị từ chối",
      "noShowCaption": "{{share}} không đến",
      "rejectedTag_one": "{{count}} từ chối",
      "rejectedTag_other": "{{count}} từ chối",
      "cancelledTag_one": "{{count}} đã hủy",
      "cancelledTag_other": "{{count}} đã hủy",
      "acceptTime": "Thời gian nhận đơn",
      "acceptP90": "10% chậm nhất",
      "seconds_one": "{{count}} giây",
      "seconds_other": "{{count}} giây",
      "readyTime": "Số phút đến khi xong",
      "deliveryTime": "Số phút giao hàng",
      "tablesTitle": "Bàn",
      "onlineTitle": "Đơn website và ứng dụng",
      "bookingsTitle": "Đặt bàn",
      "tablesNote": "Một lượt bàn là một phiên bàn có đơn đã thanh toán. Vòng quay tính theo số bàn đang thiết lập; doanh thu mỗi ghế mỗi giờ là doanh thu tại bàn chia cho số ghế và số giờ cửa hàng có bán.",
      "reasons": "Lý do từ chối đơn",
      "reason": "Lý do",
      "noReason": "Không ghi lý do",
      "count": "Số đơn",
      "bookings": "Lượt đặt",
      "online": "Trực tuyến",
      "seated": "Đã nhận bàn",
      "noShows": "Không đến",
      "declined": "Từ chối",
      "expired": "Hết hạn",
      "pending": "Chờ trả lời",
      "noTables": "Không có phục vụ tại bàn trong kỳ này",
      "noOnline": "Không có đơn trực tuyến trong kỳ này",
      "noBookings": "Không có lượt đặt bàn trong kỳ này",
      "seatedCoversHeader": "Khách đã nhận bàn"
    },
    "customers": {
      "title": "Khách hàng và khuyến mãi",
      "description": "Tỷ trọng doanh thu của thành viên, giá trị khuyến mãi và giảm giá đã cho, và số điểm, thẻ quà tặng còn phải trả.",
      "memberSales": "Doanh thu thành viên",
      "memberCaption": "{{share}} doanh thu · {{orders}} đơn · {{members}} thành viên",
      "newMembers": "Thành viên mới",
      "points": "Điểm tích lũy",
      "pointsCaption": "{{redeemed}} đã đổi",
      "liabilities": "Số dư thẻ quà tặng",
      "liabilitiesCaption": "{{vouchers}} thẻ còn hiệu lực · {{points}} điểm đang giữ",
      "pointsEarned": "Điểm tích lũy",
      "pointsRedeemed": "Điểm đã đổi",
      "pointsOutstanding": "Điểm đang giữ",
      "vouchersOutstanding": "Số dư thẻ quà tặng",
      "discountsTitle": "Giảm giá theo nguồn",
      "source": "Nguồn",
      "name": "Tên",
      "uses": "Số lần dùng",
      "orders": "Số đơn",
      "amount": "Số tiền",
      "sources": {
        "manual": "Thủ công",
        "promotion": "Khuyến mãi",
        "coupon": "Mã giảm giá",
        "member": "Giá thành viên",
        "marketplace": "Sàn",
        "points": "Điểm"
      },
      "noDiscounts": "Không có giảm giá trong kỳ này",
      "note": "Điểm chỉ được tính tại trụ sở, từ đơn đã đồng bộ. Điểm đang giữ và số dư thẻ quà tặng là số còn phải trả hiện tại, trên mọi cửa hàng, không phụ thuộc kỳ báo cáo."
    },
    "periodFrom": "Từ ngày",
    "periodTo": "Đến ngày",
    "stock": {
      "balances": "Tồn kho",
      "balancesHint": "Số lượng từng mặt hàng theo dõi tồn kho tại mỗi cửa hàng, theo đơn vị cơ bản, định giá theo giá vốn chuẩn, theo dữ liệu cửa hàng gửi gần nhất.",
      "movements": "Biến động kho",
      "movementsHint": "Bán hàng, nhập hàng, hao hụt, điều chỉnh, kiểm kê và chuyển kho tại các cửa hàng trong kỳ, kèm tổng theo loại.",
      "transfers": "Chuyển kho",
      "transfersHint": "Chuyển kho giữa các cửa hàng: số đã gửi, số đã nhận và chênh lệch. Chọn một phiếu để xem chi tiết.",
      "counts": "Kiểm kê",
      "countsHint": "Các phiếu kiểm kê đã ghi sổ và chênh lệch, định giá theo giá vốn chuẩn. Chọn một phiếu để xem chi tiết.",
      "store": "Cửa hàng",
      "item": "Mặt hàng",
      "onHand": "Tồn",
      "unitCost": "Đơn giá vốn",
      "value": "Giá trị",
      "lastMovement": "Biến động gần nhất",
      "searchItems": "Tìm mặt hàng",
      "belowZeroOnly": "Chỉ tồn âm",
      "valueTotal": "Giá trị tồn kho",
      "valueCaption": "Theo giá vốn chuẩn, chỉ mặt hàng có giá vốn",
      "lines": "Số dòng",
      "noBalances": "Chưa có tồn kho",
      "when": "Thời gian",
      "type": "Loại",
      "allTypes": "Tất cả loại",
      "quantity": "Số lượng",
      "note": "Ghi chú",
      "count": "Số biến động",
      "byType": "Tổng theo loại",
      "byTypeHint": "Số lượng theo đơn vị cơ bản của từng mặt hàng; giá trị theo giá vốn ghi cùng mỗi biến động.",
      "movementList": "Biến động",
      "noMovements": "Không có biến động trong kỳ",
      "number": "Số phiếu",
      "fromStore": "Từ",
      "toStore": "Đến",
      "status": "Trạng thái",
      "sentAt": "Gửi lúc",
      "receivedAt": "Nhận lúc",
      "postedAt": "Ghi sổ",
      "lineCount": "Số dòng",
      "differenceLines": "Dòng chênh lệch",
      "differencesOnly": "Chỉ phiếu có chênh lệch",
      "noTransfers": "Không có phiếu chuyển",
      "quantitySent": "Đã gửi",
      "quantityReceived": "Đã nhận",
      "missing": "Chưa nhận",
      "linesOf": "Chi tiết {{number}}",
      "variancesOnly": "Chỉ phiếu có chênh lệch",
      "varianceLines": "Dòng chênh lệch",
      "varianceValue": "Giá trị chênh lệch",
      "noCounts": "Chưa có phiếu kiểm kê đã ghi sổ",
      "expected": "Sổ sách",
      "counted": "Đã đếm",
      "difference": "Chênh lệch",
      "state": {
        "sent": "Đã gửi",
        "received": "Đã nhận",
        "draft": "Nháp",
        "cancelled": "Đã hủy"
      },
      "countType": {
        "full": "Kiểm kê toàn bộ",
        "partial": "Kiểm kê một phần",
        "spot": "Kiểm tra nhanh"
      },
      "txn": {
        "sale": "Bán hàng",
        "receipt": "Nhập hàng",
        "waste": "Hao hụt",
        "adjustment": "Điều chỉnh",
        "count": "Kiểm kê",
        "transfer_out": "Chuyển đi",
        "transfer_in": "Nhận chuyển"
      }
    }
  },
  "terminalApp": {
    "title": "Kết nối với cửa hàng",
    "intro": "Nhập địa chỉ máy chủ cửa hàng, hoặc quét mã QR trong trang quản trị cửa hàng → Hệ thống → Ứng dụng POS.",
    "address": "Địa chỉ cửa hàng",
    "addressHelp": "Ví dụ s123.pos.example.vn, hoặc http://192.168.1.20:5100 trong mạng của cửa hàng",
    "invalid": "Nhập địa chỉ cửa hàng, ví dụ s123.pos.example.vn. Địa chỉ http chỉ dùng được trong mạng của cửa hàng, ví dụ http://192.168.1.20:5100.",
    "connect": "Kết nối",
    "scan": "Quét mã QR",
    "checking": "Đang kiểm tra cửa hàng…",
    "unreachable": "Cửa hàng không phản hồi",
    "unreachableHelp": "Kiểm tra địa chỉ, thiết bị đã vào mạng của cửa hàng, và chứng chỉ của cửa hàng đã được cài.",
    "scanFailed": "Máy ảnh không đọc được mã QR của cửa hàng.",
    "saveFailed": "Ứng dụng không lưu được cửa hàng. Hãy thử lại.",
    "incompatible": "Ứng dụng này không khớp với máy chủ cửa hàng",
    "incompatibleHelp": "Cài ứng dụng máy tính bảng mà cửa hàng cung cấp (quản trị cửa hàng → Hệ thống → Ứng dụng POS), rồi mở lại. Chưa nhận đơn được cho đến lúc đó.",
    "settings": "Cài đặt máy chủ",
    "settingsIntro": "Máy chủ cửa hàng mà máy tính bảng này dùng. Đổi khi máy chủ có địa chỉ mới hoặc máy tính bảng chuyển sang cửa hàng khác.",
    "current": "Máy chủ cửa hàng: {{address}}",
    "save": "Lưu và kết nối"
  },
  "providers": {
    "health": {
      "column": "Tình trạng",
      "attentionTitle": "Các tài khoản này cần người xử lý: khóa, thiết lập hoặc token đã bị từ chối",
      "lastSuccess": "Thành công lần cuối {{at}}",
      "status": {
        "healthy": "Ổn định",
        "failing": "Đang lỗi",
        "needs_attention": "Cần xử lý",
        "idle": "Chưa có lệnh gọi"
      }
    }
  },
  "duplicate": {
    "action": "Nhân bản",
    "title": "Nhân bản {{name}}",
    "confirm": "Nhân bản",
    "defaultName": "{{name}} (bản sao)",
    "menuHint": "Bản sao có cùng món, combo và bố cục, và chưa được áp dụng ở đâu cho đến khi bạn thêm dòng vào tab Áp dụng. Các bảng giá gắn với thực đơn này không định giá bản sao: hãy gắn chúng ở tab Thực đơn của bảng giá.",
    "priceListHint": "Bản sao có cùng giá, ngày hiệu lực và các thực đơn được gắn, và chưa được áp dụng ở đâu cho đến khi bạn thêm dòng vào tab Áp dụng.",
    "posProfileHint": "Bản sao có cùng loại bán hàng, nút và thiết lập, bố cục POS riêng, cùng các phương thức thanh toán, dịch vụ giao hàng và câu hỏi được bật cho hồ sơ này. Chưa có máy POS nào dùng nó và nó chưa được đồng bộ tới cửa hàng nào.",
    "roleHint": "Bản sao có cùng quyền và hạn mức. Bản sao không bao giờ là vai trò quản trị hệ thống, và chưa ai được giao cho đến khi bạn giao cho nhân viên."
  },
  "roleTemplates": {
    "action": "Tạo từ mẫu",
    "title": "Tạo vai trò: {{template}}",
    "hint": "Vai trò bắt đầu với các quyền và hạn mức thường cần cho công việc này. Bạn có thể sửa sau như mọi vai trò khác.",
    "accounting": "Kế toán",
    "marketing": "Marketing",
    "area_manager": "Quản lý khu vực",
    "store_manager": "Quản lý cửa hàng",
    "cashier": "Thu ngân",
    "kitchen": "Bếp"
  },
  "roleHolders": {
    "title": "Người được giao",
    "staff": "Nhân viên",
    "status": "Trạng thái",
    "where": "Phạm vi",
    "tenant": "Toàn công ty",
    "emptyTitle": "Chưa ai được giao vai trò này",
    "empty": "Giao vai trò cho nhân viên ở tab Phân quyền của họ."
  },
  "signIn": {
    "copied": "Đã sao chép",
    "twoStep": {
      "title": "Đăng nhập hai bước",
      "hint": "Nhập mã từ ứng dụng xác thực sau mật khẩu. Các quyền về dữ liệu cá nhân, tiền và quyền truy cập chỉ dùng được khi đăng nhập theo cách này.",
      "on": "Đã bật đăng nhập hai bước",
      "off": "Chưa bật đăng nhập hai bước",
      "recoveryLeft_one": "Còn {{count}} mã khôi phục",
      "recoveryLeft_other": "Còn {{count}} mã khôi phục",
      "done": "Đã bật đăng nhập hai bước.",
      "recoveryHint": "Hãy cất các mã khôi phục này ở nơi an toàn. Mỗi mã đăng nhập được một lần khi bạn mất điện thoại. Các mã sẽ không hiện lại.",
      "saved": "Tôi đã lưu",
      "setUp": "Thiết lập ứng dụng xác thực",
      "step1": "Trong ứng dụng xác thực (Microsoft Authenticator, Google Authenticator...), thêm tài khoản bằng khóa này, hoặc mở liên kết trên điện thoại.",
      "key": "Khóa",
      "openApp": "Mở trong ứng dụng xác thực",
      "step2": "Mã 6 chữ số ứng dụng đang hiển thị",
      "confirm": "Bật",
      "turnOff": "Tắt đăng nhập hai bước",
      "turnOffConfirm": "Tắt đăng nhập hai bước?",
      "turnOffBody": "Ứng dụng xác thực và mã khôi phục sẽ không dùng được nữa. Các quyền về dữ liệu cá nhân, tiền và quyền truy cập sẽ ngừng hoạt động cho đến khi bạn thiết lập lại.",
      "signInAgain": "Phiên này đăng nhập không có mã. Hãy đăng nhập lại kèm mã để dùng mọi quyền, hoặc để tắt.",
      "needed": "Một số quyền của bạn cần đăng nhập hai bước",
      "neededHint": "Thiết lập ứng dụng xác thực từ menu tài khoản, rồi đăng nhập lại."
    },
    "sso": {
      "title": "Đăng nhập",
      "hint": "Nhân viên đăng nhập bằng nhà cung cấp danh tính của công ty (OpenID Connect: Microsoft Entra ID, Google Workspace, Okta...). Vai trò vẫn được thiết lập ở đây. Khi bật, mật khẩu chỉ dùng được cho tài khoản khẩn cấp.",
      "enabled": "Đăng nhập bằng nhà cung cấp của công ty",
      "displayName": "Tên nút",
      "displayNameHint": "Hiển thị trên màn hình đăng nhập, ví dụ Microsoft.",
      "authority": "Địa chỉ nhà cung cấp (issuer)",
      "authorityHint": "Bắt đầu bằng https://, ví dụ https://login.microsoftonline.com/<tenant id>/v2.0",
      "clientId": "Client id",
      "clientSecret": "Client secret",
      "secretSet": "Đã có secret. Nhập secret mới để thay.",
      "secretNotSet": "Chưa có secret.",
      "mfaValues": "Giá trị cho biết nhà cung cấp đã yêu cầu xác thực hai bước",
      "mfaValuesHint": "Giá trị amr hoặc acr, cách nhau bằng dấu phẩy. Thường là mfa.",
      "emailDomains": "Tên miền email",
      "emailDomainsHint": "Lần đăng nhập đầu chỉ gắn nhân viên theo email thuộc các tên miền này, cách nhau bằng dấu phẩy. Để trống: mọi email đã xác minh.",
      "callback": "Địa chỉ chuyển hướng cần đăng ký ở nhà cung cấp",
      "test": "Kiểm tra nhà cung cấp",
      "testOk": "Nhà cung cấp đã phản hồi: {{issuer}}",
      "testFailed": "Không kết nối được nhà cung cấp ở địa chỉ này.",
      "saved": "Đã lưu."
    },
    "staff": {
      "tab": "Đăng nhập",
      "linked": "Đã gắn với nhà cung cấp của công ty",
      "notLinked": "Chưa gắn với nhà cung cấp",
      "breakGlass": "Tài khoản khẩn cấp",
      "breakGlassHint": "Đăng nhập bằng mã nhân viên, mật khẩu và mã xác thực kể cả khi đã bật nhà cung cấp của công ty, phòng khi nhà cung cấp gặp sự cố. Chỉ quản trị viên toàn công ty mới thay đổi được.",
      "reset": "Đặt lại đăng nhập hai bước",
      "unlink": "Bỏ gắn tài khoản nhà cung cấp",
      "resetConfirm": "Đặt lại đăng nhập hai bước?",
      "unlinkConfirm": "Bỏ gắn tài khoản nhà cung cấp?",
      "resetBody": "Ứng dụng xác thực và mã khôi phục của họ sẽ không dùng được nữa. Họ thiết lập ứng dụng mới sau lần đăng nhập tiếp theo.",
      "unlinkBody": "Lần đăng nhập tiếp theo bằng nhà cung cấp sẽ gắn lại họ theo email."
    }
  },
  "customerSecurity": {
    "title": "Bảo mật tài khoản khách hàng",
    "hint": "Những thay đổi nào khách hàng trên website và ứng dụng phải xác nhận bằng mã một lần gửi đến điện thoại. Khách vừa đăng nhập bằng mã sẽ không bị hỏi lại. Thay đổi đến website trong khoảng 15 phút.",
    "codeFor": "Yêu cầu mã khi thay đổi",
    "changes": {
      "password": "Mật khẩu",
      "profile": "Thông tin cá nhân: họ tên, email, ngày sinh, giới tính, quốc tịch, địa chỉ nhà",
      "addresses": "Địa chỉ giao hàng đã lưu"
    },
    "default": "Chưa chọn: cần mã khi đổi mật khẩu và thông tin cá nhân.",
    "saved": "Đã lưu."
  }
}
